{
  "translations": {
    "accessbility.clickSelect": "Cliquer pour sélectionner une note",
    "accessbility.continueButton": "Continuer",
    "accessbility.continueSurvey": "Continuer le sondage",
    "accessbility.goNext": "Cliquez pour aller à la question suivante",
    "accessbility.means": "signifie",
    "accessbility.skipQuestion": "Cliquez pour sauter cette question",
    "accessibility.skipToContent": "Passer directement au contenu",
    "admin.question.nps": "eNPS",
    "anon.convo.click.here": "Entrez votre code ici",
    "anon.convo.enter.code.here": "Saisissez votre code ici",
    "anonymity-dialog.content.anonymized.one": "Cette enquête est administrée par WorkTango, un fournisseur tiers sécurisé. Les résultats peuvent être rapportés en utilisant des informations d'attribut qui sont suivies avec votre réponse à l'enquête. Ces informations sont collectées par le biais de questions posées dans l'enquête et/ou de données fournies par votre organisation (par exemple, le rôle, le lieu, le département, la titularisation). ",
    "anonymity-dialog.content.anonymized.two": "Afin de protéger votre confidentialité, les résultats ne seront rapportés que s'il y a {{threshold}} ou plus de réponses soumises dans n'importe quel groupe d'attributs (ou combinaisons de groupes d'attributs)",
    "anonymity-dialog.content.not-anonymized.one": "Cette enquête n'est pas anonyme.",
    "anonymity-dialog.content.not-anonymized.three": "Nous vous remercions de votre participation.",
    "anonymity-dialog.content.not-anonymized.two": "Vos réponses individuelles seront identifiables et pourront vous être attribuées. Vos commentaires honnêtes sont essentiels pour nous permettre de nous améliorer, et nous apprécions votre volonté de partager vos idées ouvertement.",
    "anonymity-dialog.title": "Comment les réponses seront-elles rapportées ?",
    "anonymous.convo.email.reaction.great.idea": "a reconnu votre commentaire anonyme et pense que c'est une excellente idée!",
    "anonymous.convo.email.reaction.like": "a aimé votre commentaire anonyme.",
    "anonymous.convo.email.reaction.working.on.it": "a réagi à votre commentaire et souhaite vous informer qu’il est en cours de traitement.",
    "button.dismiss": "Rejeter",
    "button.skip": "Sauter",
    "comment.placeholder": "Écrivez votre commentaire ici",
    "comment.title": "Commentaires",
    "copyright": "Copyright {{year}} WorkTango Inc. Tous droits réservés.",
    "courier.anon.convo.click.here": "Voir la conversation",
    "courier.email.anon.convo.employee.have.replied": "un employé a répondu à une conversation anonyme dont vous faites partie. Conformément à la Promesse aux employés de WorkTango, votre réponse est confidentielle.",
    "courier.email.privacy.policy": "Politique de confidentialité",
    "courier.email.support": "Assistance",
    "courier.email.you.received.email.because": "Vous avez reçu ce courriel en tant qu'utilisateur de WorkTango.",
    "courier.feedback.details": "Cliquez ici pour avoir plus d’informations.",
    "courier.general.hard.link": "Si le bouton ne fonctionne pas, collez le lien suivant dans votre navigateur:",
    "dismiss": "Annuler",
    "docTitle.kioskList": "WorkTango – Sélectionner un Sondage pour continuer",
    "docTitle.kioskLogin": "Kiosque WorkTango – Écran de connexion",
    "docTitle.surveyName": "Sondage {{name}}",
    "dropdown.ariaLabel": "Sélectionnez une option pour {{question}}",
    "enps.question.greatPlace": "",
    "eric-04-03-new-library-question-q1": "Depuis combien de temps vivez-vous dans votre pays de résidence actuel?",
    "eric-04-03-new-library-question-q2": "Avez-vous besoin de vous absenter pendant les heures de travail habituelles? Sélectionnez toutes les réponses applicables. \na) Pour assumer mes responsabilités d'aidant b) Pour prier \nc) Pour méditer\nd) Pour répondre à un besoin médical \ne) Pour prendre soin de mon bien-être mental f) Pour travailler plutôt lorsque je suis le plus efficace \ng) Il n'y a aucun besoin personnel dont je dois m'occuper pendant les heures de travail \nh) Autre (veuillez préciser dans la case commentaire)\ni) Je préfère ne pas répondre",
    "error.submission": "Une erreur est survenue lors de la soumission de votre réponse :",
    "error.unknow": "Un problème inconnu est survenu. Veuillez rafraîchir votre page et réessayer",
    "feedback.code": "Saisissez le code :",
    "feedback.details": "Cliquez ici et entrez votre code personnel pour en voir davantage.",
    "feedback.email.subject.anon": "Vous avez reçu une réponse à votre avis entièrement anonyme.",
    "feedback.has.replied.to.you": "a répondu à votre commentaire lié au sondage.",
    "feedback.placeholder": "Saisissez votre réponse.",
    "footer.poweredby": "Propulsé par WorkTango",
    "general.click.here": "Cliquez ici",
    "general.greeting": "Salut",
    "general.hard.link": "Si le bouton ne fonctionne pas, collez le lien suivant dans votre navigateur :",
    "graph.notEnough.header": "Pas de données suffisantes",
    "hardcoded - dei - q1": "Vous identifiez-vous ou vous êtes-vous déjà identifié comme transgenre? Transgenre est un terme générique utilisé décrivant les personnes dont l'identité ou l'expression de genre diffère du sexe biologique qui leur a été assigné à la naissance.",
    "hardcoded - dei - q2": "Je suis convaincu que cette organisation prendra les mesures qui s'imposent en cas d'incidents de harcèlement.",
    "hardcoded - dei - q3": "Je suis convaincu que cette organisation prendra les mesures qui s'imposent en cas d'incidents de discrimination.",
    "hardcoded - library question 1 - question text": "Je me sens en sécurité et à l'aise quand je viens au travail.",
    "hardcoded - library question 2 - question text": "L'environnement de cette organisation favorise un équilibre entre travail et vie privée.",
    "kiosk.enterPlaceholder": "Entrer votre {{kiosk_id}}",
    "kiosk.footer": "Copyright {{year}} WorkTango Inc. Tous droits réservés.",
    "kiosk.login.error": "Identifiant de kiosque invalide, veuillez réessayer",
    "kiosk.selectSurvey": "Veuillez choisir un sondage pour continuer :",
    "kiosk.welcome": "Voir les sondages disponibles en entrant votre {{kiosk_id}}",
    "logic.cleanup": "Si vous modifiez la réponse, vous devrez peut-être répondre à nouveau aux questions suivantes.",
    "logic.cleanup.warning": "Avertissement",
    "no.active.surveys.for": "Aucun sondage actif trouvé pour",
    "or": "ou",
    "peopleResponded": "Personnes ont répondu",
    "required": "obligatoire",
    "result.avg": "AVG",
    "result.comments": "Commentaires",
    "result.positive": "Positif",
    "saved": "Enregistré",
    "saving": "Économie",
    "screenReader.option": "Option {{option}}",
    "screenReader.peopleSelected": "{{percent}} pourcentage de personnes ayant sélectionné cette option.",
    "showing.all": "Tous les répondants",
    "survey.anonymity-text.anonymized": "Comment les réponses seront-elles rapportées ?",
    "survey.anonymity-text.details-here": "Détails ici.",
    "survey.anonymity-text.not-anonymized": "Cette enquête n'est pas anonyme.",
    "survey.clickButtonText": "Cliquez ici",
    "survey.confirm": "Cliquez ci-dessous pour soumettre vos réponses",
    "survey.error.title": "Oups, quelque chose s'est mal passé",
    "survey.expired.greeting": "Le sondage est expiré",
    "survey.expired.message": "Il n’est plus possible de répondre à ce sondage.",
    "survey.kiosk.copyright": "© {{year}} Tous droits réservés",
    "survey.kiosk.login.button": "Enquête ouverte",
    "survey.kiosk.poweredby": "Alimenté par",
    "survey.language.sr-rs": "Srpski",
    "survey.linkNotWorking": "Si le lien ci-dessus ne fonctionne pas, copiez et collez le lien suivant dans votre navigateur :",
    "survey.navigation.next": "Prochain(e)",
    "survey.navigation.position": "{{questionIndex}} de {{questionCount}}",
    "survey.navigation.previous": "Précédent(e)",
    "survey.navigation.progress": "{{questionIndex}} ou {{questionCount}} réponses",
    "survey.navigation.screen-reader-label": "Numéro de question {{questionIndex}} de {{questionCount}}",
    "survey.navigation.screen-reader-message": "Ceci est un message",
    "survey.not-applicable.message": "Ce sondage s’adresse à un groupe précis, et il semble que vous n’en fassiez pas partie pour le moment. Vous n’avez rien d’autre à faire. Merci d’avoir pris un moment pour vérifier.",
    "survey.not-applicable.title": "Aucune question pour vous cette fois-ci",
    "survey.not-found.message": "Veuillez contacter la personne qui vous a fourni ce lien d'enquête pour plus d'informations.",
    "survey.not-found.title": "Désolé, ce lien n'est pas valide.",
    "survey.open-survey.error-invalid-submission": "Un problème est survenu lors de l’envoi de votre réponse. Veuillez actualiser la page et réessayer.",
    "survey.open-survey.error-not-available": "Ce sondage n’est pas disponible.",
    "survey.open-survey.error-not-in-progress": "Ce sondage n’accepte pas de réponses pour le moment.",
    "survey.open-survey.error-response-limit-reached": "Ce sondage n’accepte plus de réponses ce mois-ci.",
    "survey.open-survey.error-too-soon": "Votre réponse a déjà été reçue. Si vous souhaitez la soumettre de nouveau, veuillez patienter quelques minutes et réessayer.",
    "survey.open-survey.loading": "Chargement du sondage...",
    "survey.open-survey.passcode-heading": "Entrez votre code d’accès au sondage",
    "survey.open-survey.passcode-incorrect": "Ce code d’accès est incorrect. Vérifiez-le et réessayez.",
    "survey.open-survey.passcode-label": "Entrez votre code d’accès",
    "survey.return": "Retour au sondage",
    "survey.schedule.messaging.preset.slack.1.body": "",
    "survey.schedule.messaging.preset.sms.1.body": "{{companyName}} accorde une grande importance à votre avis. Merci de prendre quelques instants pour répondre à ce sondage. Vos commentaires sont personnels ; veuillez donc ne pas partager ce lien.\n\n{{surveyUrl}}\n\nDes frais de SMS et de données peuvent s'appliquer. Répondez STOP pour vous désabonner.",
    "survey.schedule.messaging.preset.sms.10.body": "{{companyName}} vous invite à répondre à une enquête destinée aux salariés. Ce lien vous est personnellement destiné. Veuillez ne pas le partager.\n\n{{surveyUrl}}\n\nDes frais de SMS et de données peuvent s'appliquer. Répondez STOP pour vous désabonner.",
    "survey.schedule.messaging.preset.sms.2.body": "{{companyName}} : Votre avis compte. Répondez ici à notre enquête confidentielle destinée aux salariés (ce lien vous est propre, merci de ne pas le partager) :\n\n{{surveyUrl}}\n\nDes frais de SMS et de données peuvent s'appliquer. Répondez STOP pour vous désabonner.",
    "survey.schedule.messaging.preset.sms.3.body": "{{companyName}} mène actuellement son enquête auprès de ses collaborateurs. Votre participation est sollicitée et appréciée.\nVotre lien est unique, merci de ne pas le transmettre à d'autres personnes.\n\n{{surveyUrl}}\n\nDes frais de SMS et de données peuvent s'appliquer. Répondez STOP pour vous désabonner.",
    "survey.schedule.messaging.preset.sms.4.body": "Bonjour ! {{companyName}} souhaite connaître votre avis. Vos commentaires sincères nous aident à créer un environnement de travail plus agréable pour tous.\nCe lien vous est exclusivement réservé, merci de ne pas le divulguer.\n\n{{surveyUrl}}\n\nDes frais de SMS et de données peuvent s'appliquer. Répondez STOP pour vous désabonner.",
    "survey.schedule.messaging.preset.sms.5.body": "Sondage {{companyName}}, cela ne prend que 2 minutes. Votre lien (à ne pas partager) :\n\n{{surveyUrl}}\n\nDes frais de SMS et de données peuvent s'appliquer. Répondez STOP pour vous désabonner.",
    "survey.schedule.messaging.preset.sms.6.body": "{{companyName}} a besoin de votre avis, cela ne vous prendra que quelques minutes. Votre avis nous aide à façonner l'avenir.\nCliquez sur le lien pour commencer. Ce lien vous est propre, ne le partagez pas.\n\n{{surveyUrl}}\n\nDes frais de SMS et de données peuvent s'appliquer. Répondez STOP pour vous désabonner.",
    "survey.schedule.messaging.preset.sms.7.body": "Chez {{companyName}}, nous grandissons ensemble. Cela signifie que nous sommes à l'écoute de chacun, y compris de vous.\nMerci de bien vouloir répondre à ce bref questionnaire. Ce lien vous est exclusivement réservé.\n\n{{surveyUrl}}\n\nDes frais de SMS et de données peuvent s'appliquer. Répondez STOP pour vous désabonner.",
    "survey.schedule.messaging.preset.sms.8.body": "Merci pour tout ce que vous apportez à {{companyName}}. Nous aimerions savoir comment vous allez ! Ce petit sondage est l'occasion pour vous de nous faire part de votre avis en toute franchise.\nVotre lien est unique, merci de ne pas le partager.\n\n{{surveyUrl}}\n\nDes frais de SMS et de données peuvent s'appliquer. Répondez STOP pour vous désabonner.",
    "survey.schedule.messaging.preset.sms.9.body": "Salut toute l'équipe ! {{companyName}} aimerait connaître votre avis. Cela ne vous prendra que quelques minutes. Voici le lien vers votre sondage (unique à chacun d'entre vous, merci de ne pas le partager) :\n\n{{surveyUrl}}\n\nDes frais de SMS et de données peuvent s'appliquer. Répondez STOP pour vous désabonner.",
    "survey.submit": "Soumettre",
    "survey.thanks.greeting": "Merci!",
    "survey.thanks.message": "Vos réponses ont été soumises avec succès.",
    "survey.timeout-warning": "Vous serez automatiquement déconnecté dans {{timeout}} secondes si aucune interaction utilisateur n'est détectée.",
    "survey.tryagain": "Réessayer",
    "survey.type.attributebased": "Basé sur les attributs",
    "surveyEmail.defaultContent": "<p>Nous ne nous amélioreront en tant qu'organisation qu'en écoutant la voix de nos employés. </p><br /><p>Veuillez compléter le sondage en cliquant sur le lien ci-dessous et faites-nous part de vos sincères commentaires. Vos commentaires sont toujours anonymes.</p>",
    "surveyEmail.defaultTitle": "Nous avons besoin de votre rétroaction",
    "swal.button.ok": "OK",
    "swal.confirm.cancel": "Annuler",
    "swal.confirm.yes": "Oui",
    "swal.timeout.header": "Vous êtes toujours là?",
    "tableview.outof": "Sur",
    "text.ariaLabel": "Entrez votre commentaire pour {{question}}",
    "user.notice": "l’avis de confidentialité",
    "user.policy": "la politique de confidentialité",
    "user.terms": "les conditions d’utilisation",
    "warning.anonymous": "Cet entretien est tout à fait anonyme",
    "404.description": "La page que vous recherchez est introuvable.",
    "404.title": "On dirait qu'il y a un problème.",
    "ANONYMOUS_CONVERSATIONS": "Entretiens anonymes",
    "Action": "Action",
    "Africa/Cairo": "({{timezoneOffset}}) Le Caire",
    "Africa/Harare": "({{timezoneOffset}}) Harare, Pretoria",
    "Africa/Lagos": "({{timezoneOffset}}) Heure d’Afrique occidentale et centrale",
    "Africa/Monrovia": "({{timezoneOffset}}) Casablanca, Monrovia",
    "Africa/Nairobi": "({{timezoneOffset}}) Nairobi",
    "America/Anchorage": "({{timezoneOffset}}) Alaska",
    "America/Argentina/Buenos_Aires": "({{timezoneOffset}}) Buenos Aires, Georgetown",
    "America/Bogota": "({{timezoneOffset}}) Bogota, Lima, Quito",
    "America/Chihuahua": "({{timezoneOffset}}) Chihuahua, La Paz, Mazatlan",
    "America/Costa_Rica": "({{timezoneOffset}}) Amérique centrale",
    "America/Edmonton": "({{timezoneOffset}}) Hheure des Rocheuses (États Unis et Canada)",
    "America/Godthab": "({{timezoneOffset}}) Groenland",
    "America/Halifax": "({{timezoneOffset}}) Heure de l’Atlantique",
    "America/Indiana/Indianapolis": "({{timezoneOffset}}) Indiana",
    "America/La_Paz": "({{timezoneOffset}}) Caracas, La Paz",
    "America/Monterrey": "({{timezoneOffset}}) Guadalajara, Mexico, Monterrey",
    "America/Phoenix": "({{timezoneOffset}}) Arizona",
    "America/Regina": "({{timezoneOffset}}) Saskatchewan",
    "America/Santiago": "({{timezoneOffset}}) Santiago",
    "America/Sao_Paulo": "({{timezoneOffset}}) Brasilia",
    "America/St_Johns": "({{timezoneOffset}}) Terre-Neuve-et-Labrador",
    "America/Toronto": "({{timezoneOffset}}) Heure de l’Est (États Unis et Canada)",
    "America/Vancouver": "({{timezoneOffset}}) Heure du Pacifique (États Unis et Canada); Tijuana",
    "America/Winnipeg": "({{timezoneOffset}}) Hheure du Centre (États Unis et Canada)",
    "Asia/Almaty": "({{timezoneOffset}}) Astana, Dacca",
    "Asia/Baghdad": "({{timezoneOffset}}) Bagdad",
    "Asia/Baku": "({{timezoneOffset}}) Bakou, Tbilissi, Yerevan",
    "Asia/Bangkok": "({{timezoneOffset}}) Bangkok, Hanoï. Jakarta",
    "Asia/Calcutta": "({{timezoneOffset}}) Chennai, Calcutta, Mumbai, New Delhi",
    "Asia/Colombo": "({{timezoneOffset}}) Sri Jayawardenapura Kotte",
    "Asia/Irkutsk": "({{timezoneOffset}}) Irkoutsk, Oulan-Bator",
    "Asia/Jerusalem": "({{timezoneOffset}}) Jérusalem",
    "Asia/Kabul": "({{timezoneOffset}}) Kaboul",
    "Asia/Kathmandu": "({{timezoneOffset}}) Kathmandou",
    "Asia/Krasnoyarsk": "({{timezoneOffset}}) Krasnoïarsk",
    "Asia/Kuwait": "({{timezoneOffset}}) Koweït, Riyad",
    "Asia/Muscat": "({{timezoneOffset}}) Abou Dabi, Mascat",
    "Asia/Novosibirsk": "({{timezoneOffset}}) Almaty, Novossibirsk",
    "Asia/Rangoon": "({{timezoneOffset}}) Yangon Rangoun",
    "Asia/Seoul": "({{timezoneOffset}}) Séoul",
    "Asia/Shanghai": "({{timezoneOffset}}) Beijing, Chongqing, Région administrative spéciale de Hong Kong, Ürümqi",
    "Asia/Singapore": "({{timezoneOffset}}) Kuala Lumpur, Singapour",
    "Asia/Taipei": "({{timezoneOffset}}) Taipei",
    "Asia/Tashkent": "({{timezoneOffset}}) Islamabad, Karachi, Tachkent",
    "Asia/Tehran": "({{timezoneOffset}}) Téhéran",
    "Asia/Tokyo": "({{timezoneOffset}}) Osaka, Sapporo, Tokyo",
    "Asia/Vladivostok": "({{timezoneOffset}}) Vladivostok",
    "Asia/Yakutsk": "({{timezoneOffset}}) Iakoutsk",
    "Asia/Yekaterinburg": "({{timezoneOffset}}) Ekaterinbourg",
    "Atlantic/Azores": "({{timezoneOffset}}) Açores",
    "Atlantic/Cape_Verde": "({{timezoneOffset}}) Îles de Cap-Vert",
    "Atlantic/South_Georgia": "({{timezoneOffset}}) Moyen-Atlantique",
    "Australia/Adelaide": "({{timezoneOffset}}) Adélaïde",
    "Australia/Brisbane": "({{timezoneOffset}}) Brisbane",
    "Australia/Darwin": "({{timezoneOffset}}) Darwin",
    "Australia/Hobart": "({{timezoneOffset}}) Hobart",
    "Australia/Perth": "({{timezoneOffset}}) Perth",
    "Australia/Sydney": "({{timezoneOffset}}) Canberra, Melbourne, Sydney",
    "Europe/Belgrade": "({{timezoneOffset}}) Sarajevo, Skopje, Varsovie, Zagreb",
    "Europe/Berlin": "({{timezoneOffset}}) Amsterdam, Berlin, Berne, Rome, Stockholm, Vienne",
    "Europe/Istanbul": "({{timezoneOffset}}) Bucarest",
    "Europe/London": "({{timezoneOffset}}) Temps moyen de Greenwich : Dublin, Édimbourg, Lisbonne, Londres",
    "Europe/Minsk": "({{timezoneOffset}}) Athènes, Istanbul, Minsk",
    "Europe/Moscow": "({{timezoneOffset}}) Moscou, Saint-Pétersbourg, Volgograd",
    "Europe/Paris": "({{timezoneOffset}}) Bruxelles, Copenhague, Madrid, Paris",
    "Europe/Riga": "({{timezoneOffset}}) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
    "Learning": "Apprentissage",
    "MANAGE_SURVEYS": "Gérer les sondages",
    "Pacific/Apia": "({{timezoneOffset}}) Îles Midway, Samoa",
    "Pacific/Auckland": "({{timezoneOffset}}) Auckland, Wellington",
    "Pacific/Fiji": "({{timezoneOffset}}) Îles Fidji, Kamtchatka, Îles Marshall",
    "Pacific/Guadalcanal": "({{timezoneOffset}}) Magadan, Îles Salomon, Nouvelle-Calédonie",
    "Pacific/Guam": "({{timezoneOffset}}) Guam, Port Moresby",
    "Pacific/Honolulu": "({{timezoneOffset}}) Hawaï",
    "Pacific/Kiritimati": "({{timezoneOffset}}) Ligne de changement de date",
    "Pacific/Tongatapu": "({{timezoneOffset}}) Nuku’alofa",
    "Survey.duplicateName": "Nom du sondage :",
    "VIEW_OPEN_ENDED_COMMENTS": "Afficher les commentaires formulés dans le cadre de réponses ouvertes",
    "VIEW_REPORTING": "Afficher les rapports",
    "access.all": "Tous les employés",
    "access.attribute": "Attributs personnalisés",
    "access.hierarchy": "Leur hiérarchie",
    "access.otherHierarchy": "Autres hiérarchies",
    "account.email": "Adresse courriel",
    "account.password": "Mot de passe",
    "action": "Action",
    "action.added": "Action ajoutée",
    "action.added.description": "« {{title}} » a été ajouté avec succès!",
    "action.created.assigned.message": "%actionOwnerName% vient de vous attribuer l’action « %actionTitle% » sur WorkTango.",
    "action.created.button.message": "Voyez votre action",
    "action.created.link.message": "Si le lien ci-dessus ne fonctionne pas, copiez et collez le lien suivant dans votre navigateur : %baseUrl%/action-planning/actions/%actionId%",
    "action.created.sending.greetings": "Salut",
    "action.created.sending.subject": "On vous a attribué une nouvelle action sur WorkTango",
    "action.updated.button.message": "Visualiser l’action",
    "action.updated.changes.message": "%actionOwnerName% a apporté un ou plusieurs changements à votre action « %actionTitle%».",
    "action.updated.changes.warning": " Veuillez noter que vous pourriez ne pas être en mesure de voir l’action si vous n’êtes plus le cessionnaire de l’action.",
    "action.updated.fields.categoryIds": "Catégories",
    "action.updated.fields.description": "Description",
    "action.updated.fields.dueAt": "Dû le",
    "action.updated.fields.isComplete": "Est terminé",
    "action.updated.fields.languageId": "Langue",
    "action.updated.fields.libraryActionId": "Action de la bibliothèque",
    "action.updated.fields.status": "Statut",
    "action.updated.fields.surveyIds": "Enquêtes",
    "action.updated.fields.title": "Titre",
    "action.updated.fields.userIds": "Cessionnaires",
    "action.updated.link.message": "Si le lien ci-dessus ne fonctionne pas, copiez et collez le lien suivant dans votre navigateur : %baseUrl%/action-planning/actions/%actionId%",
    "action.updated.sending.greetings": "Salut",
    "action.updated.sending.subject": "L’une de vos tâches a été mise à jour dans WorkTango",
    "actions": "Actions",
    "actions.additional": "Autorisations de rapport supplémentaires",
    "active": "Actif",
    "add.action": "Ajouter une action",
    "add.factor": "Ajouter un facteur",
    "addCompanyDialog.errors.duplicateName": "Ce nom existe déjà; veuillez choisir un nom unique",
    "addCompanyDialog.errors.invalidSalesforceId": "Un identifiant Salesforce valide devrait comporter entre 15 et 18 caractères",
    "addCompanyDialog.name.label": "Nom de l'entreprise",
    "addCompanyDialog.salesforce.helperText": "",
    "addCompanyDialog.salesforce.label": "Identifiant Salesforce",
    "addCompanyDialog.testDemo.label": "Il s'agit d'une entreprise de test/démonstration",
    "addCompanyDialog.title": "Créer une nouvelle entreprise",
    "addQuestion": "Ajouter une question",
    "admin.ai-prompts.header": "Invites IA",
    "admin.ai-prompts.sub-title": "Ces invites servent à générer des résumés de questions, des analyses, des thèmes essentiels et des sentiments pour tous les sondages de la plateforme. Veuillez faire preuve de prudence lorsque vous les mettez à jour, car elles affectent tous les clients.",
    "admin.ai-prompts.title": "Invites IA génératives",
    "admin.allowFrench": "Activer la version française",
    "admin.appPermissions": "Autorisations d'application",
    "admin.benchmarks.associate-attribute": "Associer l'attribut",
    "admin.benchmarks.associate-attributes": "Associer des attributs",
    "admin.benchmarks.associate.filter": "Filtrer par nom d'entreprise",
    "admin.benchmarks.associate.subtitle": "Associer les attributs de l'employé à l'attribut de référence",
    "admin.benchmarks.benchmark-attributes": "Attributs de référence",
    "admin.benchmarks.button.go-association": "Aller à l'association des attributs de",
    "admin.benchmarks.button.go-mapping": "Aller au mappage des valeurs d'attributs de",
    "admin.benchmarks.button.map-selected-to": "Mapper l'élément sélectionné à",
    "admin.benchmarks.button.map-to": "Mapper à",
    "admin.benchmarks.button.return-attributes": "Retourner les attributs de référence",
    "admin.benchmarks.check-new-values": "Rechercher de nouvelles valeurs",
    "admin.benchmarks.default-benchmark-value": "Valeur d'attribut de référence par défaut",
    "admin.benchmarks.default-value": "Valeur par défaut",
    "admin.benchmarks.header": "Références",
    "admin.benchmarks.last-refreshed": "Dernière actualisation",
    "admin.benchmarks.map-values": "Mapper les valeurs",
    "admin.benchmarks.number-of-values": "N° de valeurs",
    "admin.benchmarks.sample-values": "Exemples de valeurs",
    "admin.benchmarks.value-mapping.alert": "Vous avez sélectionné des valeurs dont le mappage n'est pas encore terminé",
    "admin.benchmarks.value-mapping.filter": "Filtrer par valeur",
    "admin.benchmarks.value-mapping.subtitle": "Mapper les valeurs des attributs des employés avec celles des attributs de référence.",
    "admin.bulk.generate": "Créer un fichier type",
    "admin.bulk.sampleFile": "exemple de fichier",
    "admin.bulk.selectFile": "Sélectionner un fichier CSV/Excel",
    "admin.company.colour2": "Barre de navigation supérieure",
    "admin.company.cprofile": "Logo de l'entreprise",
    "admin.company.delete.alert": "Toutes les données associées à l’entreprise {{companyName}} seront SUPPRIMÉES et vous ne pouvez PAS revenir en arrière!",
    "admin.company.delete.confirmation": "Veuillez entrer le courriel associé à votre compte pour confirmer la suppression",
    "admin.company.industry": "Sélectionner le secteur d’activité",
    "admin.company.manageCompany": "Entreprises",
    "admin.company.name": "Nom de l’entreprise",
    "admin.company.public": "Public",
    "admin.company.region": "Sélectionner la région",
    "admin.company.saved": "Enregistré!",
    "admin.company.sector": "Secteur",
    "admin.companyData.header": "Configuration",
    "admin.companyData.kiosk": "Kiosque",
    "admin.companyData.learning.coach": "Coach en apprentissage",
    "admin.companyData.learning.coach.notifications.enabled": "Notifications activées",
    "admin.editPermissions": "Modifier les autorisations",
    "admin.egroup.noemployees": "Vous n’avez pas sélectionné un employé",
    "admin.email.languagesNote": "Remarque: toutes les langues activées sont requises",
    "admin.employee.addTagline": "Ajouter un nouvel employé",
    "admin.employee.customcategory": "Créer un facteur",
    "admin.employee.disableAll": "Désactiver",
    "admin.employee.edit.custom.category": "Modifier un facteur",
    "admin.employee.enableAll": "Activer",
    "admin.employee.status": "Statut",
    "admin.employee.tagline": "Actualiser les détails de l’employé",
    "admin.employees.header": "Employés",
    "admin.employees.tabs.employeeList": "Liste des employés",
    "admin.employees.tabs.importHistory": "Historique des importations",
    "admin.enable.sso": "Activer SSO",
    "admin.fields.enName": "Nom du champ (En)",
    "admin.fields.frName": "Nom du champ (Fr)",
    "admin.fields.header": "Créer un champ",
    "admin.fields.isPrivateAttribute": "Dissimulé dans la plateforme",
    "admin.fields.isReportingAttribute": "Attribut principal",
    "admin.fields.name": "Nom du champ",
    "admin.fields.required": "Requis",
    "admin.fields.systemHeader": "Champ de système",
    "admin.fields.type": "Type",
    "admin.fields.unique": "Unique",
    "admin.fields.update": "Champ de mise à jour",
    "admin.kiosk.field": "Champ de kiosque",
    "admin.kiosk.url": "Les employés peuvent accéder à la fonction du kiosque à l’aide de l’adresse URL suivante :",
    "admin.library.header": "Bibliothèque de questions",
    "admin.managePermissions": "Gérer les autorisations",
    "admin.notify.completion.button": "Voir mon aperçu d’enquête",
    "admin.notify.completion.closed": "est fermé.",
    "admin.notify.completion.overview": "Votre aperçu de l’enquête est maintenant prêt pour vous sur WorkTango",
    "admin.notify.expired.click": "Cliquer",
    "admin.notify.expired.extend": "Si vous voulez prolonger la période du sondage, modifiez simplement la date d’expiration dans les réglages de votre sondage.",
    "admin.notify.expired.see.results": "pour consulter vos résultats",
    "admin.notify.expired.submitted": "des personnes ont soumis le sondage",
    "admin.notify.expired.warn": "est maintenant expiré",
    "admin.notify.reminder.opening": "Votre sondage",
    "admin.notify.reminder.scheduled": "doit être envoyé dans",
    "admin.notify.reminder.subject": "Rappel : le sondage WorkTango est sur le point d’être envoyé",
    "admin.notify.sending.completed.happy.response.rate": "Nous vous souhaitons un taux de participation de 100 % :)",
    "admin.notify.sending.completed.senttox": "Votre sondage Pulse intitulé %surveyname% a été envoyé à %sendto% personnes.",
    "admin.notify.sending.completed.subject": "Le sondage %surveyname% a bien été envoyé.",
    "admin.notify.sending.greetings": "Votre sondage intitulé",
    "admin.notify.sending.notify.when.complete": "Nous vous enverrons un courriel lorsque le processus sera terminé.",
    "admin.notify.sending.status": "est en cours de traitement et sera envoyé",
    "admin.notify.sending.subject": "Le sondage %surveyname% est en cours d’envoi.",
    "admin.notify.sending.thanks": "Merci,",
    "admin.notify.sending.time": "au cours du/des prochain(e)s",
    "admin.permission.createSuccessMsg": "Vous avez invité avec succès {{num}} nouveaux utilisateurs.",
    "admin.permission.self": "Vous-même",
    "admin.permission.updateSuccessMsg": "Autorisation mise à jour.",
    "admin.permission.userEmailsTitle": "Saisir les courriels des utilisateurs séparés par des virgules",
    "admin.previous.header": "Questions déjà posées",
    "admin.question.addlabels": "Ajouter des étiquettes",
    "admin.question.allowMultiple": "Autoriser la sélection multiple",
    "admin.question.category": "Facteur",
    "admin.question.commentsRequired": "Permettre des commentaires",
    "admin.question.description": "Ajoutez une description",
    "admin.question.emailContent": "Contenu du courriel",
    "admin.question.emailSubject": "Objet du courriel",
    "admin.question.fixed": "Icône",
    "admin.question.fromEmailName": "Nom de l’expéditeur",
    "admin.question.hideReporting": "Masquer du rapport",
    "admin.question.labelAfter": "Saisir le contenu de l’étiquette de droite ici",
    "admin.question.labelBefore": "Saisir le contenu de l’étiquette de gauche ici",
    "admin.question.languagesNote": "Remarque: Toutes les langues sont requises.",
    "admin.question.library": "Bibliothèque de questions",
    "admin.question.multiple": "Choix multiples",
    "admin.question.name": "Question",
    "admin.question.newmessage": "Nouveau message",
    "admin.question.numratings": "Échelle",
    "admin.question.open": "Texte",
    "admin.question.openSurveyAttribute": "",
    "admin.question.openSurveyAttribute.loadError": "",
    "admin.question.openSurveyAttribute.name": "",
    "admin.question.openSurveyAttribute.noSourceAttribute": "",
    "admin.question.openSurveyAttribute.sourceAttribute": "",
    "admin.question.openSurveyAttribute.sourceAttributePlaceholder": "",
    "admin.question.options": "Choix de réponses",
    "admin.question.optionsAllowed": "Options autorisées",
    "admin.question.optionsEditor.actions": "Actions",
    "admin.question.optionsEditor.addOption": "Ajouter une option",
    "admin.question.optionsEditor.importAttributeLabel": "Attribut d’employé à partir duquel importer les options",
    "admin.question.optionsEditor.importAttributePlaceholder": "Choisir un attribut",
    "admin.question.optionsEditor.importButton": "Importer",
    "admin.question.optionsEditor.importButtonCount": "",
    "admin.question.optionsEditor.importButtonCount_other": "",
    "admin.question.optionsEditor.importDescription": "Les valeurs des attributs importées sont triées par ordre alphabétique et ajoutées à la liste des options existantes.",
    "admin.question.optionsEditor.importEmpty": "Cet attribut ne contient aucune nouvelle valeur à importer.",
    "admin.question.optionsEditor.importError": "Les valeurs de l’attribut n’ont pas pu être chargées. Veuillez réessayer.",
    "admin.question.optionsEditor.importFromAttribute": "Importer des options à partir d’un attribut...",
    "admin.question.optionsEditor.importLoaded": "",
    "admin.question.optionsEditor.importLoaded_other": "",
    "admin.question.optionsEditor.importLoading": "",
    "admin.question.optionsEditor.importTitle": "Importer des options à partir d’un attribut",
    "admin.question.optionsEditor.removeAll": "Supprimer toutes les options",
    "admin.question.optionsEditor.removeAllConfirm": "",
    "admin.question.optionsEditor.removeAllMessage": "",
    "admin.question.optionsEditor.removeAllTitle": "",
    "admin.question.previous": "Questions déjà posées (pour la tendance).",
    "admin.question.reportingFilter": "",
    "admin.question.reportingFilter.attribute": "",
    "admin.question.reportingFilter.attributePlaceholder": "",
    "admin.question.reportingFilter.loadError": "",
    "admin.question.reportingFilter.none": "",
    "admin.question.reportingFilter.questionLabel": "",
    "admin.question.reportingFilter.useAsAttributeFilter": "",
    "admin.question.reportingFilter.useAsQuestionFilter": "",
    "admin.question.required": "Requis",
    "admin.question.select": "Liste déroulante",
    "admin.question.shapetype": "Type d’icône",
    "admin.question.showSkipButton": "Afficher le bouton Sauter",
    "admin.question.sliding": "Classement",
    "admin.question.subject": "Sujet",
    "admin.question.yes_no": "Oui/Non",
    "admin.reminders.tagline": "Ceci envolera un courriel à tous les employés qui n’ont pas encore rempli le sondage.",
    "admin.resendInvites": "Renvoyer les invitations",
    "admin.selectedUsers": "Utilisateurs sélectionnés",
    "admin.setAllPermissions": "Définissez toutes les autorisations sur les paramètres actuels d'un utilisateur spécifique en cliquant sur son nom.",
    "admin.step4.recipients.header": "Choisissez les destinataires de l'enquête",
    "admin.step4.schedule.header": "Planifier",
    "admin.survey-template.activate": "Modèle actif",
    "admin.survey-template.build.empty-questions.description": "Pour commencer, ajoutez une question à ce sondage à partir de la bibliothèque.",
    "admin.survey-template.build.empty-questions.title": "Ajoutez votre première question!",
    "admin.survey-template.build.question-library.addQuestionsButton": "Ajouter les questions sélectionnées et retourner à l'éditeur",
    "admin.survey-template.build.question-library.cancelButton": "Annuler et retourner à l'éditeur",
    "admin.survey-template.build.question-library.searchQuestion": "Recherche d'une question...",
    "admin.survey-template.build.question-library.selectFactor": "Sélectionner un facteur",
    "admin.survey-template.build.survey-questions.add-button": "Ajouter des questions de la bibliothèque",
    "admin.survey-template.build.survey-questions.description": "Aucune question n'est configurée pour ce sondage.",
    "admin.survey-template.build.survey-questions.remove-button": "Supprimer",
    "admin.survey-template.build.survey-questions.title": "Questions du sondage",
    "admin.survey-template.build.title": "Constructeur de sondage",
    "admin.survey-template.config.style.helper-text": "Les sondages créés à partir de ce modèle utilisent ce style. Il ne peut pas être modifié une fois qu’un sondage est créé.",
    "admin.survey-template.config.title": "Configuration du sondage",
    "admin.survey-template.error-message.unique-name": "Le nom du modèle de sondage n'est pas valide : Un modèle de sondage portant le même nom et dans la même langue existe déjà.",
    "admin.survey-template.new-template-title": "Nouveau modèle de sondage",
    "admin.survey-template.share.note": "Remarque : Toutes les langues activées sont obligatoires",
    "admin.survey-template.share.title": "Courriel d'invitation à un sondage",
    "admin.survey-template.title-details": "Détails de votre sondage",
    "admin.survey-template.unsaved-changes": "Vous avez des modifications non enregistrées sur cette page.",
    "admin.survey.addTagline": "Créer un nouveau sondage",
    "admin.survey.allSurveyStatus": "Tous les statuts de l'enquête",
    "admin.survey.allSurveyStyles": "Tous les styles d'enquête",
    "admin.survey.allSurveyTypes": "Tous les types de sondage",
    "admin.survey.anonMessage": "Les dirigeants seront capables de répondre aux commentaires des employés",
    "admin.survey.anons": "Autoriser les conversations anonymes",
    "admin.survey.audience-mode": "Public cible",
    "admin.survey.audience-mode.helper-text": "Veuillez noter : ce paramètre ne peut pas être modifié",
    "admin.survey.audience-mode.individual.description": "Invitez des employés précis. Chaque participant reçoit son propre lien et peut répondre une seule fois.",
    "admin.survey.audience-mode.individual.title": "Lien individuel",
    "admin.survey.audience-mode.shared.description": "Publiez un lien unique que tout le monde peut ouvrir. Les réponses sont anonymes et le nombre de réponses pouvant être soumises est illimité.",
    "admin.survey.audience-mode.shared.title": "Lien partagé",
    "admin.survey.build.add-recipient.alert.inprogress": "Après confirmation, un courriel sera envoyé à {{count}} employé(s) sous peu.",
    "admin.survey.build.add-recipient.alert.scheduled": "Après confirmation, le ou les nouveaux destinataires seront ajoutés à ce sondage.",
    "admin.survey.build.add-recipient.title": "Ajouter {{count}} nouveau(x) destinataire(s)?",
    "admin.survey.build.add-recipient.title_other": "",
    "admin.survey.build.add-remove.alert.inprogress": "Après confirmation, un courriel sera envoyé à {{addCount}} employé(s) sous peu, les liens vers le sondage de {{removeCount}} destinataire(s) ne seront plus valides et les résultats seront retirés du sondage.",
    "admin.survey.build.add-remove.alert.scheduled": "Après confirmation, le ou les destinataires seront ajoutés ou retirés",
    "admin.survey.build.add-remove.title": "Ajouter {{addCount}} nouveau(x) destinataire(s) et retirer {{removeCount}} destinataire(s)?",
    "admin.survey.build.archived_invitation": "Il s'agit d'une invitation archivée qui a été créée automatiquement lorsque cet employé a été réembauché. Elle constitue une représentation précise du taux de participation et un lien vers les réponses à l'enquête, si la personne les a envoyées.",
    "admin.survey.build.automate.activate.success": "L'enquête en continu est passée avec succès au statut de \"en cours\"",
    "admin.survey.build.automate.deactivate.success": "L'enquête continue est passée avec succès à l'étape Terminée",
    "admin.survey.build.automate.save.changes.close": "Enregistrer les modifications et fermer",
    "admin.survey.build.automate.title": "Automatisation des enquêtes",
    "admin.survey.build.candidates": "Candidats à l'enquête",
    "admin.survey.build.candidates.description": "Le système a identifié les salariés suivants, qui ont été invités à répondre à l'enquête à la date prévue.",
    "admin.survey.build.candidates.empty": "Il n'y a pas de candidats en attente d'invitation pour cette enquête. Les déclencheurs d'automatisation traiteront les invitations en fonction de la date de début ou de fin.",
    "admin.survey.build.candidates.outbox-button": "Mise à jour des candidats dans la boîte d'envoi",
    "admin.survey.build.candidates.search": "Filtrer par nom",
    "admin.survey.build.disable-emails.alert.description": "Ce sondage n'enverra pas d'invitations ni de rappels par courriel aux participants. Veillez à configurer l'accès au kiosque où les employés peuvent soumettre leurs réponses.",
    "admin.survey.build.disable-emails.alert.title": "Envoi des courriels désactivé",
    "admin.survey.build.disable-emails.dialog.confirm": "Désactiver l'envoi du courriel",
    "admin.survey.build.disable-emails.dialog.description1": "La désactivation de l'envoi de courriels signifie que les participants ne seront pas invités à participer à ce sondage ou qu'ils ne recevront pas de rappel les invitant à répondre au sondage s'ils ne l'ont pas encore fait.",
    "admin.survey.build.disable-emails.dialog.description2": "Le seul moyen pour les employés d'accéder à ce sondage est le lien du kiosque; alors, veillez à en créer un.",
    "admin.survey.build.disable-emails.dialog.description3": "Voulez-vous quand même désactiver l'envoi des courriels?",
    "admin.survey.build.disable-emails.dialog.title": "Désactiver l'envoi des courriels pour ce sondage",
    "admin.survey.build.disable-emails.switch": "Activer l'envoi d'invitations par courriel et les rappels aux participants",
    "admin.survey.build.expired": "Le sondage expire le :",
    "admin.survey.build.invitation-expires-at": "Les invitations pour ces employés expirent le :",
    "admin.survey.build.leave.alert": "Des modifications apportées à cette liste de destinataires n’ont pas été enregistrées.",
    "admin.survey.build.leave.dialog.body_1": "Vous avez apporté des modifications aux listes de participants, mais vous ne les avez pas enregistrées.",
    "admin.survey.build.leave.dialog.body_2": "Êtes-vous sûr de vouloir quitter le site sans enregistrer les modifications ?",
    "admin.survey.build.leave.dialog.title": "Mise à jour sur les participants à l'enquête",
    "admin.survey.build.leave.leave_step": "Quitter sans sauvegarder",
    "admin.survey.build.leave.stay_step": "Restez sur cette étape",
    "admin.survey.build.leave.title": "Voulez-vous quitter cette page? Vous avez des modifications non enregistrées.",
    "admin.survey.build.remove-recipient.alert.inprogress": "Après confirmation, des liens vers le sondage pour {{count}} destinataire(s) ne seront plus valides et les résultats seront retirés du sondage.",
    "admin.survey.build.remove-recipient.alert.scheduled": "Après confirmation, {{count}} destinataire(s) seront retirés de ce sondage.",
    "admin.survey.build.remove-recipient.title": "Retirer {{count}} destinataire(s)?",
    "admin.survey.build.save-alert": "La liste des destinataires a été modifiée, cliquez sur \"Enregistrer\" pour sauvegarder vos modifications",
    "admin.survey.build.scheduled": "Le sondage est prévu à partir du :",
    "admin.survey.build.triggers": "Déclencheurs de l'enquête",
    "admin.survey.build.triggers.description": "Les déclencheurs suivants sont configurés pour inviter automatiquement les employés à participer à cette enquête en fonction de leur {{attribut}}",
    "admin.survey.build.triggers.empty": "Aucun déclencheur n'a été configuré pour cette enquête. Cliquez ci-dessous pour configurer le premier.",
    "admin.survey.build.update-alert": "La Liste de destinataires a été modifiée, cliquez sur « Mettre à jour » pour enregistrer vos modifications.",
    "admin.survey.cancelled": "La planification du sondage a été annulée",
    "admin.survey.combineLanguages": "Combiner toutes les langues dans un courriel",
    "admin.survey.combineLanguagesMessage": "Envoie dans un même courriel les invitations dans toutes les langues, quelle que soit la langue de préférence de l’employé.",
    "admin.survey.configure.title": "Configuration de l'enquête",
    "admin.survey.continuous": "En continu",
    "admin.survey.duplicated": "Nom du sondage déjà utilisé par une autre sondage, veuillez choisir un autre nom",
    "admin.survey.emailLanguage": "Langues des courriels",
    "admin.survey.endDate": "Expiration",
    "admin.survey.endTime": "Heure d’expiration",
    "admin.survey.endafterstart": "Veuillez sélectionner une date d’expiration après la date d’envoi planifiée",
    "admin.survey.expired": "Expirera le :",
    "admin.survey.fromEmail": "Envoyer de",
    "admin.survey.fromemailnamecheck": "Il faut inclure le nom de l’expéditeur du courriel",
    "admin.survey.futureStart": "Veuillez sélectionner une date en fonction du fuseau horaire sélectionné",
    "admin.survey.graph.tooltip.total": "Total",
    "admin.survey.languages": "Langue(s)",
    "admin.survey.leave": "Quitter le site? Vos modifications ne seront pas enregistrées.",
    "admin.survey.name": "Nom du questionnaire",
    "admin.survey.name.placeholder": "Saisir le nom de l'enquête",
    "admin.survey.new": "Nouvelle enquête",
    "admin.survey.notification-dialog.description-1": "Le modèle que vous avez choisi pour créer ce sondage comportait des questions faisant référence à des facteurs qui n'étaient pas présents dans votre configuration.",
    "admin.survey.notification-dialog.description-2": "Par conséquent, pour une ou plusieurs questions, vous devrez sélectionner manuellement les facteurs appropriés afin de sauvegarder correctement le sondage.",
    "admin.survey.notification-dialog.title": "Des facteurs sont absents d'une ou plusieurs questions",
    "admin.survey.numquestions": "Nombre de questions :",
    "admin.survey.numrecipients": "Nombre de destinataires :",
    "admin.survey.option": "Option {{num}}",
    "admin.survey.pasteEmail": "Coller des courriels",
    "admin.survey.pasteEmailError": "Le courriel d'employé suivant n'existe pas: {{emails}}",
    "admin.survey.pasteEmailInvalid": "Le courrielsuivant a un format incorrect: {{emails}}",
    "admin.survey.pasteEmailSuccess": "Ajout de {{total}} nouveaux destinataires",
    "admin.survey.preferTimezone": "Fuseau horaire préféré",
    "admin.survey.preview": "Aperçu",
    "admin.survey.scheduled": "Programmé pour :",
    "admin.survey.searchName": "Saisir le nom du sondage",
    "admin.survey.selected": "Choisi",
    "admin.survey.send.test.btn.title": "Envoyez-vous un courriel d’essai",
    "admin.survey.sentDate": "Date envoyée",
    "admin.survey.showResults": "Affiche les résultats du sondage",
    "admin.survey.showResultsMessage": "Montre aux employés les résultats totaux à la fin du sondage",
    "admin.survey.standard": "Standard",
    "admin.survey.startDate": "Date d’entrée",
    "admin.survey.startTime": "Heure d’envoi",
    "admin.survey.step1": "Configurer",
    "admin.survey.step2": "Construire",
    "admin.survey.step4": "Partager",
    "admin.survey.step5": "Automatiser",
    "admin.survey.style": "Style d'enquête",
    "admin.survey.style.continuous.description": "Cette enquête n'expire pas, mais les invitations le font, et les participants ne peuvent répondre qu'une seule fois. Les rapports sont établis sur la base des délais sélectionnés. Idéal pour les enquêtes d'intégration et de sortie.",
    "admin.survey.style.continuous.exit-date.description": "Idéal pour les enquêtes de sortie. Cette enquête n'expire pas, mais les invitations le font, et les participants ne peuvent répondre qu'une seule fois. Les rapports sont établis sur la base des délais sélectionnés.",
    "admin.survey.style.continuous.exit-date.title": "Enquête continue basée sur la date de sortie",
    "admin.survey.style.continuous.start-date.description": "Idéale pour les enquêtes d'intégration. Cette enquête n'expire pas, contrairement aux invitations, et les participants ne peuvent répondre qu'une seule fois. Les rapports sont établis sur la base des délais sélectionnés.",
    "admin.survey.style.continuous.start-date.title": "Enquête continue basée sur la date de début",
    "admin.survey.style.continuous.title": "Enquête continue",
    "admin.survey.style.helper-text": "Remarque : ce paramètre ne peut pas être modifié",
    "admin.survey.style.shared-link.description": "Ce sondage est partagé au moyen d’un lien unique plutôt que d’invitations individuelles. Les répondants n’ont donc pas besoin de figurer dans votre fichier d’employés et peuvent répondre plus d’une fois.",
    "admin.survey.style.shared-link.description-limitations": "Comme personne n’est identifié, il n’y a pas d’invitations ni de taux de réponse, et les rappels ne s’appliquent pas.",
    "admin.survey.style.shared-link.title": "Sondage par lien partagé",
    "admin.survey.style.standard.description": "Cette enquête a des dates de début et de fin fixes, après lesquelles elle ne peut plus recevoir de réponses. À des fins de tendances, vous pouvez la cloner et réinviter les participants.",
    "admin.survey.style.standard.title": "Enquête standard",
    "admin.survey.surveyNameMax": "{{Num}} caractères maximum autorisés",
    "admin.survey.timezone": "Fuseau horaire",
    "admin.survey.type": "Type de sondage",
    "admin.survey.type.placeholder": "Choisir le type",
    "admin.survey.wizard.next-step": "Prochaine étape",
    "admin.survey.wizard.previous-step": "Étape précédente",
    "admin.survey.wizard.return-to-surveys": "Retour aux enquêtes",
    "admin.survey.wizard.save-changes": "Enregistrer les modifications",
    "admin.surveylibrary.count": "# de fois envoyé",
    "admin.surveylibrary.lastSent": "Dernier envoi",
    "admin.surveylibrary.supportedLanguages": "Langues acceptées",
    "admin.surveylibrary.type": "Type de question",
    "admin.surveyquestions.header": "Ajouter des questions au sondage",
    "admin.surveys.detail": "Détails de votre sondage",
    "admin.surveys.header": "Sondages",
    "admin.title": "Admin",
    "admin.updatesurvey.add": "Ajouter",
    "admin.updatesurvey.remove": "Enlever",
    "admin.updatesurvey.resend": "Renvoyer",
    "admin.users.action-planning-perms": "Permissions pour la planification de l’action",
    "admin.users.allAttributes": "Tous les attributs",
    "admin.users.attribute.selected": "{{num}} sélectionné",
    "admin.users.attribute.selector": "Attributs que les utilisateurs peuvent voir",
    "admin.users.attributes.compareAttributesDoNotMatchFilterAttributes": "Chaque attribut de la liste \"<0>{{compareAttributesHeader}}</0>\" doit également être présent dans la liste \"<0>{{filterAttributesHeader}}</0>\".",
    "admin.users.attributes.header": "Attributs",
    "admin.users.customAttributes": "Attributs personnalisés",
    "admin.users.dataAccess": "Accès aux données",
    "admin.users.dataAccess.all": "Envoi de sondages et affichage des résultats ",
    "admin.users.dataAccess.sendingOnly": "Envoi des sondages",
    "admin.users.dataAccess.viewOnly": "Affichage des résultats du sondage",
    "admin.users.dataCompare": "Comparables de données dans les rapports",
    "admin.users.editUser": "Modifier l’accès des autres utilisateurs.",
    "admin.users.email": "Courriel",
    "admin.users.exist.email": "L'utilisateur existe déjà: {{emails}}",
    "admin.users.header": "Administrateurs",
    "admin.users.invite": "Inviter des utilisateurs",
    "admin.users.manage": "Gérer l'utilisateur",
    "admin.users.missing.compareValue": "Veuillez sélectionner des attributs pour les comparables de données pour le type de sondage {{name}}",
    "admin.users.missing.dataAccess": "Veuillez sélectionner les attributs d'accès aux données des employés pour le type de sondage {{name}}",
    "admin.users.missing.email": "Veuillez fournir un courriel",
    "admin.users.missing.employeeAccess": "Veuillez sélectionner une option pour l'accès aux données des employés pour le type de sondage {{name}}",
    "admin.users.missing.language": "Veuillez sélectionner une langue",
    "admin.users.missing.surveyType": "Au moins une autorisation de type de sondage requise",
    "admin.users.missing.visibility": "Veuillez sélectionner des attributs pour l'accès aux données d'attributs pour le type de sondage {{name}}",
    "admin.users.name": "Nom",
    "admin.users.no.email": "Pour inviter des utilisateurs avec un accès basé sur la hiérarchie ou un accès basé sur des attributs personnalisés, ils doivent être répertoriés comme employés : {{email}}",
    "admin.users.permissions": "Autorisations globales",
    "admin.users.searchAll": "Rechercher par nom ou courriel",
    "admin.users.selectAttributeValues": "Sélectionner les valeurs d'attribut",
    "admin.users.selectAttributes": "Sélectionner les attributs",
    "admin.users.selectHierarchies": "Sélectionner les hiérarchies",
    "admin.users.surveyPermissions": "Autorisations de type de sondage",
    "admin.users.tagline": "Invitez d’autres personnes à accéder à la fonction de création de sondages, à consulter tous les résultats des sondages et/ou à voir les résultats des sondages à diffusion restreinte pour leurs subordonnés directs seulement.",
    "admin.users.theirType": "Leur {{name}}",
    "admin.users.userActions": "Actions utilisateur",
    "adminExport.advanced": "Version avancée",
    "adminExport.confirm.desc": "La version avancée contient des données d’utilisateurs sensibles.",
    "adminExport.confirm.title": "Avez-vous vraiment besoin de la version avancée?",
    "adminExport.desc": "L’exportation brute inclura les données relatives aux attributs des employés, y compris l’identifiant de l’employé, l’identifiant du gestionnaire et l’adresse de courriel. Il s’agit des renseignements nécessaires pour une régénération.",
    "adminExport.dialog.confirm": "Télécharger l’exportation",
    "adminExport.includePrivateAttributes": "Inclure les attributs privés de l'employé",
    "adminExport.includeResponses": "Inclure les réponses des employés",
    "adminExport.privateAttributes.warning.confirm": "Ouais! J'ai besoin des attributs privés de l'employé et j'accepte de supprimer cette exportation dès que je l'aurai menée à terme.",
    "adminExport.privateAttributes.warning.desc": "Les attributs privés d'un employé sont sensibles et se rapportent directement à une seule personne. Elles ne doivent pas être partagées. Votre identifiant sera enregistré.",
    "adminExport.privateAttributes.warning.title": "Voulez-vous vraiment exporter les attributs privés de l'employé?",
    "adminExport.title": "Exportation brute",
    "adminExport.warning.confirm": "Oui, j’ai besoin des réponses des employés et j’accepte de supprimer cette exportation aussitôt que j’en aurai terminé.",
    "adminExport.warning.desc": "Les réponses des employés ne sont pas nécessaires pour régénérer un sondage. Cette option ne doit être choisie qu’à des fins d’analyses. Votre identifiant d’utilisateur sera enregistré.",
    "adminExport.warningTitle": "Avez-vous vraiment besoin d’exporter les réponses des employés?",
    "ago": "il y a",
    "ai.email.next.steps": "Ces informations constituent un point de départ précieux pour engager la conversation et passer à l'action. Pour approfondir votre analyse des données et comprendre les nuances qui se cachent derrière ces chiffres, nous vous encourageons à utiliser l'assistant IA directement intégré à la plateforme WorkTango. Vous pouvez solliciter le Coach WorkTango pour explorer les résultats et découvrir des stratégies efficaces pour répondre aux commentaires de votre équipe.",
    "ai.email.presentation": "Le rapport d'enquête est maintenant disponible sur WorkTango. Voici un bref résumé des résultats de votre équipe.",
    "allQuestions": "Toutes les questions",
    "analytics.distribution": "Distribution",
    "analytics.fields": "Champs de l’employé",
    "analytics.hierarchy": "Hiéarchie",
    "analytics.nps": "eNPS",
    "analyze.attribute.noVisible": "Aucun attribut principal visible pour le sondage en cours",
    "analyze.hide.empty.rows": "Masquer les lignes vides",
    "and": "et",
    "anonymouse.protection.message": "Afin de protéger l'anonymat des employés, nous ne pouvons pas afficher les données demandées. Les algorithmes d'anonymat de WorkTango sont en place pour garantir que les employés se sentent en sécurité tout en fournissant leurs commentaires. Veuillez essayer de changer le(s) sondage(s) et/ou filtre(s) sélectionné(s).",
    "ap.actionWasCreatedSuccessfully": "Votre action a été créée et attribuée avec succès.",
    "ap.add.action": "Ajouter aux actions",
    "ap.createALibraryTemplate": "Créer une action de bibliothèque",
    "ap.createAnAction": "Créer une action",
    "ap.edit.template": "Modifier l'action de bibliothèque",
    "ap.error.assignmentRequired": "Vous devez l’attribuer à quelqu’un",
    "ap.error.titleRequired": "Un titre est requis pour toutes les langues.",
    "ap.label.addAction": "Ajouter une action",
    "ap.label.addQuestion": "Ajouter une question",
    "ap.label.any": "Toute",
    "ap.label.anyone": "Quiconque",
    "ap.label.assignedTo": "Attribué à",
    "ap.label.cancel": "Annuler",
    "ap.label.changeDueDate": "Modifier l’échéance",
    "ap.label.close": "Fermer",
    "ap.label.create": "Créer",
    "ap.label.description": "Description",
    "ap.label.dueAt": "Échéance :",
    "ap.label.effectiveness": "Efficacité",
    "ap.label.factors": "Facteurs",
    "ap.label.filterBy": "Filtrer par :",
    "ap.label.introduce.question": "Introduire une nouvelle question",
    "ap.label.me": "Moi",
    "ap.label.modifyAction": "Modifier l’action",
    "ap.label.newAction": "Nouvelle mesure",
    "ap.label.reset": "Réinitialiser",
    "ap.label.save": "Enregistrer",
    "ap.label.search": "Recherche",
    "ap.label.status": "État",
    "ap.label.surveyFactor": "Facteur par défaut du sondage",
    "ap.label.surveyType": "Type d’enquête",
    "ap.label.surveys": "Sondages",
    "ap.label.title": "Titre",
    "ap.noActions": "Vous avez besoin d’un moyen pour faire le suivi des points de vue de votre organisation?",
    "ap.noFilterResults": "Aucune action n’a été trouvée pour les filtres sélectionnés. Essayez un autre ensemble de filtres.",
    "ap.noLibraryTemplates": "Aucune action de la bibliothèque",
    "ap.status.complete": "Terminé",
    "ap.status.inProgress": "En cours",
    "ap.status.todo": "À faire",
    "ap.status.unassigned": "Non attribué",
    "ap.title.actionAssigned": "Action ajoutée",
    "ap.title.actionPlanning": "Planification de la mesure",
    "ap.title.actions": "Actions",
    "ap.title.assignedTo": "Attribué à",
    "ap.title.createLibraryAction": "Créer une action de bibliothèque",
    "ap.title.dueAt": "Dû le",
    "ap.title.factors": "Facteurs",
    "ap.title.isComplete": "Effectué",
    "ap.title.library": "Bibliothèque",
    "ap.title.libraryAction": "Action de la bibliothèque",
    "ap.title.modifyLibraryAction": "Modifier l’action de la bibliothèque",
    "ap.title.name": "Nom",
    "ap.title.surveys": "Enquêtes",
    "ar-sa": "Arabe (Arabie Saoudite)",
    "are-you-sure": "Cliquez pour confirmer",
    "are.you.sure": "Es-tu sûr?",
    "attribute": "Attribut",
    "attribute-list.no-attributes": "Il n'y a pas d'attributs à afficher. Veuillez vérifier vos autorisations ou contacter le service d'assistance.",
    "attribute-list.not-available": "",
    "attribute-list.not-available-tooltip": "",
    "attribute.breakdown": "Répartition del’attribut",
    "attribute.click.to.confirm.archive": "Cliquez pour confirmer l'archivage",
    "attribute.click.to.confirm.unarchive": "Cliquez pour confirmer la réactivation",
    "attribute.create": "Créer",
    "attribute.empty.message": "Sélectionner un attribut",
    "attribute.endDate": "Date de fin",
    "attribute.name": "Nom d'attribut",
    "attribute.startDate": "Date de début",
    "attribute.unarchive": "Réactiver l'attribut",
    "attribute.unarchiveConfirmTitle": "Réactiver l'attribut \"{{nom}}\" ?",
    "attributes.all": "Tous les attributs",
    "attributes.label": "Attribut",
    "automated-invitations.add-another-trigger": "Ajouter un autre déclencheur",
    "automated-invitations.add-trigger": "Ajouter un déclencheur",
    "automated-invitations.box.switch": "Automatiser l'envoi des invitations au sondage {{surveyType}}",
    "automated-invitations.box.title": "Sondages {{surveyType}}",
    "automated-invitations.confirm-delete-dialog.delete": "oui, supprimer",
    "automated-invitations.confirm-delete-dialog.delete-with-candidates": "Supprimer le déclencheur et les candidats",
    "automated-invitations.confirm-delete-dialog.message1": "La suppression d'un déclencheur n'affectera que les automatisations futures des dossiers des employés. Cette action est irréversible.",
    "automated-invitations.confirm-delete-dialog.message2": "Tous les employés invités par le passé et ceux qui se trouvent actuellement dans la Boîte d'envoi ne seront pas affectés par cette action, et vous pourrez toujours recréer ce déclencheur à l'avenir.",
    "automated-invitations.confirm-delete-dialog.message3": "Si votre intention est d'interrompre l'automatisation, mais de conserver la configuration des déclencheurs, optez plutôt pour la commutation de l'automatisation du sondage.",
    "automated-invitations.confirm-delete-dialog.message4": "Voulez-vous vraiment supprimer ce déclencheur?",
    "automated-invitations.confirm-delete-dialog.message5": "Tous les employés actuellement dans la boîte d'envoi qui ont été ajoutés par le biais de ce déclencheur seront affectés par cette action",
    "automated-invitations.confirm-delete-dialog.title": "Supprimer le déclencheur « {{triggerName}} »?",
    "automated-invitations.confirm-disable-dialog.halt-automation": "oui, arrêter l'automatisation",
    "automated-invitations.confirm-disable-dialog.message1": "L'arrêt de ce processus n'affectera que les automatisations futures de fichiers des employés. Cette action est facilement réversible.",
    "automated-invitations.confirm-disable-dialog.message2": "Tous les employés invités par le passé et ceux qui se trouvent actuellement dans la Boîte d'envoi ne seront pas affectés par cette action, et vous pourrez toujours réactiver cette automatisation à l'avenir.",
    "automated-invitations.confirm-disable-dialog.message3": "Si vous continuez, tous les déclencheurs configurés seront conservés, mais ne seront pas actifs.",
    "automated-invitations.confirm-disable-dialog.message4": "Voulez-vous vraiment arrêter l'automatisation?",
    "automated-invitations.confirm-disable-dialog.success": "Automatisation interrompue avec succès.",
    "automated-invitations.confirm-disable-dialog.title": "Arrêter l'automatisation des sondages {{surveyType}}?",
    "automated-invitations.confirm-pause-dialog.pause-message": "La mise en pause d'un déclencheur empêchera uniquement les futurs employés d'être ajoutés à la liste. Les candidats déjà présents sur la liste ne seront pas affectés. Cette action peut être facilement annulée. <0/> Vous pouvez annuler la pause d'un déclencheur à tout moment pour reprendre l'automatisation, qui recherchera les employés correspondants. <0/> Êtes-vous sûr de vouloir mettre ce déclencheur en pause ?",
    "automated-invitations.confirm-pause-dialog.pause-title": "Déclencheur de pause \"{{triggerName}}\" ?",
    "automated-invitations.confirm-pause-dialog.unpause-message": "La désactivation d'un déclencheur reprendra l'automatisation, qui recherchera les employés correspondants pour les inviter à participer à l'enquête. <0/> Êtes-vous sûr de vouloir désactiver ce déclencheur ?",
    "automated-invitations.confirm-pause-dialog.unpause-title": "Annuler le déclencheur \"{{triggerName}}\" ?",
    "automated-invitations.rehiring.attribute-containing-rehire-date": "Attribut contenant la date de réembauche",
    "automated-invitations.rehiring.description": "Le système peut identifier si un employé a réintégré l'entreprise et permet des participations multiples aux enquêtes d'accueil et de sortie. L'invitation et les réponses à l'enquête d'origine seront conservées.",
    "automated-invitations.rehiring.rehire-date-save-failed": "La configuration de la date de réemploi n'a pas pu être enregistrée, veuillez réessayer.",
    "automated-invitations.rehiring.rehire-date-saved": "La configuration de la date de réembauche a été sauvegardée avec succès.",
    "automated-invitations.rehiring.rehire-warning": "Veuillez noter que cette modification n'affectera que les changements futurs de la date de réembauche et ne mettra pas à jour les employés existants. Si cet attribut n'est plus disponible à l'avenir (archivé ou supprimé), le système reviendra automatiquement à la date de début.",
    "automated-invitations.rehiring.title": "Réutilisation",
    "automated-invitations.these-triggers": "Ces déclencheurs sont...",
    "automated-invitations.trigger-form.actions": "Actions de déclenchement",
    "automated-invitations.trigger-form.admin-users-helper": "Il s'agit d'un champ interne visible uniquement par les administrateurs de la plate-forme",
    "automated-invitations.trigger-form.all-users-error": "Choisissez un utilisateur ou un administrateur de plateforme. Au moins une personne doit être informée avant et après l'envoi des invitations",
    "automated-invitations.trigger-form.attribute": "Attribut contenant {{attribute}}",
    "automated-invitations.trigger-form.attribute-error": "Date requise pour calculer le moment opportun pour envoyer une invitation",
    "automated-invitations.trigger-form.attribute-placeholder": "Choisir un attribut",
    "automated-invitations.trigger-form.attributes-audience-error": "Veuillez sélectionner au moins un filtre si vous utilisez le public sur la base des attributs.",
    "automated-invitations.trigger-form.automation-level": "Niveau d'automatisation",
    "automated-invitations.trigger-form.automation-level.automatic": "L'invitation par courriel devrait être émise automatiquement",
    "automated-invitations.trigger-form.automation-level.manual": "L'administrateur a besoin d'approuver les destinataires",
    "automated-invitations.trigger-form.cancel": "Annuler",
    "automated-invitations.trigger-form.custom": "Sur mesure",
    "automated-invitations.trigger-form.custom-date.description.exit": "{{days}} jours avant la sortie",
    "automated-invitations.trigger-form.custom-date.description.onboarding": "{{days}} jours de la titularisation",
    "automated-invitations.trigger-form.custom-invitation-date": "Date d'invitation personnalisée",
    "automated-invitations.trigger-form.custom-view": "Personnalisé ({{description}})",
    "automated-invitations.trigger-form.delete": "supprimer le déclencheur",
    "automated-invitations.trigger-form.delete-success": "Déclencheur supprimé avec succès.",
    "automated-invitations.trigger-form.edit": "Modifier le déclencheur",
    "automated-invitations.trigger-form.invitation-date": "Date cible de l'invitation",
    "automated-invitations.trigger-form.invitation-date.30-days-after": "30 jours après l'entrée en fonction",
    "automated-invitations.trigger-form.invitation-date.60-days-after": "60 jours après l'entrée en fonction",
    "automated-invitations.trigger-form.invitation-date.90-days-after": "90 jours après l'entrée en fonction",
    "automated-invitations.trigger-form.invitation-date.exit-15-days-before": "15 jours avant la sortie",
    "automated-invitations.trigger-form.invitation-date.exit-7-days-before": "7 jours avant la sortie",
    "automated-invitations.trigger-form.invitation-date.exit-asap": "Dès que possible",
    "automated-invitations.trigger-form.invitation-date.exit-date": "À la date de sortie",
    "automated-invitations.trigger-form.invitation-date.start-date": "À la date de début",
    "automated-invitations.trigger-form.invitation-date.week-before": "Semaine avant la date de début",
    "automated-invitations.trigger-form.invitation-time": "Heure d'envoi de l'invitation au cours de la journée",
    "automated-invitations.trigger-form.invitation-time.end-of-day": "Fin de journée (16-18 h)",
    "automated-invitations.trigger-form.invitation-time.lunch": "Midi à l'heure du déjeuner (12 h-14 h)",
    "automated-invitations.trigger-form.invitation-time.morning": "Tôt le matin (6-8 h)",
    "automated-invitations.trigger-form.invitation-time.night": "Tard dans la nuit (20-22 h)",
    "automated-invitations.trigger-form.invitation-time.tooltip": "C’est à ce moment que vos invitations sont placées dans la file d’attente d’envoi, et non nécessairement au moment où les destinataires les reçoivent. Veuillez noter que la livraison peut prendre jusqu’à 3 heures après le début de la période d’envoi afin de garantir une délivrabilité optimale des e-mails.",
    "automated-invitations.trigger-form.name": "Nom du déclencheur",
    "automated-invitations.trigger-form.name-error": "Nom interne unique requis",
    "automated-invitations.trigger-form.name-placeholder": "Entrer un nom de déclencheur interne",
    "automated-invitations.trigger-form.new-trigger-title": "Nouveau déclencheur",
    "automated-invitations.trigger-form.notified-admin-users": "Administrateurs de la plate-forme qui doivent recevoir des notifications par courrier électronique",
    "automated-invitations.trigger-form.notified-users": "Utilisateurs devant recevoir des notifications par courriel",
    "automated-invitations.trigger-form.pause": "Déclenchement de la pause...",
    "automated-invitations.trigger-form.pause-confirmation": "Oui, mettez-le en pause",
    "automated-invitations.trigger-form.pause-success": "Le déclencheur a été mis en pause avec succès.",
    "automated-invitations.trigger-form.save": "Sauvegarder le déclencheur",
    "automated-invitations.trigger-form.survey": "Sondage {{surveyType}} faisant l'objet de l'invitation",
    "automated-invitations.trigger-form.survey-error": "Veuillez sélectionner un sondage auquel les employés devraient être invités",
    "automated-invitations.trigger-form.survey-placeholder": "Choisir un sondage",
    "automated-invitations.trigger-form.target-audience": "Public cible",
    "automated-invitations.trigger-form.target-audience.attribute": "Basé sur les attributs",
    "automated-invitations.trigger-form.target-audience.everyone": "Tout le monde",
    "automated-invitations.trigger-form.timezone": "{{timezone}}, conformément au sondage",
    "automated-invitations.trigger-form.unpause": "Déclencher la pause...",
    "automated-invitations.trigger-form.unpause-confirmation": "Oui, débloquer la pause",
    "automated-invitations.trigger-form.unpause-success": "Le déclencheur a été désactivé avec succès.",
    "automated-invitations.trigger-form.users-error": "Au moins une personne doit être avertie avant et après l'envoi des invitations",
    "back.to.login": "Retour à l’ouverture de session",
    "benchmark.attribute.country": "pays",
    "benchmark.attribute.industry": "industrie",
    "benchmark.attribute.region": "région",
    "benchmark.attribute.sector": "secteur",
    "benchmark.attribute.size": "taille",
    "benchmark.comment.insufficient-data": "Données insuffisantes (N={{companiesCount}})",
    "benchmark.comment.question-not-benchmarked": "Question non comparée",
    "benchmark.compare.menu-item": "Référence WorkTango {{benchmarkPeriod}}",
    "benchmark.dropdown.label": "Évaluation comparative à",
    "benchmark.option-group.different-organization": "Différent de votre organisation",
    "benchmark.option-group.same-organization": "Identique à votre organisation",
    "benchmark.option.all-companies": "Toutes les entreprises",
    "benchmark.option.other-country": "Autre pays...",
    "benchmark.option.other-industry": "Autre secteur d’activité...",
    "benchmark.option.other-region": "Autre région...",
    "benchmark.option.other-sector": "Autre secteur...",
    "benchmark.option.other-size": "Autre taille...",
    "benchmark.option.same-country": "Même pays ({{countryName}})",
    "benchmark.option.same-industry": "Même industrie ({{industryName}})",
    "benchmark.option.same-region": "Même région ({{regionName}})",
    "benchmark.option.same-sector": "Même secteur ({{sectorName}})",
    "benchmark.option.same-size": "Même taille ({{sizeName}})",
    "benchmark.option.top25-companies": "Quartile supérieur des entreprises les plus performantes",
    "benchmark.question-mapping.all-companies": "Toutes les entreprises",
    "benchmark.question-mapping.all-questions": "Toutes les questions",
    "benchmark.question-mapping.all-survey-types": "Tous les types de sondage",
    "benchmark.question-mapping.all-years": "Toutes les années",
    "benchmark.question-mapping.empty": "Aucune question ne correspond à vos filtres.",
    "benchmark.question-mapping.filter-question": "Filtrer par question",
    "benchmark.question-mapping.library-question": "Question de bibliothèque",
    "benchmark.question-mapping.not-tagged-msg": "Question non utilisée pour la référence",
    "benchmark.question-mapping.number-of-surveys": "N° de sondages",
    "benchmark.question-mapping.only-untagged": "Uniquement les éléments anonymisés",
    "benchmark.question-mapping.period": "Période",
    "benchmark.question-mapping.question-scope": "Portée de la question",
    "benchmark.question-mapping.survey-question": "Question de sondage",
    "benchmark.question-mapping.survey-questions.title": "Identiqueter la question de la bibliothèque avec des questions de sondage",
    "benchmark.question-mapping.survey-years": "Années de sondage",
    "benchmark.question-mapping.surveyType.dei": "Diversité, équité et inclusion",
    "benchmark.question-mapping.surveyType.engagement": "Engagement",
    "benchmark.question-mapping.surveyType.exit": "Sortie",
    "benchmark.question-mapping.surveyType.onboarding": "Intégration",
    "benchmark.question-mapping.switch-mode": "Passer à l'identiquetage par Question de sondage",
    "benchmark.question-mapping.tagged": "Questions identiquetées",
    "benchmark.question-mapping.tagged-survey-questions": "Questions de sondage identiquetées",
    "benchmark.question-mapping.tagged-with-count": "Questions identiquetées ({{count}})",
    "benchmark.question-mapping.title": "Identiquetage des questions de sondage pour la référence",
    "benchmark.question-mapping.untagged": "Anonymiser les questions",
    "benchmark.question-mapping.update-mappings": "Sauvegarder avec les {{selectedCount}} questions identiquetées",
    "benchmark.question.indicator-tooltip": "Cette question fait partie de WorkTango Benchmarking",
    "benchmark.title": "Référence",
    "benchmark.title.attribute": "Référence pour {{attributeName}}",
    "benchmark.title.attribute-value": "{{attributeName}}: {{valueName}}",
    "benchmark.title.same-country": "dans le même pays",
    "benchmark.title.same-industry": "Même secteur d’activité",
    "benchmark.title.same-region": "Même région",
    "benchmark.title.same-sector": "Même secteur",
    "benchmark.title.same-size": "Même taille",
    "benchmark.title.top-quartile": "Quartile supérieur",
    "benchmark.tooltip.disabled-option": "WorkTango n'a pas enregistré ces renseignements pour votre organisation. Veuillez contacter votre représentant Réussite clients pour obtenir de l'aide.",
    "benchmark.tooltip.na": "Actuellement, seules les questions sont comparées",
    "benchmark.tooltip.no-other-values": "Il n’y a pas suffisamment d’autres organisations ayant un {{attributeName}} différent pour établir une comparaison.",
    "benchmark.unknown": "Inconnue",
    "benchmark.value-dropdown.label": "Autre {{attributeName}}",
    "benchmark.value-dropdown.placeholder": "Choisir {{attributeName}}",
    "boolean.no": "Non",
    "boolean.yes": "Oui",
    "bottom.attributes": "Cinq derniers attributs",
    "bounced.emails.list": "Certains employés n’ont pas reçu de courriel. Veuillez passer en revue la liste des erreurs ci-dessous pour en savoir plus.",
    "btc_sliding_05-07-2018": "Bitcoin",
    "button.add-filters": "Ajouter des filtres...",
    "button.add-selected": "Ajouter l'élément sélectionné",
    "button.addRule": "Ajouter une deuxième règle",
    "button.analyze": "Analyser",
    "button.apply": "Appliquer",
    "button.approve-all": "Approuver tout",
    "button.automate.activate.survey": "Activer l'enquête",
    "button.automate.deactivate.survey": "Désactiver l'enquête",
    "button.back": "Retourner",
    "button.back-attribute": "Retour à tous les attributs",
    "button.cancel": "Annuler",
    "button.clone": "Cloner",
    "button.close": "Fermer",
    "button.confirm": "Confirmer",
    "button.create": "Créer",
    "button.debug": "Déboguer",
    "button.delete": "Supprimer",
    "button.download-template": "Télécharger le modèle",
    "button.edit": "Modifier",
    "button.edit-prompt": "Modifier l'invite",
    "button.export": "Exportation",
    "button.filter-results": "Filtrer les résultats",
    "button.filters": "Filtres",
    "button.got-it": "C'est compris",
    "button.hide": "Cacher",
    "button.launch": "Planifier le sondage",
    "button.launchNow": "Confirmer",
    "button.launchlater": "Annuler",
    "button.leave": "Quitter la page",
    "button.next-step": "Étape suivante",
    "button.ok": "OK",
    "button.override": "Écraser",
    "button.previous-step": "Étape précédente",
    "button.re-analyze": "Réanalyser",
    "button.remove": "Supprimer",
    "button.removeRule": "Retirer une deuxième règle",
    "button.reset": "Réinitialiser",
    "button.retry-analysis": "Analyse des tentatives",
    "button.return": "Continuer la modification",
    "button.return-templates": "Retour aux modèles",
    "button.save": "Enregistrer",
    "button.save-changes": "Sauvegarder les modifications",
    "button.save-prompt": "Enregistrer l'invite",
    "button.saveAndClose": "Enregistrer et fermer",
    "button.saveAndSchedule": "Sauvegarder les modifications et programmer",
    "button.search": "Rechercher",
    "button.select.all.matches": "Sélectionner tous les {{count}} résultats",
    "button.select.all.visible": "Sélectionner tous les éléments visibles",
    "button.send.test": "Envoyer un courriel de test...",
    "button.show": "Montrer",
    "button.start": "Début",
    "button.start-import": "Démarrer l'importation",
    "button.start-migration": "Démarrer la migration",
    "button.tag.all.matches": "Identiqueter tous les {{count}} résultats",
    "button.tag.all.visible": "Identiqueter tous les éléments visibles",
    "button.tooltip.migration-failure": "Pour le motif de l'échec, veuillez vous référer au courriel envoyé à {{email}}",
    "button.tooltip.pending-for-approval": "Approuver la migration et marquer le sondage comme Terminé",
    "button.unselect.all": "Désélectionner tout",
    "button.unselect.visible": "Désélectionner les éléments visibles",
    "button.untag.all.matches": "Anonymiser tous les {{count}} résultats",
    "button.untag.all.visible": "Anonymiser tous les éléments visibles",
    "button.update": "Mettre à jour",
    "button.upload-survey": "Téléverser les données de sondage",
    "button.yes-remove": "Oui, supprimer",
    "categories.all": "Sélectionnez un facteur",
    "category.enName": "Nom du facteur (En)",
    "category.frName": "Nom du facteur (Fr)",
    "category.name": "Nom du facteur",
    "change": "Changer",
    "clear.content.type": "Effacer le type de contenu",
    "clibrary.navigation.read": "Lire",
    "clibrary.navigation.starred": "Marqué",
    "clibrary.navigation.unread": "Non lu",
    "close": "Fermer",
    "coach.end.summary.qestion": "Y a-t-il des points particuliers que vous souhaiteriez que je clarifie ou que j'approfondisse en ce qui concerne cette enquête ?",
    "coach.present.summary.header": "Voici le résumé de l'enquête généré par l'IA :",
    "colorpicker.title": "Choisir une couleur",
    "comment.idea": "Excellente idée!",
    "comment.like": "Aimer",
    "comment.reply": "Répondre à ce commentaire",
    "comment.working": "On s’en occupe",
    "comments.attributeFiltersIgnored": "Les filtres que vous avez appliqués ne se reflètent pas dans les commentaires ci-dessous.",
    "comments.filter.sentiment": "Filtrer par sentiment",
    "comments.filter.theme": "Filtrer par thème",
    "common.approved": "Approuvé",
    "common.bottom": "Bas",
    "common.field.isDisabled": "Vous ne pouvez pas modifier ce champ",
    "common.nameUsed": "Le nom a déjà été utilisé!",
    "common.none": "Aucune",
    "common.not-approved": "Non approuvé",
    "common.notify": "Notifier",
    "common.other": "Autres",
    "common.select": "Sélectionner",
    "common.selected": "sélectionné",
    "common.top": "Haut",
    "company.add": "Ajouter une entreprise",
    "company.error.duplicateSalesforceId": "Une entreprise ayant le même identifiant Salesforce existe déjà.",
    "company.industry.assetIntensive": "Intensif en actifs",
    "company.industry.financialService": "Services financiers",
    "company.industry.healthcare": "Soins de santé",
    "company.industry.technology": "Technologie",
    "company.region.APAC": "APAC",
    "company.region.Canada": "Canada",
    "company.region.EMEA": "EMEA",
    "company.region.NorthAmerica": "Amérique du Nord",
    "company.region.UnitedStates": "États-Unis",
    "company.sector.private": "Privé",
    "company.sector.public": "Public",
    "compare-with": "Comparer avec",
    "compare.attribute": "Comparaison d'attributs",
    "compare.attributes": "Attribut(s)",
    "compare.dropdown.benchmarks-group": "Références, n'utilise pas les filtres appliqués",
    "compare.dropdown.current-survey-group": "Sondage(s) actuel(s), n'utilise pas les filtres appliqués",
    "compare.dropdown.different-timeframe": "Différents horizons temporels",
    "compare.dropdown.other-surveys-group": "Autre sondage, utilise les filtres appliqués",
    "compare.none": "Aucun",
    "compare.organization": "À l'échelle de l'organisation",
    "compare.survey": "Sondage",
    "compare.timeframe": "Comparaison des périodes",
    "compare.to": "Comparer avec : {{name}}",
    "compare.toSurvey": "Comparer les sondages",
    "completed": "Terminé",
    "contact.us": "Contactez-nous",
    "continuous-survey.triggers.add-trigger": "Configurer un nouveau déclencheur pour cette enquête...",
    "continuous-survey.triggers.configure-automation": "Configurer l'automatisation",
    "continuous-survey.triggers.no-triggers-subtitle": "Aucun déclencheur actif n'est configuré pour cette enquête. Pour que l'automatisation fonctionne, il faut au moins un déclencheur actif. ",
    "continuous-survey.triggers.no-triggers-warning": "Aucun déclencheur actif n'est configuré",
    "continuous-survey.triggers.trigger-type-disabled-button": "Aller dans les paramètres d'automatisation de l'enquête",
    "continuous-survey.triggers.trigger-type-disabled-subtitle": "Le système n'ajoutera pas automatiquement de nouveaux candidats à cette enquête.",
    "continuous-survey.triggers.trigger-type-disabled-warning": "L'automatisation est désactivée",
    "continuous-survey.triggers.view-all": "Voir les déclencheurs de toutes les enquêtes",
    "conversations.placeholder": "Entrer un message...",
    "courier.general.click.here": "Réinitialiser mon mot de passe",
    "courier.password.reset.email": "quelqu'un a demandé un lien pour réinitialiser votre mot de passe pour la plateforme WorkTango.",
    "create.reminder.button": "Créer un nouveau rappel",
    "createSurvey.logicEditor": "Éditeur Logic",
    "createSurvey.questionEditor": "Éditeur de question",
    "created": "Établi",
    "created.by": "Créé par",
    "cs-cz": "Tchèque",
    "da-dk": "Danois",
    "date.operator.greater": "supérieur ou égal à",
    "date.operator.less": "inférieur ou égal à",
    "date.unit.day": "jour(s)",
    "date.unit.month": "mois",
    "date.unit.year": "an(s)",
    "dateStatus0": "Créé(e) :",
    "dateStatus1": "Programmé(e) :",
    "dateStatus2": "Expire :",
    "dateStatus3": "Complété(e) le:",
    "de-de": "Allemand",
    "deactivated": "Désactivé",
    "debug.header": "Débogage",
    "default": "défaut ",
    "detractor.2": "Détracteur",
    "disabled": "Désactivé",
    "dmin.survey.build.add-recipient.title_one": "",
    "doNotContact.add.success": "Employé ajouté avec succès à la liste.",
    "doNotContact.adding-reason": "Motif de l'ajout",
    "doNotContact.adding-reason.placeholder": "Entrez le motif d'ajout de cet employé ou de ces employés",
    "doNotContact.automaticEmailTriggers.tab": "",
    "doNotContact.button.addEmployee": "Ajouter un employé à la liste",
    "doNotContact.dialog.add.noEmployees": "Aucun employé ne correspond à vos filtres.",
    "doNotContact.dialog.add.title": "Sélectionnez des employés à ajouter",
    "doNotContact.dialog.delete.message1": "La suppression d'une personne de cette liste signifie qu'elle n'est plus ignorée dans les invitations à des sondages automatisés.",
    "doNotContact.dialog.delete.message2": "Si vous n'êtes pas la personne ayant initialement inscrit {{name}} sur la liste, le système enverra également une notification à l'utilisateur l'ayant fait.",
    "doNotContact.dialog.delete.message3": "Voulez-vous vraiment supprimer {{name}} de la liste?",
    "doNotContact.dialog.delete.title": "Supprimer {{name}} de la liste?",
    "doNotContact.filterEmployee": "Filtrer les employés",
    "doNotContact.page.title": "Liste Ne pas contacter",
    "doNotContact.reason.required": "Ce champ ne peut pas être vide",
    "doNotContact.remove.success": "Employé supprimé avec succès de la liste.",
    "doNotContact.selectedEmployees.required": "Vous devez sélectionner au moins un employé dans la liste.",
    "doNotContact.smsOptOuts.addEmployee": "",
    "doNotContact.smsOptOuts.addedBySystem": "",
    "doNotContact.smsOptOuts.description": "",
    "doNotContact.smsOptOuts.remove.message1": "",
    "doNotContact.smsOptOuts.tab": "",
    "doNotContact.table.addedAtTimeUTC": "Ajouté à la liste",
    "doNotContact.table.addedByUserName": "Ajouté par",
    "doNotContact.table.email": "Adresse courriel",
    "doNotContact.table.name": "Nom de l'employé",
    "doNotContact.table.noData": "Aucun employé ne correspond à vos filtres.",
    "doNotContact.table.reason": "Motif",
    "draft": "Brouillon",
    "el-gr": "Grec",
    "email": "Courriel",
    "email.account.locked.body.if.you.did.not.attempt": "Si ce n'est pas vous qui tentez de vous connecter, veuillez inclure ces informations dans la demande à notre équipe d'assistance.",
    "email.account.locked.body.please.reach.out": "Veuillez réinitialiser votre mot de passe pour déverrouiller votre compte.",
    "email.account.locked.body.someone.have.attempted": "Quelqu'un a tenté de se connecter à WorkTango avec cette adresse courriel et a échoué plusieurs fois.",
    "email.account.locked.reset.password": "Réinitialiser le mot de passe",
    "email.account.locked.subject": "Compte WorkTango verrouillé",
    "email.activate.account.btn": "Activez votre compte",
    "email.anon.convo.employee.have.replied": "un employé a répondu à une conversation anonyme à laquelle vous prenez part.",
    "employee.addNewEmployee": "Ajouter un nouvel employé",
    "employee.duplicatedEmployeeId": "Il y a plusieurs rangées qui utilisent le même identifiant d’employé : {{employeeId}}",
    "employee.export.exportEmployees": "Employés à l'exportation",
    "employee.export.loading": "Nous traitons votre demande, veuillez patienter...",
    "employee.import.activationWarning.agreementMessage": "Je comprends que 1 nouvel utilisateur sera activé",
    "employee.import.activationWarning.agreementMessage.plural": "Je comprends que {{count}} nouveaux utilisateurs seront activés",
    "employee.import.activationWarning.description": "Si vous procédez à cette importation, les employés suivants recevront l'accès au système en fonction de leur rôle indiqué entre parenthèses :",
    "employee.import.activationWarning.title": "Avertissement d'activation",
    "employee.import.email.failed.error.label": "Détails de l'erreur :",
    "employee.import.email.failed.message": "L’importation de vos employés pour {{companyName}} n’a pas pu être effectuée. Aucune modification n’a été apportée aux données de vos employés lors du traitement de {{fileName}}.",
    "employee.import.email.failed.next.steps": "Corrigez le problème dans {{fileName}} et relancez l’importation.",
    "employee.import.email.failed.subject": "Échec de l'importation des employés",
    "employee.import.email.succeeded.message": "L’importation de vos employés pour {{companyName}} a terminé le traitement de {{fileName}}. Les données de vos employés sont maintenant à jour.",
    "employee.import.email.succeeded.subject": "Importation des employés terminée",
    "employee.import.error.attributeTypeErrors": "Type de valeur d'attribut incorrect",
    "employee.import.error.customPermissionsRows": "Impossible de définir les « Autorisations personnalisées » (ligne {{rows}}). Elles ne peuvent être ajoutées que dans la plateforme; seule l'attribution de rôles nommés est prise en charge dans le fichier.",
    "employee.import.error.duplicateUniqueValues": "Valeur unique en double",
    "employee.import.error.fileValidation": "Veuillez corriger les erreurs suivantes dans votre fichier et réessayer",
    "employee.import.error.fileValidationDescription": "Veuillez les corriger et téléverser un nouveau fichier.",
    "employee.import.error.fileValidationTitle": "Le fichier téléversé présente des problèmes.",
    "employee.import.error.invalidType": "l'employé '{{employeeId}}' a un type de valeur incorrect pour le champ {{attrType}} '{{attrName}}'",
    "employee.import.error.invitingDisabledEmployee": "Vous ne pouvez pas à la fois inviter un nouvel utilisateur et désactiver son accès. Il faut soit effacer la valeur $SurveyRole, soit régler Activé sur « Oui » dans la ou les ligne(s) {{rows}}",
    "employee.import.error.missingField": "l'employé '{{employeeId}}' manque le champ obligatoire '{{attrName}}'",
    "employee.import.error.missingRequiredErrors": "Champ obligatoire manquant",
    "employee.import.error.modifiedEmployeeId": "L'identifiant de {{employeeName}} est passé de {{oldEmployeeId}} à {{newEmployeeId}}",
    "employee.import.error.modifiedEmployeeIdErrors": "Identifiants d'employé modifiés (ne devraient pas changer ici)",
    "employee.import.error.noHeaders": "En-tête d'attribut absent",
    "employee.import.error.unableToImport": "Impossible d'importer des employés",
    "employee.import.error.unableToReadFile": "Impossible de lire le fichier. Essayez un autre fichier ou corrigez le problème avec le fichier sélectionné.",
    "employee.import.error.unknownAttributeNames": "Nom d'attribut inconnu",
    "employee.import.error.unknownRoleNamesRows": "Nom de rôle inconnu (ligne {{rows}}). Assurez-vous que le nom de rôle indiqué dans le fichier est identique à celui configuré dans la plateforme.",
    "employee.import.error.unsupportedLangs": "Langue non prise en charge",
    "employee.import.error.userMissingEmailRows": "Utilisateur sans adresse courriel (rangée {{rows}}). Assurez-vous que tous les utilisateurs (employés ayant un rôle) disposent d'une adresse courriel.",
    "employee.import.history.column.date": "Date de téléversement",
    "employee.import.history.column.uploader": "Personne ayant téléversé le fichier",
    "employee.import.history.dialog.date": "Date d’importation",
    "employee.import.history.dialog.dateOriginFile": "Date d’importation, origine et nom de fichier d’origine",
    "employee.import.history.dialog.dateOriginFileValue": "{{date}} par {{origin}} ({{fileName}})",
    "employee.import.history.dialog.dateOriginValue": "{{date}} par {{origin}}",
    "employee.import.history.dialog.errors": "Détails de l’erreur",
    "employee.import.history.dialog.errorsCount": "1 erreur",
    "employee.import.history.dialog.errorsCount.plural": "{{count}} erreurs",
    "employee.import.history.dialog.issueRow": "Ligne {{rowNumber}} : {{message}}",
    "employee.import.history.dialog.issues": "Erreurs et avertissements d’importation",
    "employee.import.history.dialog.loadError": "Une erreur s’est produite lors du chargement des détails de l’importation. Veuillez réessayer.",
    "employee.import.history.dialog.notFound": "Cette importation est introuvable.",
    "employee.import.history.dialog.title": "Détails de l’importation",
    "employee.import.history.dialog.warningsCount": "1 avertissement",
    "employee.import.history.dialog.warningsCount.plural": "{{count}} avertissements",
    "employee.import.history.empty": "Aucune importation pour le moment.",
    "employee.import.history.loadError": "Une erreur s’est produite lors du chargement de l’historique des importations. Veuillez réessayer.",
    "employee.import.history.status.error": "Erreur",
    "employee.import.history.status.processing": "Traitement en cours",
    "employee.import.history.title": "Historique des importations",
    "employee.import.history.viewDetails": "Voir les détails...",
    "employee.import.importEmployees": "Importer des employés",
    "employee.import.importFile": "Importer le fichier",
    "employee.import.importType": "Type d'importation",
    "employee.import.instructions": "Cette action met à jour les données des employés en fonction du contenu du fichier d'importation et de votre paramètre de type d'importation.",
    "employee.import.instructions.generated-file": "Veuillez utiliser le <0>fichier type généré</0> pour un formatage adéquat.",
    "employee.import.is-valid": "Le fichier téléversé n'a aucun problème.",
    "employee.import.override": "Cette action écrasera le fichier de l'employé actuel et le remplacera par le fichier en cours de téléchargement. REMARQUE : tout employé ne figurant pas sur la nouvelle liste sera marqué comme désactivé",
    "employee.import.override.description": "Outre l'ajout de nouveaux employés et la mise à jour de ceux existants, les employés ne figurant pas dans le fichier d'importation seront désactivés.",
    "employee.import.scheduled.message": "Nous vous enverrons un e-mail dès que l'importation de votre dossier d'employé sera terminée.",
    "employee.import.scheduled.title": "L'importation a commencé",
    "employee.import.selectFile": "Sélectionner un fichier (.xlsx ou .csv)",
    "employee.import.success": "Données d'employé importées avec succès",
    "employee.import.title": "Importer les données des employés",
    "employee.import.update": "Cette action mettra à jour le fichier existant avec toute nouvelle information sur le fichier en cours de téléchargement",
    "employee.import.update.description": "Les données des employés contenues dans le fichier seront utilisées pour en créer de nouveaux et mettre à jour les données de ceux existants",
    "employee.import.validating-file": "Détection de problèmes dans le fichier...",
    "employee.import.warning.accept-deactivated.employees": "Je comprends que $t(employés, {\"count\": {{employees}}}) seront désactivés",
    "employee.import.warning.accept-deactivated.users": "Je comprends que $t(utilisateurs, {\"count\": {{users}}}) seront désactivés",
    "employee.import.warning.accept-deactivated.users-and-employees": "Je comprends que $t(utilisateurs, {\"count\": {{users}}}) et $t(employés, {\"count\": {{employees}}}) seront désactivés",
    "employee.import.warning.deactivatedEmployees": "Si vous poursuivez cette importation, les employés suivants seront désactivés :",
    "employee.import.warning.deactivatedUsers": "Si vous poursuivez cette importation, les utilisateurs suivants seront désactivés :",
    "employee.import.warning.title": "Avertissement de désactivation",
    "employee.list.lastUpdated": "Dernière mise à jour : {{date}}",
    "employee.update-ids.description": "Cette action mettra à jour de manière irréversible l'ID de l'employé pour toutes les personnes incluses dans le fichier.",
    "employee.update-ids.employee-id": "Identifiant d'employé",
    "employee.update-ids.error.blankCurrentIds": "Identifiants actuels absents",
    "employee.update-ids.error.blankNewIds": "Nouveaux identifiants absents",
    "employee.update-ids.error.duplicatedCurrentIds": "Identifiants actuels en double",
    "employee.update-ids.error.duplicatedNewIds": "Nouveaux identifiants en double",
    "employee.update-ids.error.empty-new-id": "L'identifiant du nouvel employé ne peut pas être vide",
    "employee.update-ids.error.file-validation": "Le fichier téléversé présente des problèmes, veuillez les corriger et le téléverser à nouveau.",
    "employee.update-ids.error.invalidCurrentIds": "Les identifiants actuels n'existent pas",
    "employee.update-ids.error.occupied-new-id": "L'identifiant du nouvel employé est déjà pris. Veuillez en entrer un autre.",
    "employee.update-ids.error.occupiedNewIds": "Nouveaux identifiants déjà pris",
    "employee.update-ids.error.row-no": "Rangée n°",
    "employee.update-ids.error.unable-update": "Impossible de mettre à jour l'identifiant de l'employé de l'entreprise",
    "employee.update-ids.individual.title": "Mettre à jour l'identifiant d'employé",
    "employee.update-ids.sampleFile1": "Veuillez utiliser le",
    "employee.update-ids.sampleFile2": "pour un formatage correct.",
    "employee.update-ids.success": "Identifiants d'employés mis à jour avec succès.",
    "employee.update-ids.success-completed": "Identifiants d'employés mis à jour avec succès.",
    "employee.update-ids.title": "Mise à jour en masse des identifiants d'employés",
    "employee.update-ids.updating": "Mise à jour des identifiants d'employés",
    "employee.update-ids.upload-file": "Téléverser le fichier",
    "employee.upload-ids.validate.loading": "Détection de problèmes dans le fichier",
    "employee.upload-ids.validate.pass": "Le fichier téléversé n'a aucun problème.",
    "employee.upload.employeeData": "Données de l'employé",
    "employee.upload.mismatch": "Il y a des champs incompatibles dans votre fichier",
    "employee.upload.uniqueConflict": "Employé : {{firstEmployee}} et employé : {{lastEmployee}} utilisent la même valeur: {{value}} pour l'attribut : {{name}}",
    "employee.upload.updateEmployeeIds": "Mise à jour en masse des identifiants d'employés",
    "employees.accessChange.attributeFrom": "{{attribute}} change de",
    "employees.accessChange.attributeTo": "à",
    "employees.accessChange.begin": "Employés dont l’accès aux données va changer :",
    "employees.accessChange.desc": "Le ou les employés suivants sont aussi des utilisateurs qui ont accès aux données du sondage en fonction de leurs attributs d’employé. En continuant cette modification, leur accès aux données du sondage va changer. Voulez-vous continuer?",
    "employees.accessChange.title": "Attention! L’accès aux données du sondage va changer pour certains utilisateurs.",
    "employees.export.success": "Employés exportés vers le fichier '{{filename}}'.",
    "employees_one": "{{count}} employé",
    "employees_other": "{{count}} employés",
    "en-ca": "Anglais",
    "en-us": "Anglais (US)",
    "entities.table.entity": "Entité",
    "entities.table.frequency": "Fréquence",
    "entities.table.sentiment": "Sentiment",
    "entities.table.type": "Type",
    "error.create.roleName.required": "Le nom du rôle est obligatoire.",
    "error.invite.all.emails.valid": "tous les e-mails doivent être valides",
    "error.invite.at.least.one.email": "besoin d'au moins une adresse e-mail",
    "error.invite.at.least.one.survey.type.permission": "nécessite au moins une autorisation de type d'enquête",
    "error.invite.from.required": "du nom est requis",
    "error.invite.include.all.compare.attributes.in.filter.attributes.list": "Ajouter les attributs de la liste \"{{compareAttributesHeader}}\" qui ne figurent pas dans la liste \"{{filterAttributesHeader}}\".",
    "error.invite.language.required": "la langue est requise",
    "error.invite.oops": "Oups, on dirait qu'il nous manque quelque chose",
    "error.invite.please.check.validations": "Veuillez vérifier les validations suivantes :",
    "error.lockedOut": "Vous avez dépassé le nombre maximum autorisé de tentatives de connexion. Pour déverrouiller votre compte, réinitialisez votre mot de passe.",
    "error.msg.invalid.employee": "Identifiant d'employé invalide",
    "error.msg.you.have.exceeded.max.login.attempts": "Vous avez dépassé le nombre maximum autorisé de tentatives de connexion. Pour déverrouiller votre compte, réinitialisez votre mot de passe en cliquant sur \"Mot de passe oublié ?\" lien ci-dessous.",
    "error.no.employee.matching.hierarchy.user": "Pour inviter des utilisateurs avec un accès basé sur la hiérarchie ou un accès basé sur des attributs personnalisés, ils doivent être répertoriés comme employés",
    "error.roleName.duplicated": "Le nom du rôle existe déjà!",
    "error.somethingWentWrong": "Une erreur est survenue",
    "error.validationError": "Erreur de validation",
    "errorBoundary.errorPreDescription": "Détails de l'erreur qui peuvent aider nos techniciens à diagnostiquer le problème :",
    "errorBoundary.headImageAltText": "Un serveur se trouve sur le côté droit, tandis qu'au centre se trouve la prise non branchée.",
    "errorBoundary.resetButton": "Recharger cette page",
    "errorBoundary.subtitle": "Le système a rencontré une erreur inattendue. Veuillez essayer de recharger la page.",
    "errorBoundary.title": "Oups !",
    "errors.tokenExpired": "veuillez ouvrir une session",
    "es-es": "Espagnol",
    "export.all": "Toutes les données",
    "export.attributeType": "Type d'attribut",
    "export.attributesSelected": "Attributs sélectionnés :",
    "export.comment": "Commentaire",
    "export.compareTo": "Comparer à :",
    "export.favourable": "Favorable",
    "export.filterSelected": "Filtre sélectionné :",
    "export.header": "Exporter",
    "export.neutral": "Neutre",
    "export.outof": "Sur",
    "export.overallResponseRate": "Taux de réponse globale",
    "export.qualitative": "Données qualitatives",
    "export.quantitative": "Données quantitatives",
    "export.question": "Question :",
    "export.surveySelected": "Sondage sélectionné :",
    "export.themes": "Thèmes de l'IA",
    "export.title.timeframe-selected": "Délai choisi :",
    "export.unfavourable": "Défavorable",
    "exportMenu.errorDialog.message": "Échec de la génération de l’exportation sommaire.",
    "exportMenu.export": "Exportation",
    "exportMenu.loadingDialog.message": "Nous sommes en train de créer votre exportation. Le téléchargement devrait commencer dans la prochaine minute.",
    "exportMenu.loadingDialog.title": "Votre exportation sera prête sous peu.",
    "factor": "Le facteur",
    "factor.score": "Score factoriel",
    "factors": "Les facteurs",
    "factors.filter.prompt": "Sélectionner un facteur",
    "factors.questions": "Question des facteurs",
    "favorable.button.text": "FAV",
    "feedback.email.subject.anon.reaction": "Votre rétroaction strictement confidentielle a bien été reçue.",
    "fi-fi": "Finlandais",
    "field.isRequired": "{{field}} est un champ obligatoire.",
    "fieldType.boolean": "Oui/Non",
    "fieldType.date": "Date",
    "fieldType.email": "Courriel",
    "fieldType.number": "Numéro",
    "fieldType.string": "Texte",
    "fieldType.time": "Heure",
    "filter.attributes.main": "Sélectionner un attribut",
    "filter.attributes.values": "Sélectionner la ou les valeurs d'attribut",
    "filter.by.factors": "Filtrer par facteurs",
    "filter.byAttribute": "Filtrer par attribut",
    "filter.date.startMessage": "Afficher tous les destinataires avec un",
    "filter.date.title": "Filtrer par Date de début",
    "filter.dateRange.clear": "Effacer la plage de dates",
    "filter.dateRange.title": "Sélectionner une plage de dates",
    "filter.filterBy": "Filtrer par",
    "filter.message": "Rechercher un message ...",
    "filter.question": "Filtrer par question",
    "fixed_eyes": "Yeux",
    "fixed_faces_1": "Visages 1",
    "fixed_faces_2": "Visages 2",
    "fixed_flowers": "Fleurs",
    "fixed_gas_tank": "Réservoir d’essence",
    "fixed_generation": "Génération",
    "fixed_glasses_of_water": "Verres d’eau",
    "fixed_growing_wheels": "Évolution des roues",
    "fixed_hands": "Mains",
    "fixed_hearts_gradient": "Cœurs (gradient)",
    "fixed_hurdles": "Obstacles",
    "fixed_ice_cream_emoji": "Émoji crème glacée",
    "fixed_mad_happy_emoji": "Émoji furieux-heureux",
    "fixed_magnifying_glass": "Lloupe",
    "fixed_mood_weather": "Humeur du temps",
    "fixed_office": "Bureau",
    "fixed_overwhelmed_happy_emoji": "Émoji submergé-heureux",
    "fixed_poo_emoji": "Émoji crotte",
    "fixed_rockets": "Rockets",
    "fixed_sad_happy_emoji": "Émoji triste-heureux",
    "fixed_stairs": "Escaliers",
    "fixed_teal_rose": "Rose épanouie",
    "fixed_technology": "Technologie",
    "fixed_thumbs_rotating": "Pouces tournants",
    "fixed_trophies": "Trophées",
    "fixed_type_of_work": "Types de travail",
    "fixed_workplace_flexibility": "Flexibilité du milieu du travail",
    "forgot.password.dialog.description": "Le lien de réinitialisation de votre mot de passe est en route!",
    "forgot.password.dialog.title": "Vérifiez votre boîte de réception!",
    "forgot.password.instruction": "Ne vous inquiétez pas, cela nous arrive à tous. Ajoutez votre adresse courriel ci-dessous et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "form.dependsOn": "Le champ {{label}} est obligatoire",
    "form.exit": "Fermer",
    "form.fileError": "Veuillez vérifier les champs suivants dans votre fichier",
    "form.fileSelected": "Fichier sélectionné :",
    "form.invalid": "Oups, veuillez vérifier vos commentaires!",
    "form.invalidAttribute": "L'attribut '{{name}}' n'est pas valide",
    "form.isBoolean": "Ce champ doit être vrai/faux",
    "form.isDate": "Ce champ doit être de type AAAA-MM-JJ",
    "form.isEmail": "Ce champ doit être un courriel",
    "form.isNotA": "'{{value}}' n'est pas un {{type}}",
    "form.isNumber": "Ce champ doit être un nombre",
    "form.isRequired": "Ce champ est requis",
    "form.isUnique": "Ce champ doit être unique",
    "form.row": "Ligne",
    "fr-ca": "Français (CA)",
    "fr-fr": "Français (FR)",
    "gemAI.dialog.title": "Invite et réponse de l'IA générative",
    "genAI.button.awaiting-response": "En attente d'une réponse de l'IA",
    "genAI.button.export-ai-data": "Démarrer l'exportation de données IA",
    "genAI.button.send-prompt": "Renvoyer l'invite et sauvegarder la nouvelle réponse",
    "genAI.commentAnalysis.deleteDialog.confirmButton": "Oui, supprimer",
    "genAI.commentAnalysis.deleteDialog.confirmText": "Voulez-vous vraiment supprimer cette analyse?",
    "genAI.commentAnalysis.deleteDialog.descriptionText": "Cette action supprimera définitivement le <0>résumé du commentaire</0> généré par IA et vous permettra d'en générer un nouveau. Veuillez noter que le nouveau commentaire pourrait être différent de celui d'origine, soit dans le style, soit dans son contenu. Cela est particulièrement vrai dans les cas où l'invite ou l'algorithme d'IA a été mis à jour entre le moment présent et la dernière fois qu'il a été généré.",
    "genAI.commentAnalysis.deleteDialog.error": "Erreur pendant la suppression de l'analyse IA. Réessayer.",
    "genAI.commentAnalysis.deleteDialog.success": "Analyse IA supprimée avec succès.",
    "genAI.commentAnalysis.deleteDialog.title": "Supprimer l'analyse IA",
    "genAI.comments.analysis": "Analyse IA",
    "genAI.comments.analysis-available": "L'analyse IA est disponible",
    "genAI.comments.analysis-negatives": "Les négatifs",
    "genAI.comments.analysis-next-steps": "Actions recommandées",
    "genAI.comments.analysis-not-performed": "Demander à l'IA d'interpréter les résultats?",
    "genAI.comments.analysis-positives": "Les points positifs",
    "genAI.comments.analysis-summary": "En bref",
    "genAI.comments.analyzing": "L'IA analyse les résultats...",
    "genAI.comments.continuous-survey.analyze": "Demander à l'IA d'interpréter les résultats pour cette période ?",
    "genAI.comments.continuous-survey.failed-load": "Un problème est survenu lors du traitement de votre demande. Demandez à l'IA de réessayer d'interpréter les résultats pour cette période ?",
    "genAI.comments.failed-load": "Le traitement de votre demande a posé problème. Demander à l'IA de réessayer d'interpréter les résultats ?",
    "genAI.debug-mode": "Mode débogage IA",
    "genAI.dialog.context-label": "Contexte utilisé pour initier l'IA",
    "genAI.dialog.prompt-label": "Invite utilisée pour générer la réponse",
    "genAI.dialog.response-label": "Réponse IA brute",
    "genAI.dialog.sentiment-label": "Sentiment analysé",
    "genAI.dialog.theme-label": "Thème(s) clé(s) analysé(s)",
    "genAI.export.AI-generated-data": "Données générées par IA",
    "genAI.export.AI-report-dialog.title": "Télécharger les données générées par IA",
    "genAI.export.ai-report.text1": "Cette action initiera la collecte de toutes les données générées par l'IA pour ce sondage et les compilera dans un fichier Excel. Le fichier sera mis à disposition pour <0>téléchargement unique</0> par le biais d'un lien électronique envoyé à l'adresse suivante :",
    "genAI.export.ai-report.text2": "Veuillez vous assurer que l'adresse courriel ci-dessus est correcte avant de demander le lancement de l'exportation.",
    "genAI.label.find-in-comments": "Trouver dans les commentaires",
    "genAI.not-available": "Indisponible",
    "genAI.question.analysis-generated": "Analyse IA générée",
    "genAI.question.analysis-not-performed": "Analyse IA non exécutée",
    "genAI.surveys.analysis-areas-of-opportunity": "Domaines d'opportunités",
    "genAI.surveys.analysis-areas-to-watch": "Zones à surveiller",
    "genAI.surveys.analysis-overall-summary": "Bref résumé général des résultats",
    "genAI.surveys.analysis-participation-rate": "Taux de participation",
    "genAI.surveys.analysis-qualitative-feedback": "Résumé des commentaires qualitatifs",
    "genAI.surveys.analysis-recommended-actions": "Actions recommandées",
    "genAI.surveys.analysis-strengths": "Points forts",
    "genAI.title.key-theme": "Thème clé",
    "genAi.comments.error.rate-limit": "Vous avez dépassé notre limite de débit pour cette fonctionnalité de l'IA. La limite actuelle autorise un maximum de 20 résumés par période de 10 minutes. L'accès sera rétabli dans les 10 prochaines minutes. Nous vous remercions de votre patience.",
    "genAi.comments.translationNotification": "Veuillez noter que le résumé ci-après a été traduit de l’anglais.",
    "genai.": "",
    "genai.analysis-type.comment-analysis": "Analyse des sentiments des commentaires",
    "genai.analysis-type.comments-summary": "Résumé des commentaires",
    "genai.analysis-type.rating-question-summary": "Résumé de la question d'évaluation",
    "genai.analysis-type.theme-association": "Association thématique",
    "genai.analysis-type.theme-extraction": "Extraction de thèmes",
    "genai.button.config-prompts": "Configurer les invites",
    "genai.prompt-custom.token-label": "Jetons disponibles :",
    "general.clearAll": "Tout effacer",
    "general.here": "ici",
    "global.error.500": "La demande a échoué, veuillez actualiser la page ou réessayer plus tard!",
    "graph.average": "Moyenne",
    "graph.detractors": "Détracteurs",
    "graph.favorable": "Favorable",
    "graph.neutral": "Neutre",
    "graph.passives": "Passifs",
    "graph.promoters": "Promoteurs",
    "graph.respondents": "{{answered}} sur {{total}} personnes ont répondu",
    "graph.unfavorable": "Défavorable",
    "group.delete": "Supprimer",
    "has.suggestions.description": "Voici les actions et les apprentissages que nous recommandons en fonction des résultats de votre enquête.",
    "header.actionContent": "Contenu de l’action",
    "header.help": "Aide",
    "header.learning-content": "Contenu d’apprentissage",
    "header.logout": "Déconnexion",
    "header.profile": "Profil",
    "header.signin": "Connexion",
    "header.surveyTemplates": "Modèles",
    "header.switch": "Changer de compte",
    "heatmap.allAnonymized.tooltip": "L'option « Tout anonymisé » comprend un maximum de {{ fully }} réponses d'employés entièrement anonymisées et {{ partial }} questions partiellement anonymisées en raison de conditions d'attributs ou de la logique des questions. Consultez l'article pour en savoir plus.",
    "heatmap.compare.empty": "Aucune donnée disponible car il n'y avait pas de {{filter}} dans {{compare}}",
    "heatmap.header": "Carte thermique",
    "heatmap.hide.empty.columns": "Masquer les colonnes vides",
    "heatmap.legend.highest": "Le plus élevé",
    "heatmap.legend.least.favorable": "Le plus bas Favorable",
    "heatmap.legend.lowest": "Le plus bas",
    "heatmap.legend.most.favorable": "Le plus élevé Favorable",
    "heatmap.legend.negative": "Défavorable",
    "heatmap.legend.positive": "Favorable",
    "heatmap.legend.text": "Les données reflètent les valeurs minimales et maximales des réponses à votre sondage",
    "heatmap.overall": "globalement",
    "heatmap.responses": "Nombre de réponses",
    "heatmap.score": "Pointage",
    "heatmap.show.categories": "Facteurs",
    "heatmap.show.questions": "Questions",
    "help.email.header": "Envoyez-nous un courriel.",
    "help.email.message": "Envoyez-nous un courriel à",
    "help.guides.header": "Guide d’utilisation",
    "help.guides.linkText": "Cliquez ici pour notre guide de l'utilisateur",
    "help.guides.message": "Lisez notre guide d’utilisation qui couvre toutes les sections de cette plateforme.",
    "help.header": "Aide",
    "help.intercom.header": "Clavardage en direct",
    "help.intercom.message": "Clavardez avec nous pendant les heures d’ouverture. Cliquez sur la bulle de texte en bas à gauche (si vous ne la voyez pas, veuillez essayer d’actualiser votre navigateur).",
    "help.roadmap.title": "Notre feuille de route actuelle",
    "hi-in": "Hindi",
    "hide": "Masquer",
    "hierarchy.turnedOffReason": "WorkTango Hierarchy Heatmap sera temporairement indisponible à partir du mardi 25 novembre 2025 à 17 h 00 (heure de l'Est) pour la mise en œuvre des mises à jour. Le service reprendra immédiatement une fois les mises à jour terminées. Nous vous prions de nous excuser pour la gêne occasionnée.",
    "highest.label": "Le plus élevé",
    "hour": "heure",
    "hours": "heures",
    "hu-hu": "Hongrois",
    "id-id": "Indonésien",
    "image.aspect": "Le rapport d’aspect de l’image devrait être environ {{x}}:{{y}}",
    "importing": "Importation...",
    "in.progress": "En cours",
    "inbox.header": "Conversations",
    "insights.bad": "LE MAUVAIS",
    "insights.explainertext.bad": "Les domaines susceptibles d’être améliorés sont indiqués ci-dessous.",
    "insights.explainertext.good": "Vous faites du très bon travail dans ces domaines, et vos employés le remarquent!",
    "insights.explainertext.ugly": "Ces domaines exigent une attention immédiate.",
    "insights.good": "LE BON",
    "insights.ugly": "LE PIRE",
    "invalid.email.format": "L’adresse courriel est dans le mauvais format, veuillez réessayer",
    "invite.new": "Inviter de nouveaux",
    "invites.pending.delete": "Supprimer les invitations en attente",
    "invites.pending.delete.confirm": "Voulez-vous supprimer ces invitations en suspens?",
    "is.platform.user.export.column.name": "Est un utilisateur",
    "it-it": "Italien",
    "jp-jp": "Japonais",
    "keyFactor": "Facteur clés",
    "keyFactors": "Facteurs clés",
    "keyQuestions": "Questions sur les facteurs clés",
    "ko-kr": "Coréen",
    "kw.custom.access.not.set.up.check.back.later": "Veuillez revérifier plus tard.",
    "kw.custom.access.not.set.up.yet": "Votre accès est encore en cours de configuration par votre administrateur, et vous pouvez le contacter pour obtenir une mise à jour sur le statut.",
    "kw.permission.setup.in.progress": "Configuration d'autorisation en cours",
    "label.invite.users": "Inviter de nouveaux utilisateurs",
    "label.no.filters": "Aucun résultat trouvé pour les filtres sélectionnés. Essayez un autre jeu de filtres.",
    "language": "Langue",
    "language.code.desc": "Veuillez utiliser le code de langue WorkTango correspondant dans la colonne Langue lorsque vous importez de nouveaux employés",
    "languageCode": "Codes de langues",
    "layout.cardview": "Vue de la carte",
    "layout.listview": "Affichage de la liste",
    "learning": "Apprentissage",
    "less.than.an.hour": "moins d'une heure",
    "lifecycle.survey.email.access.outbox": "Accédez à la boîte d'envoi",
    "lifecycle.survey.email.access.outbox.weekly.digest": "Voir qui sera prochainement invité",
    "lifecycle.survey.email.digest.explainer": "Les employés suivants ont été automatiquement ajoutés à un sondage WorkTango",
    "lifecycle.survey.email.digest.subject": "Rapport d'invitations à des sondages automatisés pour la semaine écoulée",
    "lifecycle.survey.outbox.candidate.was.invited": "%employeeName% a été invité le %targetInvitationDate% à %surveyName%",
    "lifecycle.survey.outbox.candidate.will.be.invited": "%employeeName%, à inviter le %targetInvitationDate% pour %surveyName%",
    "lifecycle.survey.outbox.employees.added.exit": "Les employés suivants ont été identifiés comme candidats à un sondage de sortie et ont été placés dans la Boîte d'envoi. Vous pouvez consulter la liste intégrale en suivant le lien ci-dessous.",
    "lifecycle.survey.outbox.employees.added.onboarding": "Les employés suivants ont été identifiés comme candidats à une enquête d'intégration et ont été placés dans la boîte d'envoi. Vous pouvez consulter la liste complète en suivant le lien ci-dessous.",
    "lifecycle.survey.outbox.updated.header.exit": "La boîte d'envoi du sondage de sortie a été mise à jour",
    "lifecycle.survey.outbox.updated.header.onboarding": "La Boîte d'envoi du sondage d'intégration a été mise à jour",
    "lifecycle.survey.outbox.updated.subject.exit": "Boîte d'envoi de sortie mise à jour",
    "lifecycle.survey.outbox.updated.subject.onboarding": "Boîte d'envoi d'intégration mise à jour",
    "lifecycle.survey.weekly.digest.email.header": "Condensé du sondage sur le cycle de vie hebdomadaire",
    "loading": "Chargement... Veuillez patienter",
    "login.error": "Nom d'utilisateur ou mot de passe incorrect fourni",
    "login.expired.desc": "Veuillez ouvrir une nouvelle session pour accéder à WorkTango.",
    "login.expired.title": "Votre session est expirée",
    "login.improve.question": "Vous cherchez à améliorer l’engagement de votre organisation?",
    "login.instruction.email": "Saisissez votre adresse courriel pour continuer",
    "login.instruction.password": "Saisissez votre mot de passe pour ouvrir une session",
    "login.migrated.desc.first": "Veuillez utiliser",
    "login.migrated.desc.last": "pour accéder à WorkTango.",
    "login.migrated.success": "Bonne nouvelle! Votre organisation est maintenant sur la nouvelle plateforme WorkTango!",
    "login.sso.failed.desc": "La connexion par l’intermédiaire du SSO de votre entreprise n’a pas pu être effectuée. Veuillez communiquer avec votre administrateur TI ou le soutien de WorkTango et fournir cette référence : {{reference}}",
    "lowest.label": "Le plus bas",
    "mailing-list.automatic-invitations": "Invitations automatiques",
    "mailing-list.automatic-invitations.add-not-contact.modal.confirm-button": "Ajouter à la liste",
    "mailing-list.automatic-invitations.add-not-contact.modal.confirm-label": "Motif de l'ajout",
    "mailing-list.automatic-invitations.add-not-contact.modal.confirm-placeholder": "Entrez un motif d'ajout de cet employé",
    "mailing-list.automatic-invitations.add-not-contact.modal.description": "L'ajout d'une personne à cette liste signifie qu'elle ne reçoit plus des invitations automatisées à des sondages, mais qu'elle peut toujours être invitée manuellement à participer à des sondages.",
    "mailing-list.automatic-invitations.add-not-contact.modal.description2": "Vous ou un autre administrateur ayant accès à la liste pourrez annuler cette action en accédant à la liste et en la supprimant ultérieurement, si nécessaire. Le motif de l'ajout sera indiqué.",
    "mailing-list.automatic-invitations.add-not-contact.modal.title": "Ajouter {{user}} à la liste Ne pas contacter?",
    "mailing-list.automatic-invitations.approve-all.modal.confirm-button": "Oui, approuver tout",
    "mailing-list.automatic-invitations.approve-all.modal.description": "Cette action approuvera l'envoi de l'invitation à tous les candidats à leur date d'invitation individuelle.",
    "mailing-list.automatic-invitations.approve-all.modal.description2": "Voulez-vous vraiment approuver ces invitations?",
    "mailing-list.automatic-invitations.approve-all.modal.title": "Approuver 1 candidats?",
    "mailing-list.automatic-invitations.approve-all.modal.title-plural": "Approuver {{count}} candidats?",
    "mailing-list.automatic-invitations.bulk-actions": "Actions en bloc",
    "mailing-list.automatic-invitations.bulk-actions-with-count": "Actions en bloc ({{count}} sélectionnées)",
    "mailing-list.automatic-invitations.bulk-actions.disabled": "Veuillez d'abord sélectionner les candidats pour lesquels vous souhaitez effectuer des actions groupées",
    "mailing-list.automatic-invitations.bulk-add-not-contact.modal.title": "Ajouter les utilisateurs {{count}} à la liste des personnes à ne pas contacter ?",
    "mailing-list.automatic-invitations.button.add-to-not-contact": "Ajouter à la liste « Ne pas contacter »",
    "mailing-list.automatic-invitations.button.approve": "Approuver",
    "mailing-list.automatic-invitations.button.approve-and-invite": "Approuver et inviter immédiatement",
    "mailing-list.automatic-invitations.button.bulk-approve": "Approuver sélectionné",
    "mailing-list.automatic-invitations.button.bulk-approve-and-invite": "Approuvé sélectionné et invité immédiatement ",
    "mailing-list.automatic-invitations.button.bulk-remove": "Supprimer de la liste",
    "mailing-list.automatic-invitations.button.invite": "Inviter immédiatement",
    "mailing-list.automatic-invitations.button.remove": "Supprimer de la liste?",
    "mailing-list.automatic-invitations.button.undo-approval": "Annuler l'approbation",
    "mailing-list.automatic-invitations.column.addedToList": "Ajouté à la liste",
    "mailing-list.automatic-invitations.column.candidateName": "Nom du candidat",
    "mailing-list.automatic-invitations.column.exitDate": "Date de sortie",
    "mailing-list.automatic-invitations.column.startDate": "Date de début",
    "mailing-list.automatic-invitations.column.status": "Statut",
    "mailing-list.automatic-invitations.column.surveyName": "Nom du sondage",
    "mailing-list.automatic-invitations.column.targetInvitationDate": "Date d'invitation cible",
    "mailing-list.automatic-invitations.onboarding-survey.description": "Le système identifie les employés suivants devant être invités à renseigner leur sondage à la date cible.",
    "mailing-list.automatic-invitations.onboarding-survey.description2": "Veuillez vous reporter à la liste et supprimer les personnes auxquelles vous ne souhaitez pas qu'une invitation soit adressée, ou les placer sur la liste « Ne pas contacter » si vous voulez reporter l'invitation pour une durée indéterminée.",
    "mailing-list.automatic-invitations.onboarding-survey.filter-candidates": "Filtrer les candidats",
    "mailing-list.automatic-invitations.onboarding-survey.filter-surveys": "Filtrer les sondages",
    "mailing-list.automatic-invitations.onboarding-survey.title": "Candidats au sondage",
    "mailing-list.automatic-invitations.snackbar.add-to-not-contact": "Personne ajoutée avec succès à la liste Ne pas contacter",
    "mailing-list.automatic-invitations.snackbar.approve": "Statut mis à jour avec succès",
    "mailing-list.automatic-invitations.snackbar.approve-all": "Invitations approuvées avec succès",
    "mailing-list.automatic-invitations.snackbar.error": "Un problème est survenu lors de l'ajout de cette personne au sondage. Veuillez actualiser l'écran et réessayer",
    "mailing-list.automatic-invitations.snackbar.invite": "Invitation envoyée avec succès",
    "mailing-list.automatic-invitations.snackbar.remove": "Personne supprimée avec succès",
    "mailing-list.automatic-invitations.table.no-data": "Aucun candidat ne correspond à vos filtres.",
    "mailing-list.automatic-invitations.tooltip.approved": "Vous avez choisi de ne pas approuver manuellement les invitations, mais de les envoyer automatiquement dès le lendemain de l'ajout de l'employé. Si vous souhaitez modifier ce paramètre, accédez aux paramètres d'Automatisation du sondage auprès des entreprises.",
    "mailing-list.automatic-invitations.trigger-type.exit": "Uniquement les sondages de sortie",
    "mailing-list.automatic-invitations.trigger-type.onboarding": "Uniquement les sondages d'intégration",
    "mailing-list.blocked-recipients": "Destinataires bloqués",
    "mailing-list.do-not-contact": "Ne pas contacter",
    "mailing-list.title": "Gestion de la liste de distribution",
    "message.deleteSurveyWarning": "Voulez-vous vraiment supprimer ce sondage?",
    "message.stopSurveyWarning": "Voulez-vous vraiment annuler l'envoi de ce sondage?",
    "minute": "minute",
    "minutes": "minutes",
    "month": "Mois",
    "ms-my": "Malais (latin)",
    "my-mm": "Birman",
    "nav.leave.surveys.and.insights": "Quitter Sondages et informations",
    "nav.sidebar.title.surveys.and.insights": "Sondages et informations",
    "nb-no": "Norvégien Bokmål",
    "next": "Suivant",
    "nl-nl": "Néerlandais",
    "no.base.survey.type": "Inconnu",
    "no.common.questions": "Il n'y a pas de questions communes dans les enquêtes sélectionnées.",
    "no.conversations": "Il n'y a aucune conversation pour le moment.",
    "no.employee": "Aucun employé trouvé",
    "no.libraryActions": "Il n’y a aucune action de la bibliothèque.",
    "no.reminders": "Aucun rappel n’est actuellement prévu pour ce sondage.",
    "no.reponseRate.text": "Il n'y a pas encore de réponse pour le sondage actuel.",
    "no.results.filter": "Aucun résultat pour les filtres sélectionnés",
    "no.suggestions.description": "Désolé, nous n’avons pas d’actions recommandées pour les enquêtes ou les filtres que vous consultez.",
    "no.survey.instructions": "Veuillez ajuster votre série de données pour analyser vos résultats.",
    "no.survey.text": "Sélectionnez un type de sondage",
    "no.surveyData.text": "Il n'y a pas de données quantitatives dans les sondages sélectionnés",
    "no.trend.text": "Sélectionner plus d’un sondage pour afficher les résultats de tendance.",
    "noAttributeValues": "Aucune valeur trouvée pour cet attribut",
    "noCanvasSupport": "Votre navigateur ne supporte pas le canvas. Le graphique à barres ne peut pas être affiché.",
    "note.survey.question.active.between": "Note : Cette question était active de {{added-date}} à {{discontinued-date}}",
    "note.survey.question.added": "Note : Cette question a été introduite pour la première fois le {{added-date}}",
    "note.survey.question.discontinued": "Note : Cette question a été abandonnée le {{discontinued-date}}",
    "notice.leave.title": "Voulez-vous vraiment quitter cette page?",
    "notifications.current.password.incorrect": "Le mot de passe actuel fourni est incorrect.",
    "notifications.message.actionCreated": "Action créée avec succès",
    "notifications.message.actionRemoved": "Action supprimée avec succès",
    "notifications.message.actionUpdated": "Action mise à jour avec succès",
    "notifications.message.categoryCreated": "Facteur créé avec succès",
    "notifications.message.categoryRemoved": "Facteur supprimé avec succès",
    "notifications.message.categoryUpdated": "Facteur mis à jour avec succès",
    "notifications.message.companyDeleted": "L’entreprise et les données associées ont été supprimées!",
    "notifications.message.companyUpdated": "Entreprise mise à jour avec succès",
    "notifications.message.employeeCreated": "Employé créé avec succès",
    "notifications.message.employeeUpdates": "Employé mis à jour avec succès",
    "notifications.message.surveyTypeCreated": "Type de sondage créé avec succès",
    "notifications.message.surveyTypeUpdated": "Type de sondage mis à jour avec succès",
    "notifications.message.templateCreated": "Action de la bibliothèque créée avec succès",
    "notifications.message.templateRemoved": "Action de la bibliothèque supprimée avec succès",
    "notifications.message.templateUpdated": "Action de la bibliothèque mise à jour avec succès",
    "notifications.message.userPermissionsUpdated": "Autorisations utilisateur mises à jour avec succès",
    "notifications.profile.updateSuccessful": "Votre profil a été mis à jour avec succès.",
    "notifications.title.done": "Effectué",
    "notifications.title.newAction": "Nouvelle action",
    "notifications.title.survey-migration": "Migration des données entamée",
    "nps.delta": "Pointage eNPS",
    "on": "Le",
    "oops.something.went.wrong": "Oups, quelque chose s'est mal passé",
    "openEnded": "OUVRIR TERMINÉ",
    "origin.source": "Source",
    "overview.aboveOrgWide": "Note supérieure à l’échelle de l’organisation",
    "overview.anonymized": "Anonymisé",
    "overview.attributeAnonymized": "Pas assez de réponses pour respecter le seuil d’anonymat",
    "overview.attributeBetterOrg": "Principaux attributs affichant un meilleur rendement par rapport à l’ensemble de l’organisation",
    "overview.attributeCantDisplay": "Les attributs principaux ne peuvent pas être affichés",
    "overview.attributeDecrease": "Principaux attributs affichant les plus fortes baisses",
    "overview.attributeIncrease": "Principaux attributs affichant les plus fortes augmentations",
    "overview.attributeWorseOrg": "Principaux attributs affichant un rendement inférieur à celui de l’ensemble de l’organisation",
    "overview.belowOrgWide": "Note inférieure à l’échelle de l’organisation",
    "overview.bottom25org": "Ce {{name}} se classe parmi les 25 % inférieurs de l’organisation!",
    "overview.compareToEmpty": "Par rapport à la valeur de la dernière enquête, sans objet",
    "overview.emptyPage": "Il n’y a pas de données quantitatives pour les enquêtes que vous avez sélectionnées ou il n’y a pas suffisamment de réponses en fonction de votre seuil de confidentialité. Veuillez vérifier plus tard.",
    "overview.enps": "Les scores eNPS vont de -100 à 100",
    "overview.factorSummary": "Résumé des facteurs",
    "overview.from": "de",
    "overview.highlights": "Points saillants",
    "overview.label": "Aperçu",
    "overview.lastMeasured": "Depuis le dernier sondage",
    "overview.lastSurvey": "dernière enquête",
    "overview.noLastSurvey": "Attention! C’est la première enquête du genre. Vous ne verrez donc pas d’information de comparaison pour les résultats précédents.",
    "overview.noPreviousSurvey": "Aucune enquête antérieure à comparer",
    "overview.orgDifferEnabled": "Attention! Les notes dans les premiers 25 % et les derniers 25 % ne sont disponibles que pour les gestionnaires de personnel sans autres filtres. Nous avons ajouté d’autres renseignements utiles en remplacement!",
    "overview.orgRankDisabled": "Attention! Utilisez n’importe quel filtre pour obtenir automatiquement des données de comparaison à l’échelle de l’organisation, et filtrez vers des gestionnaires de personnel précis pour voir les statistiques des 25 % supérieurs et des 25 % inférieurs.",
    "overview.orgWideBottom": "Résultats dans les 25 % inférieurs à l’échelle de l’organisation",
    "overview.orgWideEmpty": "Comparativement à la valeur à l’échelle de l’organisation, sans objet",
    "overview.orgWideIsSame": "La note est égal à la note à l’échelle de l’organisation",
    "overview.orgWideTop": "Résultats dans les 25 % supérieurs à l’échelle de l’organisation",
    "overview.orgwideCompare": "Par rapport à l'organisation",
    "overview.permissionGroup": "Selon votre accès, les groupes suivants font partie de vos résultats : {{label}}",
    "overview.questionSummary": "Résumé de la question",
    "overview.responseRate": "Taux de réponse",
    "overview.responseVolume.devices_one": "",
    "overview.responseVolume.devices_other": "",
    "overview.responseVolume.responses_one": "",
    "overview.responseVolume.responses_other": "",
    "overview.responseVolume.viewBreakdown": "",
    "overview.scoreDecrease": "Cette note a considérablement diminué!",
    "overview.scoreDifferDisabled": "Attention! Nous ne pouvons pas vous montrer les données de comparaison d’enquêtes précédentes lorsque vous consultez les données de plusieurs enquêtes.",
    "overview.scoreHugeDecrease": "Diminution significative du score",
    "overview.scoreHugeIncrease": "Augmentation significative du score",
    "overview.scoreIncrease": "Cette note a considérablement augmenté!",
    "overview.scoreIsSame": "La note n’a pas changé depuis la dernière mesure",
    "overview.seeAllFactors": "Voir tous les facteurs",
    "overview.seeAllQuestions": "Voir toutes les questions",
    "overview.seeAllScores": "Voir tous les détails de la note",
    "overview.since": "depuis",
    "overview.top25Org": "Ce {{name}} se classe parmi les 25 % supérieurs de l’organisation!",
    "overview.vsOrgWide": "par rapport à la moyenne à l’échelle de l’organisation",
    "participants-dialog.cancel": "Annuler",
    "participants-dialog.column.employee": "Employé",
    "participants-dialog.column.invited-date": "Date de l'invitation",
    "participants-dialog.column.submitted-date": "Date de soumission",
    "participants-dialog.confirm": "afficher uniquement les réponses de cette personne",
    "participants-dialog.not.yet.invited": "",
    "participants-dialog.not.yet.submitted": "Non soumis",
    "participants-dialog.search.placeholder": "Filtrer les participants",
    "participants-dialog.title": "Sélectionner un participant à l'enquête",
    "participants.actions": "Actions",
    "participants.actions.removeFromList": "Supprimer de la liste",
    "participants.actions.resend": "Renvoyer l'invitation",
    "participants.actions.revoke": "Révoquer l'accès et supprimer les données",
    "participants.addButton": "AJOUTER DES PARTICIPANTS...",
    "participants.channel.failed": "",
    "participants.channel.name.email": "",
    "participants.channel.name.sms": "",
    "participants.channel.none": "",
    "participants.channel.pending": "",
    "participants.channel.sent": "",
    "participants.channel.sms.noPhone": "",
    "participants.channel.sms.optedOut": "",
    "participants.chip.addedNotInvited": "",
    "participants.chip.alreadyInvited": "DÉJÀ INVITÉ",
    "participants.chip.deactivated": "DEACTIVATED",
    "participants.chip.invited": "Invité le {{date}}",
    "participants.chip.notInvited": "PAS ENCORE INVITÉ",
    "participants.chip.onTheList": "SUR LA LISTE",
    "participants.emptyFilter": "Aucun participant ne correspond aux filtres actuels.",
    "participants.emptyState": "Aucun destinataire n'a été sélectionné pour cette enquête.",
    "participants.filter.search": "Filtrer par le nom, l'adresse électronique ou l'identifiant du participant",
    "participants.filter.status": "Filtrer par statut du participant",
    "participants.filter.status.all": "Tous les statuts",
    "participants.filter.status.invited": "Invitation reçue",
    "participants.filter.status.notInvited": "Pas encore invité",
    "participants.groupAction": "Action de groupe pour {{count}} sélectionnée",
    "participants.groupAction.all": "Tous les participants",
    "participants.groupAction.invited": "Salariés déjà participants",
    "participants.groupAction.notInvited": "Employés non encore invités",
    "participants.groupAction.remove": "Supprimer de la liste des participants",
    "participants.groupAction.resend": "Renvoyer les invitations",
    "participants.groupAction.revoke": "Révoquer l'accès et supprimer les données",
    "participants.groupAction.unselectAll": "Désélectionner tout",
    "participants.modal.disabledCheckbox": "La case à cocher désactivée signifie que l'employé participe déjà à l'enquête",
    "participants.modal.disabledRowTooltip": "Il n'est pas possible de retirer de la liste les employés déjà invités. S'ils ont été invités par erreur, révoquez leur accès et supprimez les données de l'enquête de la liste des participants. Veuillez noter que les employés invités ne reçoivent pas un nouvel e-mail d'invitation chaque fois que vous ajoutez d'autres destinataires.",
    "participants.modal.email": "Courriel",
    "participants.modal.employeeId": "ID",
    "participants.modal.employeeList": "Liste des employés",
    "participants.modal.employeeName": "Nom de l'employé",
    "participants.modal.filterByAttribute": "Filtrer par attribut",
    "participants.modal.filterByDate": "Filtrer par date",
    "participants.modal.filterByDate.add": "AJOUTER UN FILTRE DE DATE DE DÉBUT",
    "participants.modal.filterByDate.after": "Après la date",
    "participants.modal.filterByDate.before": "Avant la date",
    "participants.modal.filterByDate.beforeIncluding": "Date antérieure et date incluse",
    "participants.modal.filterByDate.between": "Entre deux dates",
    "participants.modal.filterByDate.custom": "Date personnalisée ou plage de dates...",
    "participants.modal.filterByDate.includingAndAfter": "Y compris la date et l'après",
    "participants.modal.filterByDate.label": "La date d'entrée en fonction de l'employé est...",
    "participants.modal.filterByDate.lastWeek": "La semaine dernière",
    "participants.modal.filterByDate.notBetween": "Pas entre deux dates",
    "participants.modal.filterByDate.notOn": "Pas à la date prévue",
    "participants.modal.filterByDate.onExact": "À la date exacte",
    "participants.modal.filterByDate.remove": "Supprimer le filtre",
    "participants.modal.filterByDate.select": "Sélectionner...",
    "participants.modal.filterByDate.shortcuts": "Raccourcis",
    "participants.modal.filterByDate.sinceYesterday": "Depuis hier",
    "participants.modal.filterByDate.thisMonth": "Ce mois-ci",
    "participants.modal.filterByDate.thisWeek": "Cette semaine",
    "participants.modal.filterByEmployee": "Filtrer par employé",
    "participants.modal.filterByEmployee.placeholder": "Saisir le nom, l'adresse électronique ou l'identifiant",
    "participants.modal.filterByEmployee.remove": "Supprimer le filtre",
    "participants.modal.filterSubtitle": "La liste des employés répondra à tous les filtres sélectionnés",
    "participants.modal.filterTitle": "Filtrer la liste des employés",
    "participants.modal.newParticipants_one": "{{count}} nouveau participant",
    "participants.modal.newParticipants_other": "{{count}} nouveaux participants",
    "participants.modal.removed": "{{count}} supprimé",
    "participants.modal.save": "SAUVEGARDE",
    "participants.modal.saveWith": "Économiser avec {{détails}}",
    "participants.modal.selectAll": "SELECT ALL",
    "participants.modal.title": "Ajouter des participants à partir de la liste des employés",
    "participants.modal.unselectAll": "DÉSÉLECTIONNER TOUT",
    "participants.revoke.confirm.body.multiple": "En supprimant des participants, vous annulez leur invitation et leur accès à l'enquête, et vous supprimez leurs données d'enquête, au cas où ils les auraient déjà envoyées. Cette action ne peut pas être annulée. Vous pourrez les inviter à nouveau à l'enquête, mais leurs données seront effacées. Êtes-vous sûr de vouloir supprimer ces participants ?",
    "participants.revoke.confirm.body.single": "Le retrait d'un participant annulera son invitation et son accès à l'enquête, et supprimera ses données d'enquête, au cas où il les aurait déjà envoyées. Cette action ne peut pas être annulée. Vous pourrez à nouveau les inviter à l'enquête, mais leurs données seront effacées. Êtes-vous sûr de vouloir supprimer ce participant ?",
    "participants.revoke.confirm.button.multiple": "OUI, SUPPRIMER TOUT {{count}}",
    "participants.revoke.confirm.button.single": "OUI, ENLEVER",
    "participants.revoke.confirm.title.multiple": "Supprimer les participants {{count}} ?",
    "participants.revoke.confirm.title.single": "Supprimer le participant {{firstName}} {{lastName}} ?",
    "participants.revoke.success.multiple": "Participants retirés avec succès",
    "participants.revoke.success.single": "Participant supprimé avec succès",
    "participants.table.email": "Courriel",
    "participants.table.invitationChannel": "",
    "participants.table.name": "Nom",
    "participants.table.status": "Statut",
    "participants.unsavedChanges": "Vous avez apporté des modifications non enregistrées à la liste des participants. Veillez à les enregistrer avant de quitter cet écran.",
    "passive": "Neutre",
    "passive.2": "Passif",
    "password.reset.email": "Quelqu'un a demandé un lien pour réinitialiser votre mot de passe pour la plateforme WorkTango.",
    "password.reset.error": "Ce lien de réinitialisation du mot de passe n'est pas valide, a expiré ou a déjà été utilisé une fois.",
    "password.strength.tooltip": "Votre saisie de mot de passe est comparée à une bibliothèque de plus de 30000 mots de passe, noms et noms de famille courants, mots anglais populaires de Wikipédia, télévision américaine, films et autres modèles courants tels que les dates, les répétitions (aaa), les séquences (abcde), les modèles de clavier ( qwertyuiop) et le l33t speak (p4ssw0rd).",
    "pending": "En attente",
    "people": "personnes",
    "percentage": "Pourcentage",
    "permission.accessAiAssistant": "Utilisateur",
    "permission.aiAssistant": "Coach WorkTango",
    "permission.aiAssistantPermissionLevel": "Niveau d'autorisation du coach WorkTango",
    "permission.manageActionsForAll": "Planification d'action : tous les utilisateurs",
    "permission.manageActionsUnderHierarchy": "Planification d'action : uniquement la hiérarchie",
    "permission.manageAiAssistant": "Administrateur",
    "permission.manageCompany": "Configuration de l'entreprise",
    "permission.manageEmployees": "Gérer les employés",
    "permission.manageUsers": "Gérer les utilisateurs",
    "permission.manageUsersAndEmployees": "Utilisateurs et employés",
    "permission.receivesSummaryEmail": "WorkTango Coach: résumé de l'enquête",
    "permission.task.attributes": "Afficher et gérer les actions également pour le ou les attributs suivants :",
    "permission.task.main": "Afficher et gérer les actions pour :",
    "permission.task.self": "eux seulement",
    "permissions.canFilterSurveyComments": "",
    "permissions.canManageSurveys": "Gérer les sondages",
    "permissions.canSeeComments": "Voir les commentaires",
    "permissions.canSeeConversations": "Conversations anonymes",
    "permissions.canSeeInProgressResults": "",
    "permissions.canSeeReporting": "Afficher les rapports",
    "permissions.canUpdateCommentSentiment": "Mettre à jour le sentiment relatif aux commentaires",
    "permissions.canViewBenchmarks": "Voir les références",
    "permissions.loading.hierarchy": "Chargement des hiérarchies..",
    "person": "personne",
    "picker.noOption": "Aucune option disponible",
    "pl-pl": "Polonais",
    "positive.sentiment": "Sentiment positif",
    "ppt.questions.breakdown": "Répartition des questions",
    "ppt.score": "Score",
    "presentaionExport.spreadChart.favorable": "Favorable",
    "presentaionExport.spreadChart.neutral": "Neutre",
    "presentaionExport.spreadChart.unfavorable": "Négatif",
    "presentationExport.appendix": "Annexe",
    "presentationExport.appendix.allQuestionsSlide.title": "Toutes les questions quantitatives",
    "presentationExport.appendix.breakdown": "Panne",
    "presentationExport.attributeDisclaimer": "Uniquement affiché pour les répondants avec les conditions d'attribut(s) suivantes :",
    "presentationExport.bottomFiveQuestions": "Cinq dernières questions",
    "presentationExport.compareType.attribute": "Par rapport à l'attribut de comparaison",
    "presentationExport.compareType.organization": "Comparativement à Org. Large",
    "presentationExport.compareType.survey": "Par rapport à l'enquête comparative",
    "presentationExport.comparedWith": "Comparativement à",
    "presentationExport.comparisonAttributes": "Comparatif d’attribut(s)",
    "presentationExport.comparisonSurveys": "Comparatif de sondage(s)",
    "presentationExport.confidential": "Exclusif et confidentiel. © WorkTango Inc., 2022.",
    "presentationExport.dropdownQuestionSlide.title": "Questions déroulantes",
    "presentationExport.enps": "eNPS",
    "presentationExport.enpsSlide.description.compareValue.comparisonAttribute": "changement vs attribut de comparaison",
    "presentationExport.enpsSlide.description.compareValue.comparisonSurvey": "changement vs sondage de comparaison",
    "presentationExport.enpsSlide.description.compareValue.orgWide": "changement vs l’ensemble de l’organisation",
    "presentationExport.enpsSlide.description.compareValue.timeframe": "Changement par rapport au calendrier",
    "presentationExport.enpsSlide.detractors": "Détracteurs",
    "presentationExport.enpsSlide.detractorsDescription": "employés qui sont des « détracteurs »",
    "presentationExport.enpsSlide.employeeBreakdown": "Répartition des employés",
    "presentationExport.enpsSlide.enpsDescription": "Le score net de recommandation de l’employé (eNPS) fournit une mesure globale de l’engagement des employés en mesurant dans quelle mesure l’employé est disposé à recommander son lieu de travail à ses amis et à sa famille.",
    "presentationExport.enpsSlide.enpsFormula": "*eNPS est calculé en soustrayant la proportion de détracteurs de la proportion de promoteurs",
    "presentationExport.enpsSlide.passives": "Passifs",
    "presentationExport.enpsSlide.promoters": "Promoteurs",
    "presentationExport.enpsSlide.promotersDescription": "employés qui sont des « promoteurs »",
    "presentationExport.factorsSlide.byFactor": "Par facteur",
    "presentationExport.factorsSlide.keyFactors": "Facteurs clés",
    "presentationExport.factorsSlide.otherFactors": "Facteurs",
    "presentationExport.filters": "Filtres",
    "presentationExport.mcqSlide.title": "Questions à choix multiple",
    "presentationExport.openEndedCommentsSlide.frequency": "Fréquence",
    "presentationExport.openEndedCommentsSlide.keyword": "Mot clé",
    "presentationExport.openEndedCommentsSlide.majoritySentiment": "Sentiment de la majorité",
    "presentationExport.openEndedCommentsSlide.respondents": "Les répondants",
    "presentationExport.openEndedCommentsSlide.sentimentDescription": "*Remarque : Les sentiments reflètent les mots clés avec une majorité de commentaires positifs, neutres et négatifs, selon le moteur de traitement du langage naturel (NLP) d’Amazon; veuillez visiter la plateforme WorkTango pour obtenir des commentaires détaillés et les sentiments notés pour chaque commentaire.​",
    "presentationExport.openEndedCommentsSlide.title": "Commentaires ouverts",
    "presentationExport.overallFindings": "Constatations générales",
    "presentationExport.question": "Question :",
    "presentationExport.questionThemes": "Thèmes des questions",
    "presentationExport.resultsSlide.factorCompareAttr": "Différence en pourcentage pour le facteur ci-dessus par rapport aux attributs sélectionnés",
    "presentationExport.resultsSlide.factorCompareOrgWide": "Différence en pourcentage pour le facteur ci-dessus par rapport à l’ensemble de l’organisation",
    "presentationExport.resultsSlide.factorCompareSurvey": "Différence en pourcentage pour le facteur ci-dessus comparativement aux enquêtes de comparaison",
    "presentationExport.resultsSlide.factorCompareTimeframe": "Différence en pourcentage pour le facteur ci-dessus lors de la comparaison des délais",
    "presentationExport.resultsSlide.highestFactor": "Facteur de notation le plus élevé",
    "presentationExport.resultsSlide.highestQuestion": "Question ayant obtenu la meilleure note",
    "presentationExport.resultsSlide.keyResults": "Principaux résultats",
    "presentationExport.resultsSlide.lowestFactor": "Facteur de notation le plus faible",
    "presentationExport.resultsSlide.lowestQuestion": "Question ayant obtenu le pointage le plus bas",
    "presentationExport.resultsSlide.questionCompareAttr": "Différence en pourcentage pour la question ci-dessus par rapport aux attributs sélectionnés",
    "presentationExport.resultsSlide.questionCompareOrgWide": "Différence en pourcentage pour la question ci-dessus par rapport à l’ensemble de l’organisation",
    "presentationExport.resultsSlide.questionCompareSurvey": "Différence en pourcentage entre la question ci-dessus et l’enquête de comparaison",
    "presentationExport.resultsSlide.questionCompareTimeframe": "Différence en pourcentage pour le facteur ci-dessus lors de la comparaison des délais",
    "presentationExport.resultsSlide.respondents": "Les employés ont répondu",
    "presentationExport.resultsSlide.responseRate": "Taux de participation",
    "presentationExport.resultsSlide.responseRateCompareAttr": "Pourcentage de différence par rapport au taux de réponse\ndes attributs de comparaison",
    "presentationExport.resultsSlide.responseRateCompareOrgWide": "Pourcentage de différence par rapport au taux de réponse\nde l’ensemble de l’organisation",
    "presentationExport.resultsSlide.responseRateCompareSurvey": "Pourcentage de différence par rapport au taux de réponse \ndu sondage de comparaison",
    "presentationExport.resultsSlide.responseRateCompareTimeframe": "Différence en pourcentage par rapport au taux de réponse de la période comparée",
    "presentationExport.resultsSlide.responseRate_plural": "Taux de réponse",
    "presentationExport.resultsSlide.title": "Sommaire des résultats",
    "presentationExport.summaryGeneratedWithResponses": "Ce résumé a été généré par l'IA en analysant {{responses}} réponses.",
    "presentationExport.title.report-timeframe": "Calendrier du rapport",
    "presentationExport.title.report-timeframe.empty": "Pas de délai sélectionné",
    "presentationExport.topFiveQuestions": "Cinq questions principales",
    "presentationExport.yesNoQuestionSlide.title": "Questions oui/non",
    "privacy.notice": "Avis de confidentialité",
    "privacy.policy": "Politique de confidentialité",
    "profile.avatar": "Avatar",
    "profile.avatarErrorSize": "Taille de fichier de {{fileSize}} Ko non valide. Maximum {{maxFileSize}} Ko.",
    "profile.avatarErrorType": "Fichier image non valide.",
    "profile.confirmPassword": "Confirmer le mot de passe",
    "profile.currentpassword": "Mot de passe actuel",
    "profile.fname": "Prénom",
    "profile.lname": "Nom",
    "profile.newpassword": "Nouveau mot de passe",
    "profile.password": "Mot de passe",
    "profile.picture": "Image de profil",
    "profile.saved": "Détails de votre sondage",
    "profile.selectLanguage": "Sélectionner la langue",
    "profile.updateSuccessful": "Votre profil a été mis à jour avec succès.",
    "promoter.2": "Promoteur",
    "pt-br": "Portugais",
    "pt-pt": "Portugais (PT)",
    "published": "Publié",
    "question.add-to-library": "Ajouter à la bibliothèque",
    "question.cannotDiscontinue": "Cette question ne peut pas être abandonnée car elle fait partie de la logique de la question. Veuillez dissocier la question dans l'éditeur de logique, puis l'abandonner.",
    "question.cannotDiscontinue.title": "Cette question ne peut pas être abandonnée",
    "question.confirmDiscontinue": "Oui, interrompre",
    "question.delete": "Supprimer",
    "question.discontinue": "Question sur l'arrêt de la production",
    "question.discontinueDesc": "En confirmant cette action, vous supprimerez de manière irréversible cette question de l'enquête. Tous les rapports seront encore disponibles pour cette question. Êtes-vous sûr de vouloir procéder à ce changement ?",
    "question.discontinueThisQuestion": "Abandonner cette question ?",
    "question.discontinuingQuestion": "La question n'est plus d'actualité...",
    "question.duplicate": "Copier",
    "question.issue.attrEmpty": "Veuillez sélectionner une ou plusieurs valeurs d'attribut",
    "question.issue.attributeFilterEmpty": "",
    "question.issue.categoryEmpty": "Le facteur doit être sélectionné",
    "question.issue.descEmpty": "Veuillez saisir la description de la question pour toutes les langues",
    "question.issue.isPrevious": "La question de tendance n'est pas modifiable",
    "question.issue.leftEmpty": "Veuillez saisir l'étiquette de gauche pour toutes les langues",
    "question.issue.openSurveyAttributeNameEmpty": "",
    "question.issue.optionsEmpty": "Veuillez saisir le contenu des options pour toutes les langues",
    "question.issue.questionFilterLabelEmpty": "",
    "question.issue.rightEmpty": "Veuillez saisir l'étiquette de droite pour toutes les langues",
    "question.issue.titleEmpty": "Veuillez saisir le titre de la question pour toutes les langues",
    "question.lock.attributeBased": "Tous les accès des employés sont requis pour modifier la question basée sur l'attribut",
    "question.locked": "Cette question ne peut pas être modifiée parce qu’elle est maintenant une question de tendance. Si vous voulez modifier la question, vous pouvez la copier et modifier la version dupliquée.",
    "question.multiple.error": "La sélection maximale autorisée ne peut pas être 1 lorsque la sélection multiple est autorisée.",
    "question.order": "Glisser",
    "question.remove-from-library": "Retirer de la bibliothèque",
    "question.saved.success": "Question enregistrée avec succès.",
    "question.showDiscontinued": "Afficher les questions abandonnées ({{count}})",
    "question.toast.success.discontinue": "Succès ! La question ne sera plus posée dans cette enquête.",
    "question.upload": "Ajouter à la Bibliothèque",
    "question.uploaded": "Cette question est dans votre bibliothèque, cliquez pour supprimer",
    "questionExport.Description": "La description",
    "questionExport.FactorName": "Facteur",
    "questionExport.Question": "Question",
    "questionExport.benchmarkedQuestion": "Question comparée",
    "questionExport.commentsTurnedOn": "commentaires activés?",
    "questionExport.isBenchmarked": "Est comparée",
    "questionExport.isConditionalOnAttribute": "Affiché conditionnellement en fonction de l'attribut?",
    "questionExport.isConditionalOnPreviousQuestion": "Affiché conditionnellement en fonction de la question précédente?",
    "questionExport.isQuestionRequired": "la question est-elle nécessaire?",
    "questionExport.isTrend": "questionnera la tendance avec d'autres sondages?",
    "questionExport.questionNumber": "Question #",
    "questionExport.questionType": "Type de question\n",
    "questionExport.responseOptions": "Options de réponse",
    "questions": "Questions",
    "questions.none": "Ajoutez votre première question",
    "questions.none.message": "Cliquez sur un bouton + au pour ajouter une question à ce sondage",
    "questions.select.attributesAndValue": "Sélectionner le champ et la valeur",
    "recipients": "Destinataires",
    "recipients.added_one": "ajouter {{count}} un nouveau participant",
    "recipients.added_other": "ajouter {{count}} de nouveaux participants",
    "recipients.all": "Tous les employés",
    "recipients.change-confirmation": "Êtes-vous sûr de vouloir procéder à cette modification ?",
    "recipients.changed.dialog.button.confirm": "Confirmer le changement",
    "recipients.changed.dialog.title": "Résumé de la mise à jour des participants à l'enquête",
    "recipients.description.added": "En confirmant cette mise à jour, vous allez <0>{{{addedText}}</0>, et leur envoyer un courriel d'invitation à l'enquête.",
    "recipients.description.both": "En confirmant cette mise à jour, vous allez <0>{{Texte ajouté}}</0>, et <0>{Texte supprimé}}</0>. Les participants ajoutés recevront un courriel d'invitation.",
    "recipients.description.removed": "En confirmant cette mise à jour, vous <0>{{{Texte supprimé}}</0>. ",
    "recipients.removed-warning": "L'accès à l'enquête des participants supprimés ne sera plus valide et <0>toutes les réponses qu'ils ont soumises seront supprimées.</0>",
    "recipients.removed_one": "supprimer {{count}} un participant existant",
    "recipients.removed_other": "supprimer {{count}} les participants existants",
    "reminder.schedule.already.sending.error": "Des invitations sont en cours d’envoi pour ce sondage. Peut-être un rappel a-t-il déjà été programmé?",
    "reminder.title.date.time": "Date et heure des rappels",
    "reminder.title.status": "État",
    "reminders.invitation-time.tooltip": "C’est à ce moment que vos rappels sont placés dans la file d’attente d’envoi, et non nécessairement au moment où les destinataires les reçoivent. Veuillez noter que la livraison peut prendre jusqu’à 3 heures après le début de la période d’envoi afin de garantir une délivrabilité optimale des e-mails.",
    "remove.all.compare.attributes": "Cette action supprimera tous les attributs comparables personnalisés.",
    "remove.all.custom.response.attributes": "Cette action supprimera tous les attributs de données de réponse personnalisés.",
    "remove.all.filter.attributes": "Cette action supprimera tous les attributs de filtrage personnalisés.",
    "remove.all.other.hierarchies": "Cette action supprimera tous les chefs d’équipe sélectionnés.",
    "reporting.compare.withFilterNotice": "Les données de comparaison sont également filtrées avec les filtres appliqués",
    "reporting.compare.withoutFilterNotice": "Les données de comparaison ne sont pas filtrées avec les filtres appliqués",
    "reporting.employeeIdUpdateInProgress": "",
    "reporting.export.fullResponses": "Résultats (individuel)",
    "reporting.export.raw-export": "Exportation de données de sondage brutes",
    "reporting.filter.or": "ou",
    "reporting.nonRespondents": "Non-répondants",
    "reporting.outOf": "sur",
    "reporting.participant.filter.reset.button": "rapport de restitution à tous les participants",
    "reporting.participant.filter.select.button": "sélectionner un participant...",
    "reporting.participant.filter.selectAnother.button": "sélectionner un autre participant...",
    "reporting.participant.filter.selected": "Le rapport est limité aux <0>réponses soumises par {{nom}}</0>",
    "reporting.responded": "ont répondu",
    "reporting.respondents": "Répondants",
    "reporting.responseVolume.description": "",
    "reporting.responseVolume.period": "",
    "reporting.responseVolume.responses_one": "",
    "reporting.responseVolume.responses_other": "",
    "reporting.responseVolume.seriesLabel": "",
    "reporting.responseVolume.total": "",
    "reporting.responseVolume.weekOf": "",
    "reporting.timeframeCompare.dialog.aMonthPriorToReport": "Un mois avant le rapport",
    "reporting.timeframeCompare.dialog.aWeekPriorToReport": "Une semaine avant le rapport",
    "reporting.timeframeCompare.dialog.custom": "Délai personnalisé",
    "reporting.timeframeCompare.dialog.description1": "Cette action permet de choisir une période différente pour comparer les données avec la période du rapport",
    "reporting.timeframeCompare.dialog.description2": "Comparer avec la sélection des délais",
    "reporting.timeframeCompare.dialog.quarterPriorToReport": "Trimestre précédant le rapport",
    "reporting.timeframeCompare.dialog.samePeriodLastYear": "Même période l'année dernière",
    "reporting.timeframeCompare.dialog.threeMonthsPriorToReport": "3 mois avant le rapport",
    "reporting.timeframeCompare.dialog.title": "Choisir Comparer avec la période",
    "reporting.timeframeCompare.option.aMonthPriorToReport": "Un mois avant le rapport",
    "reporting.timeframeCompare.option.aWeekPriorToReport": "Une semaine avant le rapport",
    "reporting.timeframeCompare.option.custom": "Délai personnalisé",
    "reporting.timeframeCompare.option.quarterPriorToReport": "Trimestre précédant le rapport",
    "reporting.timeframeCompare.option.samePeriodLastYear": "Même période l'année dernière",
    "reporting.timeframeCompare.option.threeMonthsPriorToReport": "3 mois avant le rapport",
    "reporting.timeframeFilter.button": "Changer de période...",
    "reporting.timeframeFilter.dialog.description1": "Cette action limitera le rapport à la prise en compte des réponses soumises dans le délai sélectionné.",
    "reporting.timeframeFilter.dialog.description2": "Sélection de la période de référence du rapport",
    "reporting.timeframeFilter.dialog.filterLabel": "Calendrier choisi",
    "reporting.timeframeFilter.dialog.title": "Modifier le délai du rapport",
    "reporting.timeframeFilter.label": "La période couverte par le rapport est limitée à",
    "reporting.timeframeFilter.option.AllTime": "Tout le temps",
    "reporting.timeframeFilter.option.Custom": "Sur mesure",
    "reporting.timeframeFilter.option.Last30Days": "30 derniers jours",
    "reporting.timeframeFilter.option.Last7Days": "7 derniers jours",
    "reporting.timeframeFilter.option.Last90Days": "90 derniers jours",
    "reporting.timeframeFilter.option.PreviousQuarter": "Quart précédent",
    "reporting.timeframeFilter.option.SinceBeginningOfYear": "Depuis le début de l'année",
    "reporting.timeframeFilter.option.ThisQuarter": "Ce trimestre",
    "resend.emails.in.progress": "Une demande de renvoi des invitations à l'enquête aux participants est déjà en cours. Veuillez attendre la fin de cette demande avant de réessayer.",
    "reset.filters": "Réinitialiser les filtres",
    "reset.password.dialog.description": "Votre nouveau mot de passe est prêt à être utilisé.",
    "reset.password.dialog.title": "La configuration du nouveau mot de passe est terminée!",
    "reset.password.instruction": "Configurer votre nouveau mot de passe",
    "response.comment": "Saisir un commentaire facultatif",
    "response.entities.sentiment": "Sentiment",
    "response.entities.sentimentscore": "Pointage",
    "responseRate.responses": "{{detail}} réponses",
    "responseRates": "Taux de réponse",
    "responserates.answered": "Répondu",
    "responserates.total": "Total",
    "responses.count": "Nombre de réponses",
    "responses.count.compare-timeframe": "Comparer le nombre de réponses au calendrier",
    "result.commentSentiment.negative": "Négatif",
    "result.commentSentiment.neutral": "Neutre",
    "result.commentSentiment.positive": "Positif",
    "result.commentSentiment.unknown": "Inconnu",
    "result.noPositiveSentiment": "Aucun sentiment positif",
    "results.moreDetails": "Plus de détails",
    "results.responded": "Ont répondu",
    "results.see": "Voir",
    "return.home": "Retour à la page d'accueil",
    "role.current.direct.reports": "Rapport direct actuel",
    "role.current.hierarchy": "Rapport sur la hiérarchie actuelle",
    "role.directReport": "Rapport direct",
    "role.hierarhcyReport": "Rapport de hiérarchie",
    "role.peopleleader": "Dirigeant",
    "roles.actionPlanning.all": "Toutes les actions",
    "roles.actionPlanning.default": "Seulement leurs actions",
    "roles.actionPlanning.hierarchy": "Hiérarchie seulement",
    "roles.addRole": "Ajouter un rôle",
    "roles.column.actionPlanning": "Accès à la planification des actions",
    "roles.column.other": "Autres permissions",
    "roles.column.role": "Rôle",
    "roles.column.surveyType": "Accès au type de sondage",
    "roles.column.users": "Nombre d’utilisateurs",
    "roles.create.desc": "Créez un rôle en définissant un ensemble de permissions dont les utilisateurs d’un certain groupe ont besoin pour accéder à la plateforme. Lorsque vous avez créé le rôle, attribuez le rôle aux utilisateurs respectifs dans la section Utilisateurs.",
    "roles.create.error": "Oups, il semble qu’il manque quelque chose",
    "roles.create.errorDesc": "Veuillez vérifier les validations suivantes :",
    "roles.create.successDesc": "{{name}} a été enregistré avec succès.",
    "roles.create.successTitle": "Nouveau rôle créé",
    "roles.create.title": "Créer un nouveau rôle",
    "roles.delete.preventDesc": "Veuillez attribuer un autre rôle à tous les utilisateurs avec le rôle HR BP avant de supprimer ce rôle.",
    "roles.delete.preventDesc.automaticallyCreated": "Il s'agit d'un rôle système impossible à supprimer.",
    "roles.delete.preventKazooDefaultRole": "Il s'agit d'un rôle par défaut qui ne peut pas être supprimé à partir du module Sondages et informations. Veuillez contacter votre service client pour davantage de renseignements sur les rôles par défaut.",
    "roles.delete.preventTitle": "Ce rôle est attribué à des utilisateurs.",
    "roles.delete.preventTitle.default": "Ce rôle ne peut pas être supprimé",
    "roles.delete.preventTitle.kazooDefaultRole": "Impossible de supprimer le rôle",
    "roles.delete.successDesc": "{{name}} a été supprimé avec succès.",
    "roles.delete.successTitle": "Rôle supprimé",
    "roles.empty": "Il n’y a rien ici pour l’instant… Changeons cela!",
    "roles.input.name": "Nom du rôle",
    "roles.mainTitle": "Rôles",
    "roles.other.none": "Aucune",
    "roles.searchLabel": "Rechercher par rôle",
    "roles.surveyType.all": "Toutes",
    "roles.surveyType.attribute": "En fonction des attributs",
    "roles.surveyType.hierarchy": "Hiérarchie",
    "roles.update.alertConfirm": "Confirmer les modifications",
    "roles.update.alertDesc": "En continuant, les permissions des utilisateurs avec ce rôle seront mises à jour en fonction de leurs nouvelles permissions",
    "roles.update.alertTitle": "La mise à jour de ce rôle affectera les utilisateurs actuels qui ont ce rôle",
    "roles.update.successDesc": "{{name}} a été enregistré avec succès.",
    "roles.update.successTitle": "Rôle mis à jour",
    "roles.update.title": "Modifier un rôle",
    "rows.per.page": "Lignes par page :",
    "ru-ru": "Russe",
    "schedule.time.early-morning": "Tôt le matin (6-8h)",
    "schedule.time.eod": "Fin de journée (16h-18h)",
    "schedule.time.evening": "Soirée (20-22h)",
    "schedule.time.noon": "De midi à midi (12h-14h)",
    "scheduled": "Prévu",
    "scoreByAttrSpread": "Répartition du pointage par attribut",
    "search.for.content": "Recherche de contenu...",
    "search.placeholder": "Recherche...",
    "search.question.title": "Chercher une question",
    "see.all": "Voir tout",
    "see.more.something": "Voir d’autres {{something}}",
    "select": "Sélectionner",
    "select.all": "Tout sélectionner",
    "select.an.attribute": "Sélectionner un attribut",
    "select.choosesurvey": "Filtrer par sondage",
    "selected.survey.status.header": "Statut",
    "selected.survey.styles.header": "Styles d'enquête",
    "selected.survey.types.header": "Types de sondage",
    "send.password.reset.email": "Envoyer le e-mail",
    "sentimentCloud.noAvailableData": "Aucune donnée accessible",
    "sentimentCloud.slider.title": "Affichages des expressions clés : ",
    "sentiments.set": "Cliquez pour modifier le sentiment {{sentiment}}.",
    "sentiments.set.negative": "Réglé sur négatif",
    "sentiments.set.neutral": "Mise au neutre",
    "sentiments.set.positive": "Régler sur Positif",
    "sentiments.set.unknown": "Remise à l'état inconnu",
    "settings.add.survey.type": "Ajouter un type de sondage",
    "settings.alert.baseCategory.warningDescription": "Vous pouvez toujours recevoir les suggestions recommandées de WorkTango en liant votre facteur personnalisé à un facteur WorkTango ci-dessus et en personnalisant le nom.",
    "settings.alert.baseCategory.warningTitle": "Les facteurs personnalisés n’auront pas de suggestion recommandée",
    "settings.alert.recommendation": "Les suggestions pour ce facteur seront optimisées par les recommandations de WorkTango pour <strong>{{categoryName}}</strong>.",
    "settings.company.genai-dialog-body": "Notre plateforme fait appel à des capacités d'intelligence artificielle de tiers pour effectuer les actions suivantes :\n<0>Analyse du sentiment des commentaires</0> <0>Extraction et association des thèmes des commentaires</0> <0>Résumé succinct des commentaires</0> <0>Recommandation d'actions sur la base des commentaires<0>.<0> <0>Générer des entités de commentaires textuels</0> <1>Créer un nuage de mots de commentaires textuels</1> Vos données ne sont pas stockées par des tiers et ne sont pas non plus utilisées pour l'entraînement de modèles d'IA. Pour en savoir plus sur les politiques de WorkTango en matière d'IA, veuillez suivre <2>ce lien.</2>",
    "settings.company.genai-dialog-title": "À propos des fonctions d'IA de WorkTango",
    "settings.company.genai-settings": "Paramètres d'IA générative",
    "settings.company.genai-settings-tooltip": "Cliquez pour en savoir plus sur les fonctions d'IA de WorkTango",
    "settings.company.genai.comment-analysis": "Activer les fonctionnalités IA",
    "settings.company.language-settings": "Paramètres linguistiques",
    "settings.company.open-surveys-settings": "Sondages ouverts",
    "settings.company.open-surveys.enabled": "Activer les sondages par lien partagé",
    "settings.company.open-surveys.response-limit": "",
    "settings.company.open-surveys.response-limit.helperText": "",
    "settings.company.open-surveys.response-limit.invalid": "",
    "settings.company.open-surveys.response-limit.save-error": "",
    "settings.company.salesforceId": "SalesForce ID",
    "settings.company.salesforceId.helperText": "",
    "settings.customFactor": "Facteur personnalisé",
    "settings.customizeName": "Personnaliser le nom",
    "settings.desc.baseSurveyType": "Sélectionnez la catégorie pour obtenir une liste de facteurs et de suggestions automatiques recommandés pour améliorer vos scores",
    "settings.desc.factors": "Des facteurs regroupent des questions à thème similaire, ce qui vous permet de voir le score global pour le groupe de questions. Nous recommandons nos facteurs reconnus qui vous fourniront des recommandations automatiques sur la façon d’améliorer vos scores.",
    "settings.desc.surveyTypes": "Les types de sondages vous permettent de regrouper des sondages similaires ayant la même structure de permission et partageant le même seuil d’anonymat.",
    "settings.done": "Fini",
    "settings.done.message": "Vos paramètres ont été mis à jour avec succès.",
    "settings.edit.survey.type": "Modifier le type de sondage",
    "settings.employee-attribute.deletion": "L'attribut de l'employé a été supprimé avec succès!",
    "settings.employeeAttribute.archiveAttribute": "Archiver l'attribut",
    "settings.employeeAttribute.archiveAttributeConfirmTitle": "Attribut d'archive \"{{nom}}\" ?",
    "settings.employeeAttribute.archiveImpact.bucket.compare": "",
    "settings.employeeAttribute.archiveImpact.bucket.dataset": "",
    "settings.employeeAttribute.archiveImpact.bucket.visible": "",
    "settings.employeeAttribute.archiveImpact.confirm": "",
    "settings.employeeAttribute.archiveImpact.intro": "",
    "settings.employeeAttribute.archiveImpact.loading": "",
    "settings.employeeAttribute.archiveImpact.role": "",
    "settings.employeeAttribute.archiveImpact.title": "",
    "settings.employeeAttribute.archiveModalBody": "L'archivage d'un attribut le masquera dans le système, mais conservera toutes les données des employés qui y sont stockées au cas où vous décideriez de le réactiver ultérieurement.\n\nToutes les enquêtes précédentes resteront intactes, mais vous ne pourrez plus consulter ni filtrer les nouveaux résultats d'enquête à l'aide de cet attribut.\n\nSi vous souhaitez supprimer définitivement cet attribut, y compris les données des employés et l'historique des enquêtes, veuillez le supprimer.\n\nÊtes-vous sûr de vouloir archiver cet attribut ?",
    "settings.employeeAttribute.confirmYesArchive": "Oui, archiver",
    "settings.employeeAttribute.confirmYesDelete": "Oui, supprimer",
    "settings.employeeAttribute.confirmYesReactivate": "Oui, réactiver",
    "settings.employeeAttribute.deleteAttribute": "Supprimer l'attribut",
    "settings.employeeAttribute.deleteAttributeConfirmTitle": "Supprimer l'attribut \"{{nom}}\" ?",
    "settings.employeeAttribute.deleteModalBody": "La suppression d'un attribut le supprimera définitivement du système, ainsi que toutes les données des employés qui y sont stockées. Cette action est irréversible.\n\nToutes les enquêtes, actuelles et passées, seront également affectées par cette action, et vous ne pourrez plus consulter ni filtrer les résultats d'enquête à l'aide de cet attribut.\n\nSi vous souhaitez cesser d'utiliser cet attribut tout en conservant les données historiques, envisagez plutôt de l'archiver.\n\nÊtes-vous sûr de vouloir supprimer cet attribut ?",
    "settings.employeeAttribute.reactivateModalBody": "La réactivation d'un attribut archivé le rendra visible dans le système et il sera présent dans toutes les nouvelles enquêtes, mais ne sera pas ajouté aux enquêtes en cours.\n\nÊtes-vous sûr de vouloir réactiver cet attribut ?",
    "settings.employeeAttributes.duplicateError": "Il semble qu'il existe déjà un attribut portant le même nom. Veuillez choisir un autre nom pour continuer.",
    "settings.error.baseFactorRequired": "Un facteur WorkTango valide est obligatoire",
    "settings.error.baseSurveyTypeRequired": "Il est obligatoire d’entrer une catégorie de sondage",
    "settings.error.enNameRequired": "Le nom anglais ne doit pas être vide",
    "settings.error.invalidSize": "Taille de fichier de {{fileSizeKB}} Ko non valide. Maximum {{maxUploadSizeKB}} Ko.",
    "settings.error.maxedPrimary": "Nombre maximum d’attributs principaux déjà sélectionné",
    "settings.error.notValidImage": "Fichier image non valide.",
    "settings.error.thresholdRequired": "Un seuil d’anonymat valide est obligatoire",
    "settings.error.validTypeRequired": "Type d’attribut d’employé non valide",
    "settings.integrations.channel.slack.description": "",
    "settings.integrations.channel.slack.label": "",
    "settings.integrations.channel.sms.description": "",
    "settings.integrations.channel.sms.label": "",
    "settings.integrations.channel.teams.description": "",
    "settings.integrations.channel.teams.label": "",
    "settings.integrations.configure": "",
    "settings.integrations.description": "",
    "settings.integrations.error": "",
    "settings.integrations.heading": "",
    "settings.integrations.notConnectedHint": "",
    "settings.integrations.setup": "",
    "settings.integrations.setup.comingSoon": "",
    "settings.integrations.slack.connectError": "",
    "settings.integrations.slack.connected": "",
    "settings.integrations.status.connected": "",
    "settings.integrations.status.notConnected": "",
    "settings.integrations.toggle.error": "",
    "settings.kiosk.attributes": "Identifiant de kiosque",
    "settings.kiosk.download-qr-code": "Télécharger le code QR",
    "settings.kiosk.language": "Renseignements complémentaires",
    "settings.kiosk.language.tooltip": "Ce texte sera affiché sur la page de connexion du kiosque en guise de texte de bienvenue",
    "settings.kiosk.none": "Aucune",
    "settings.kiosk.qr-code": "Code QR du kiosque",
    "settings.label.archived": "Archivé",
    "settings.label.baseAttribute": "Système",
    "settings.label.createAttribute": "Créer un attribut",
    "settings.label.factor": "Facteur WorkTango",
    "settings.label.key.factor": "Facteur clés",
    "settings.label.modifyAttribute": "Modifier l'attribut",
    "settings.label.name": "Nom",
    "settings.label.newAttribute": "Nouvel attribut",
    "settings.label.phone": "Téléphone",
    "settings.label.phoneAlt": "Numéro de téléphone",
    "settings.label.phoneDisabled": "Les numéros de téléphone ne peuvent être configurés que pour les attributs de type texte",
    "settings.label.prepopulateFactors": "Préremplir ce type d’enquête avec des facteurs prédéfinis",
    "settings.label.primary": "Principal",
    "settings.label.primaryAlt": "Principal (toujours affichée par défaut, jusqu'à 10 autorisés)",
    "settings.label.private": "Privé",
    "settings.label.privateAlt": "Privé (caché dans la liste des employés)",
    "settings.label.required": "Requis",
    "settings.label.setup.suggestions": "Cliquer pour configurer les suggestions",
    "settings.label.suggestions.content": "Suggestions de {{categoryName}} recommandées de WorkTango",
    "settings.label.suggestions.powered.by": "Suggestions optimisées par",
    "settings.label.survey.types": "Types de sondage",
    "settings.label.type": "Type",
    "settings.label.unique": "Unique",
    "settings.message.categoryUpdated": "Le facteur a été mis à jour avec succès.",
    "settings.message.surveyTypesUpdated": "Le type de sondage a été mis à jour avec succès.",
    "settings.primaryAttributeCannotBeModified": "Il s'agit d'un attribut système et ne peut pas être modifié. ",
    "settings.selected.baseSurveyType": "Catégorie de sondage",
    "settings.title": "Configuration",
    "settings.title.automatedInvitations": "Invitations automatisées",
    "settings.title.categoryUpdated": "Enregistré",
    "settings.title.company": "Entreprise",
    "settings.title.employee-attributes": "Attributs d’employés",
    "settings.title.error": "Erreur",
    "settings.title.integrations": "",
    "settings.title.kiosk": "Kiosque",
    "settings.title.surveyTypes": "Types et facteurs d'enquête",
    "settings.title.surveyTypesUpdated": "Enregistré",
    "settings.title.surveys": "Questionnaires",
    "settings.useRecommendedName": "Utiliser le nom recommandé",
    "show": "Montrer",
    "show.all": "Tout montrer",
    "show.all.suggestions": "Afficher les {{count}} suggestions",
    "show.less": "Afficher moins",
    "sidebar.action-planning": "Planification de l’action",
    "sidebar.admin.branding": "Info sur l’entreprise",
    "sidebar.admin.data": "Configuration",
    "sidebar.admin.employees": "Employés",
    "sidebar.content.library": "Coach en apprentissage",
    "sidebar.inbox": "Conversations",
    "sidebar.mailing-lists": "Listes de distribution",
    "sidebar.surveys": "Sondages",
    "skip.disabled.when.required": "Ignorer n'est pas disponible lorsque la question est requise",
    "sliding_accessible_ms_custom_blue": "Bleu (carré) numérique, accessible",
    "sliding_accessible_squares": "Numérique (carré), accessible",
    "sliding_apples": "Pommes",
    "sliding_blush": "Émoji sourire rougissant",
    "sliding_boat": "Bateau",
    "sliding_canada": "Drapeaux canadiens",
    "sliding_computer": "Ordinateurs",
    "sliding_cpa_custom_emoji": "Émoji 5 notes seulement",
    "sliding_crown": "Couronnes",
    "sliding_desk": "Bureaux",
    "sliding_double_phones": "Deux téléphones",
    "sliding_eyes_closed_happy_emoji": "Émoji yeux clos heureux",
    "sliding_flags": "Drapeaux",
    "sliding_hands_up": "Mains levées",
    "sliding_headphones_happy_face_emoji": "Émoji heureux avec casque d’écoute",
    "sliding_hearts": "Cœurs",
    "sliding_hearts_united_way": "Étoiles Centraide",
    "sliding_lemur": "Maki",
    "sliding_lightbulb": "Ampoule",
    "sliding_music_note": "Notes de musique",
    "sliding_office_chair": "Chaises de bureau",
    "sliding_otter": "Loutre",
    "sliding_panda": "Panda",
    "sliding_pencil": "Stylos",
    "sliding_penguin": "Manchot",
    "sliding_phone_in_hand": "Téléphone en main",
    "sliding_pint_glasses": "Pinte de bière",
    "sliding_pizza": "Tranche de pizza",
    "sliding_puppy": "Têtes de chiots",
    "sliding_single_phone": "Téléphones individuels",
    "sliding_speech_bubbles": "Bulles de texte",
    "sliding_stars": "Étoiles",
    "sliding_teal_square": "Numérique (carré)",
    "sliding_thumbs_up": "Pouces levées",
    "sliding_tiff_stars": "Étoiles Tiff",
    "sliding_wifi": "Signal Wi-Fi",
    "snapshots.update.unknown.error": "",
    "snapshots.updated.successfully": "",
    "source": "Source",
    "spread": "Étendue",
    "spread.of.responses.by.attribute": "Répartition des taux de réponse par attribut",
    "sq-al": "Albanais",
    "sr-rs": "Serbian",
    "sso.loginFailed": "La connexion a échoué",
    "sso.loginFailed.invalidToken": "Jeton invalide",
    "sso.user.not.found.description": "Aucun utilisateur n’a été trouvé pour {{email}}",
    "star.this": "Marquer d’un astérisque",
    "starred": "Marqué d’un astérisque",
    "status.all": "Tous",
    "suggestions": "Suggestions",
    "summary": "Résumé",
    "summaryReport": "Rapport sommaire",
    "support.failure.message": "Une erreur inattendue s'est produite lorsque nous avons essayé de vous connecter à Zendesk avec SSO. Veuillez contacter le support.",
    "survey": "Sondage",
    "survey-template.dialog.confirm": "Créer un sondage en utilisant le modèle sélectionné",
    "survey-template.dialog.confirm-multiple": "Créer un sondage en utilisant le modèle sélectionné comme",
    "survey-template.dialog.description": "Si vous souhaitez ajouter une enquête, veuillez cloner une enquête existante.",
    "survey-template.dialog.empty-state": "Aucun modèle ne correspond à vos filtres.",
    "survey-template.dialog.error": "Vous devez sélectionner au moins une langue",
    "survey-template.dialog.select-language.helper-text": "Remarque importante : il ne sera pas possible de modifier les langues disponibles une fois le sondage créé.",
    "survey-template.dialog.select-language.label": "Proposer le sondage dans la/les langue(s) suivante(s)",
    "survey-template.dialog.title": "Choisir un modèle de sondage",
    "survey-template.dialog.tooltip.missing-factors": "Un ou plusieurs facteurs obligatoires pour ce type de sondage sont absents. Vous devrez choisir manuellement des facteurs pour une ou plusieurs questions.",
    "survey-template.dialog.warning": "Ces modèles permettent de créer une nouvelle enquête.",
    "survey-template.preview.empty-state": "Sélectionnez un sondage pour obtenir une prévisualisation de la liste des questions incluses",
    "survey-template.preview.loading": "Chargement des questions...",
    "survey-template.preview.no-content": "Aucun contenu",
    "survey-template.preview.title": "Prévisualisation de « {{name}} »",
    "survey.ai-summary.ask-to-interpret-results": "Demander à l’IA d’interpréter les résultats d’une enquête ?",
    "survey.ai-summary.fetch-error": "Erreur lors du chargement du résumé de l'IA. Veuillez réessayer.",
    "survey.ai-summary.footer-actions.regenerate": "Régénérer",
    "survey.ai-summary.footer-actions.regenerate-loading": "Régénérant...",
    "survey.ai-summary.generate-error": "Erreur lors de la génération du résumé de l'IA. Veuillez réessayer.",
    "survey.ai-summary.generate-success": "Résumé de l'IA généré avec succès",
    "survey.ai-summary.generating": "L'IA analyse les résultats de l'enquête. Cela peut prendre un certain temps…",
    "survey.ai-summary.generating-summary": "Génération d'un résumé des résultats de l'enquête",
    "survey.ai-summary.not-performed-with-filters": "L'analyse par IA n'a pas été effectuée à l'aide des filtres appliqués.",
    "survey.aiSummary.noAreasToWatch": "Aucune zone à surveiller n’a pu être déterminée à partir des données traitées.",
    "survey.aiSummary.noNegativeSentiment": "Aucun domaine d’opportunité n’a pu être déterminé à partir des données traitées.",
    "survey.aiSummary.noParticipationRate": "Aucun taux de participation n’a pu être déterminé à partir des données traitées.",
    "survey.aiSummary.noPositiveSentiment": "Aucun résultat positif n’est ressorti des données traitées.",
    "survey.aiSummary.noRecommendations": "Aucune recommandation à partir des données traitées.",
    "survey.analyze": "Analyser",
    "survey.approveMigration": "Approuver la migration",
    "survey.audience.missing.applicable.questions.intro": "Chaque question de cette enquête s'adresse à un groupe spécifique, et les collaborateurs invités ci-dessous ne répondent aux critères d'aucune d'entre elles :",
    "survey.audience.missing.applicable.questions.outro": "Modifiez le public ou les critères de ciblage de l'enquête avant de l'enregistrer.",
    "survey.automatic-reminder.validation.email-content": "Veuillez saisir un contenu d'e-mail pour toutes les langues",
    "survey.automatic-reminder.validation.email-subject": "Veuillez saisir un objet de courriel pour toutes les langues",
    "survey.automatic-reminder.validation.reminder-frequency": "Veuillez saisir une fréquence de rappel",
    "survey.automatic-reminder.validation.reminder-time": "Veuillez sélectionner une heure de rappel",
    "survey.build.dialog.email-recipients": "",
    "survey.build.dialog.email-to-employees_one": "",
    "survey.build.dialog.email-to-employees_other": "",
    "survey.build.dialog.once-confirmed-schedule": "",
    "survey.build.dialog.sms-no-phone_one": "",
    "survey.build.dialog.sms-no-phone_other": "",
    "survey.build.dialog.sms-opted-out_one": "",
    "survey.build.dialog.sms-opted-out_other": "",
    "survey.build.dialog.sms-recipients": "",
    "survey.build.dialog.sms-to-employees_one": "",
    "survey.build.dialog.sms-to-employees_other": "",
    "survey.build.new.title": "Enregistrer et programmer?",
    "survey.build.questions.information.about.benchmarks.text": "Les références WorkTango vous permettent de comparer les résultats de vos questionnaires à ceux d'entreprises similaires à la vôtre. Les questions de la bibliothèque accompagnées d'une icône verte sont incluses par défaut dans le programme d'évaluation des performances de WorkTango. Si vous souhaitez comparer les résultats de l'une de vos questions personnalisées à la référence de WorkTango, veuillez collaborer avec l'équipe Réussite client de WorkTango afin de trouver une question appropriée dans la bibliothèque WorkTango en guise de référence.",
    "survey.build.questions.information.about.benchmarks.title": "Renseignements sur les références",
    "survey.build.schedule.invitation-date.1-week-after": "L'invitation expire après 1 semaine",
    "survey.build.schedule.invitation-date.2-week-after": "L'invitation expire après 2 semaines",
    "survey.build.schedule.invitation-date.custom-number-of-days": "Nombre de jours personnalisé",
    "survey.build.schedule.invitation-date.custom-number-of-days.label": "Jours",
    "survey.build.schedule.invitation-date.label": "L'invitation est valable jusqu'à",
    "survey.build.schedule.invitation-date.same-as-survey": "Identique à l'enquête",
    "survey.build.schedule.invitation-date.tooltip": "Les invitations individuelles peuvent être configurées pour expirer après avoir été envoyées. Si vous activez ou désactivez cette fonction, seules les invitations futures seront concernées.",
    "survey.build.update.title": "Résumé de la mise à jour du sondage",
    "survey.button.cancel": "Annuler",
    "survey.button.edit": "Modifier l'enquête",
    "survey.button.hideReminders": "Masquer les rappels",
    "survey.button.remind": "Envoyer un rappel",
    "survey.button.view-reminders": "Rappels d’affichage",
    "survey.button.viewReminders": "Afficher les rappels",
    "survey.button.viewReports": "Afficher les rapports",
    "survey.button.viewReports.noInProgressPermission": "",
    "survey.cancel": "Annuler l'enquête",
    "survey.choose-from-template": "Choisir à partir d'un modèle...",
    "survey.clone": "Cloner l'enquête",
    "survey.convert-continuous": "Convertir en enquête continue",
    "survey.convert.dialog.action-text-1": "Cette action ne peut être annulée.",
    "survey.convert.dialog.action-text-2": "Êtes-vous sûr de vouloir procéder à cette modification ?",
    "survey.convert.dialog.desc-1": "Cette action modifiera le style d'enquête de \"Standard\" à \"Continu\", comme décrit ci-dessous. Cela signifie que",
    "survey.convert.dialog.desc-2": "L'enquête n'expire pas et les invitations sont automatisées",
    "survey.convert.dialog.desc-3": "Les réponses soumises restent disponibles et deviennent communicables en fonction de la date d'invitation",
    "survey.convert.dialog.desc-4": "Toutes les invitations existantes restent actives",
    "survey.convert.dialog.desc-5": "Vous devez configurer des déclencheurs d'automatisation après la conversion",
    "survey.convert.dialog.option-1": "Enquête continue basée sur la date de début",
    "survey.convert.dialog.option-2": "Enquête continue basée sur la date de sortie",
    "survey.convert.dialog.option-help-text-1": "Idéal pour les enquêtes d'intégration. Cette enquête n'expire pas, contrairement aux invitations, et les participants ne peuvent répondre qu'une seule fois.",
    "survey.convert.dialog.option-help-text-2": "Les rapports sont établis sur la base des délais sélectionnés.",
    "survey.convert.dialog.option-help-text-3": "Idéal pour les enquêtes de sortie. Cette enquête n'expire pas, contrairement aux invitations, et les participants ne peuvent répondre qu'une seule fois.",
    "survey.convert.dialog.option-help-text-4": "Les rapports sont établis sur la base des délais sélectionnés.",
    "survey.convert.dialog.option-title": "Veuillez choisir un nouveau style d'enquête :",
    "survey.convert.dialog.submit-button": "Oui, Début de la conversion",
    "survey.convert.dialog.success-message": "L'enquête a été convertie avec succès.",
    "survey.convert.dialog.title": "Conversion d'une enquête standard en enquête continue",
    "survey.create-new-survey": "Créer un nouveau sondage",
    "survey.custom-survey": "Sondage personnalisé",
    "survey.delete": "Supprimer",
    "survey.delete2": "Supprimer l'enquête",
    "survey.descPlaceholder": "Saisissez la description de la question ici",
    "survey.duplicate": "Dupliquer",
    "survey.edit": "Modifier",
    "survey.edit2": "Modifier l'enquête",
    "survey.emails.off": "Ce sondage est configuré pour ne PAS envoyer d'invitations et de rappels par courriel.",
    "survey.emptyEmailContent": "Veuillez saisir le contenu du courriel pour toutes les langues",
    "survey.emptyEmailSubject": "Veuillez saisir le sujet du courriel pour toutes les langues",
    "survey.emptyExpiryTime": "Veuillez sélectionner l'heure d'expiration",
    "survey.emptySendTime": "Veuillez sélectionner l'heure d'envoi",
    "survey.emptyTimezone": "Veuillez sélectionner le fuseau horaire",
    "survey.error.manageNotAllowed": "",
    "survey.filterByCategory": "Facteur",
    "survey.list.no.active.triggers": "Aucun déclencheur actif n'est configuré. \nPour que l'automatisation fonctionne, il faut au moins un déclencheur actif.",
    "survey.list.trigger.type.disabled": "L'automatisation est désactivée. Le système n'ajoutera pas automatiquement de nouveaux candidats à cette enquête.",
    "survey.messaging.error.disableInProgress": "",
    "survey.messaging.error.languageNotConfigured ": "",
    "survey.messaging.error.saveFailed": "",
    "survey.messaging.error.smsAttributeNotPhone": "",
    "survey.messaging.error.smsAttributeRequired": "",
    "survey.messaging.error.smsAttributeWrongCompany": "",
    "survey.messaging.error.textRequired": "",
    "survey.messaging.error.variationRequired": "",
    "survey.migrate.description.first": "Cette action prend votre fichier de données de sondage et remplit ce sondage avec ces réponses.",
    "survey.migrate.description.second": "Veillez à recréer au préalable toutes les questions du sondage originel, et vous pouvez utiliser le fichier modèle de migration de sondage pour un formatage en bonne et due forme.",
    "survey.migrate.error.commentsWithoutAnswer": "Cette question est assortie d'un commentaire, mais n'a pas de réponse",
    "survey.migrate.error.duplicatedQuestions": "Questions en double",
    "survey.migrate.error.employeesWithWrongCompletedSurvey": "L'employé n'a pas effectué le sondage, mais les données de réponse figurent dans le fichier de sondage",
    "survey.migrate.error.invalidEmployeeIds": "Ces identifiants d'employé n'existent pas",
    "survey.migrate.error.invalidRatingAnswers": "Questions à échelle avec réponse invalide",
    "survey.migrate.error.missingInvitationTimes": "Salariés n'ayant pas de créneau d'invitation",
    "survey.migrate.error.missingMultipleChoiceOptions": "Les options n'existent pas dans le sondage (question à choix multiples)",
    "survey.migrate.error.missingSubmissionDates": "Salariés ayant répondu à une question mais pour lesquels aucune date d'envoi n'est indiquée",
    "survey.migrate.error.noCompletedSurveyColumn": "Colonne « Sondage terminé » absente",
    "survey.migrate.error.noEmployeeIdColumn": "Colonne « Identifiant de l'employé » absente",
    "survey.migrate.error.noInvitationTimeColumn": "Colonne \"Heure d'invitation\" manquante",
    "survey.migrate.error.noSubmissionDateColumn": "La colonne « Date de soumission » manque",
    "survey.migrate.error.nonExistingQuestions": "Ces questions n'existent pas dans ce sondage",
    "survey.migrate.error.rejoinedEmployeeIds": "L'employé a rejoint la même enquête",
    "survey.migrate.error.unsupportedCompletedSurvey": "Format incorrect du titre « Sondage terminé »",
    "survey.migrate.error.unsupportedEmployeeId": "Format incorrect du titre « Identifiant de l'employé »",
    "survey.migrate.error.unsupportedTitles": "Titres inconnus comparés aux caractéristiques de l'entreprise",
    "survey.migrate.message.scheduled": "Le système va procéder à la migration des réponses au sondage. Vous pouvez fermer cette fenêtre et suivre la progression dans l'onglet « Migration » pour connaître les progrès et les erreurs. Une fois la migration réussie, vous pourrez retrouver le sondage dans l'onglet « Terminé ».",
    "survey.migrate.select-file": "Sélectionner un fichier (.xlsx ou .xls)",
    "survey.migrate.template": "Générer un modèle",
    "survey.nochanges": "Veuillez noter que vous ne pouvez pas modifier les questions une fois le sondage envoyé.",
    "survey.open-survey.attribute-value-not-disclosed": "",
    "survey.open-survey.error-benchmarks-not-available": "",
    "survey.open-survey.error-compare-not-available": "",
    "survey.open-survey.error-reported-with-other-surveys": "",
    "survey.optionPlaceholder": "Saisissez le titre de l'option ici",
    "survey.preview": "Aperçu de l'enquête",
    "survey.recipients.changed": "Vous avez apporté des modifications non enregistrées à la liste des participants. Veillez à les enregistrer avant de quitter cet écran.",
    "survey.recipients.save.button": "Enregistrer les modifications apportées aux participants",
    "survey.reminder": "Personnalisez votre message de rappel",
    "survey.reminder.button.create": "Planifier un nouveau rappel",
    "survey.reminder.button.edit": "Enregistrer les modifications",
    "survey.reminder.button.view": "Planifier un nouveau rappel",
    "survey.reminder.confirm.description.delete": "Voulez-vous vraiment supprimer définitivement ce rappel et son contenu? Vous ne pouvez pas annuler cette opération.",
    "survey.reminder.confirm.title.delete": "Supprimer un rappel planifié",
    "survey.reminder.create.success": "Le rappel a bien été créé.",
    "survey.reminder.delete.success": "Le rappel a bien été supprimé.",
    "survey.reminder.scheduled-date-time": "Date et heure planifiés",
    "survey.reminder.scheduled-date-time.error": "L’heure doit être entre {{minDateTime}} et {{maxDateTime}} dans le fuseau horaire {{timezone}} ({{gmt}}).",
    "survey.reminder.scheduled-date-time.error.min-only": "",
    "survey.reminder.status.ERROR": "Erreur",
    "survey.reminder.status.PROCESSING": "Traitement",
    "survey.reminder.status.SCHEDULED": "Planifié",
    "survey.reminder.status.SENDING": "En cours d’envoi",
    "survey.reminder.status.SENT": "Envoyé",
    "survey.reminder.timezone-desc": "Les heures sont dans le fuseau horaire {{timezone}} ({{gmt}}).",
    "survey.reminder.title.create": "Planifier un nouveau rappel",
    "survey.reminder.title.edit": "Modifier le rappel",
    "survey.reminder.title.view": "Afficher le rappel",
    "survey.reminder.update.success": "Le rappel a bien été mis à jour.",
    "survey.resend.employee.emails": "Retourner l’invitation au sondage dans les courriels suivants?",
    "survey.responseVolume": "",
    "survey.responserates": "Taux de réponse",
    "survey.responses": "Réponses",
    "survey.results": "Résultats",
    "survey.schedule.email.choose-language-to-edit": "Choisir la langue à modifier",
    "survey.schedule.email.from-email": "Adresse électronique de l'expéditeur",
    "survey.schedule.email.subject": "Objet du courriel",
    "survey.schedule.frequency.custom": "Nombre de jours personnalisé",
    "survey.schedule.frequency.custom-label": "Jours",
    "survey.schedule.frequency.errors.out-of-range": "Doit être un nombre compris entre 1 et 99",
    "survey.schedule.frequency.errors.required": "Nombre de jours requis",
    "survey.schedule.frequency.every-x-days": "Tous les {{count}} jours",
    "survey.schedule.frequency.info": "Les rappels seront automatiquement envoyés en fonction de la date à laquelle le participant a été invité. Ils s'arrêteront lorsque le participant aura répondu à l'enquête ou que son accès à l'enquête aura expiré.",
    "survey.schedule.from.max.length": "Longueur maximale de 255 caractères",
    "survey.schedule.messaging.channel.email": "",
    "survey.schedule.messaging.channel.slack": "",
    "survey.schedule.messaging.channel.sms": "",
    "survey.schedule.messaging.channel.teams": "",
    "survey.schedule.messaging.content-label.slack": "",
    "survey.schedule.messaging.content-label.sms": "",
    "survey.schedule.messaging.content-placeholder": "",
    "survey.schedule.messaging.enable-label.slack": "",
    "survey.schedule.messaging.enable-label.sms": "",
    "survey.schedule.messaging.enable-label.teams": "",
    "survey.schedule.messaging.invitation-card-title": "",
    "survey.schedule.messaging.not-connected": "",
    "survey.schedule.messaging.not-enabled": "",
    "survey.schedule.messaging.sms.attribute-helper": "",
    "survey.schedule.messaging.sms.attribute-label": "",
    "survey.schedule.messaging.sms.attribute-placeholder": "",
    "survey.schedule.messaging.sms.tcpa-warning": "",
    "survey.schedule.messaging.tabs-aria-label": "",
    "survey.schedule.messaging.variation": "",
    "survey.schedule.remarks.survey-expiry": "Les participants qui n'ont pas soumis de réponses resteront dans l'enquête, mais ne pourront pas y participer",
    "survey.schedule.reminder-content.label": "Contenu de l'e-mail de rappel",
    "survey.schedule.reminder-frequency.label": "Fréquence des rappels",
    "survey.schedule.reminder-subject.label": "Objet du courriel de rappel",
    "survey.schedule.reminder-time.label": "Heure à laquelle le rappel doit être envoyé",
    "survey.schedule.skip-weekends.label": "",
    "survey.schedule.switch.survey_reminders": "Activer les rappels automatiques",
    "survey.schedule.switch.survey_reminders_callout": "En plus d'être automatiques, les rappels programmés peuvent être programmés avec un libellé personnalisé à partir de la page Enquêtes pour les enquêtes dont le statut est \"programmé\" ou \"en cours\".",
    "survey.schedule.title": "Programme de sondage",
    "survey.schedule.title.continuous-survey": "Paramètres de l'enquête en continu",
    "survey.schedule.title.invitation": "Invitation à l'enquête",
    "survey.schedule.title.survey-expiry": "Date d'expiration du lien de l'enquête",
    "survey.schedule.title.survey_reminders": "Rappels de l'enquête",
    "survey.selectMore": "Sélectionner plus de sondages",
    "survey.selection": "Sélectionnez les sondages à ajouter à l’affichage actuel",
    "survey.send.test.success": "Un deuxième courriel d’essai vous a été envoyé. Veuillez vérifier votre boîte de réception!",
    "survey.sending.estimate": "Un courriel sera envoyé à {{total}} employés au cours des {{minutes}} prochaines minutes",
    "survey.set.survey.completed": "Déplacer l'enquête vers Terminé",
    "survey.set.survey.in.progress": "Déplacer l'enquête en cours",
    "survey.share.bypass-link": "Lien direct du sondage pour contourner le code d’accès",
    "survey.share.bypass-qr-code": "Code QR direct du sondage pour contourner le code d’accès",
    "survey.share.copied": "Copié dans votre presse-papiers.",
    "survey.share.copy-bypass-link": "Copier le lien direct",
    "survey.share.copy-failed": "Nous n’avons pas pu copier cela. Sélectionnez-le sur la page et copiez-le plutôt.",
    "survey.share.copy-link": "Copier le lien",
    "survey.share.copy-passcode": "Copier le code d’accès",
    "survey.share.device-count-one-device_other": "{{count}} réponses d’un appareil",
    "survey.share.device-count_one": "{{count}} réponse d’un appareil sur {{deviceCount}}",
    "survey.share.device-count_other": "{{count}} réponses de {{deviceCount}} appareils",
    "survey.share.download-bypass-qr-code": "Télécharger le code QR direct",
    "survey.share.download-qr-code": "Télécharger le code QR",
    "survey.share.link": "Lien du sondage",
    "survey.share.passcode": "Code d’accès",
    "survey.share.passcode-failed": "Nous n’avons pas pu mettre à jour le code d’accès. Réessayez.",
    "survey.share.passcode-hint": "Choisissez un mot facile à prononcer et évitez les caractères faciles à confondre, comme les zéros et la lettre O majuscule.",
    "survey.share.passcode-invalid": "Un code d’accès peut contenir jusqu’à 32 lettres et chiffres, et ne peut pas contenir les caractères I, L, O, 0 ou 1.",
    "survey.share.passcode-saved": "Code d’accès mis à jour.",
    "survey.share.passcode-toggle": "Protéger le lien avec un code d’accès",
    "survey.share.qr-code": "Code QR du sondage",
    "survey.share.title": "Paramètres du sondage",
    "survey.stage.1": "Créé et programmé",
    "survey.stage.2": "Terminé et en cours",
    "survey.stage.all": "Tous les sondages",
    "survey.status": "Statut",
    "survey.status0": "Créé",
    "survey.status1": "Programmé(e)",
    "survey.status2": "En cours",
    "survey.status3": "Terminé(e)",
    "survey.status4": "En cours d’envoi",
    "survey.status5": "Traitement",
    "survey.status6": "Migré",
    "survey.status7": "Échec de la migration",
    "survey.stop": "Annuler",
    "survey.tab.migrating": "Migration",
    "survey.title.report-for": "Rapport pour",
    "survey.titlePlaceholder": "Saisissez le titre de la question ici",
    "survey.trend": "Tendance",
    "survey.type.disabled": "Désactivé",
    "survey.view": "Voir",
    "surveyEdit.addLogic": "Ajouter une logique",
    "surveyEdit.admin.unlockButton": "Modifier une question",
    "surveyEdit.admin.unlockDesc": "Vous êtes sur le point de modifier une question qui a déjà des réponses dans ce sondage ou dans un autre sondage.\n\nModifier une telle question peut annuler toutes les réponses précédentes. Modifier cette question affectera aussi la question dans les autres sondages dans lesquels elle a été posée.\n\nVoulez-vous vraiment modifier cette question?",
    "surveyEdit.admin.unlockTitle": "Soyez prudent!",
    "surveyEdit.conditional": "Conditionnelle",
    "surveyEdit.conditional.attribute": "Cette question est affichée de façon conditionnelle aux répondants correspondant aux attributs suivants : {{attributes}}",
    "surveyEdit.conditional.logic": "Cette question est affichée de façon conditionnelle en fonction de certaines conditions logiques",
    "surveyEdit.conditional.logicAndAttribute": "Cette question est affichée de façon conditionnelle en fonction de certaines conditions logiques et les répondants correspondant aux attributs suivants : {{attributes}}",
    "surveyEdit.deleteLogic": "Supprimer une logique",
    "surveyEdit.deleteLogicConfirm": "Voulez-vous vraiment supprimer ce bloc de logique?",
    "surveyEdit.logic.addCondition": "Ajouter une condition",
    "surveyEdit.logic.affectedQuestion": "Question à afficher",
    "surveyEdit.logic.broken": "Ce bloc logique fait référence à une question qui n'existe plus dans ce questionnaire. Contactez le service d'assistance si vous avez besoin d'aide, ou supprimez-le ci-dessous.",
    "surveyEdit.logic.cancel": "Annuler",
    "surveyEdit.logic.conditionDesc": "Autrement, masquer la question {{order}}",
    "surveyEdit.logic.conditionDescMsg": "Autrement, masquez « {{message}} »",
    "surveyEdit.logic.deleteCondition": "Supprimer cette condition",
    "surveyEdit.logic.disableAdd": "Vous devez ajouter d’autres conditions logiques? Utilisez les blocs de logique existants ci-dessus pour ajouter d’autres conditions",
    "surveyEdit.logic.display": "Afficher",
    "surveyEdit.logic.if": "Si",
    "surveyEdit.logic.incomplete": "Veuillez terminer ou supprimer les conditions incomplètes ci-dessus",
    "surveyEdit.logic.or": "ou",
    "surveyEdit.logic.question": "la question",
    "surveyEdit.logic.response": "la réponse",
    "surveyEdit.logic.save": "Enregistrer la logique",
    "surveyEdit.logic.selectAnswer": "Sélectionner une réponse",
    "surveyEdit.logic.selectQuestion": "Sélectionner une question",
    "surveyEdit.logic.selectTitle": "Pour la question",
    "surveyEdit.logicEditor": "Éditeur de logique",
    "surveyEdit.logicEditorDesc": "Utilisez l’éditeur de logique pour décider quelles questions devraient s’afficher à vos répondants en fonction des réponses précédentes. Les questions sont ensuite masquées par défaut pour tous les répondants jusqu’à ce qu’au moins une de leurs conditions soit remplie.",
    "surveyEdit.logicEditorEmpty": "Vous n’avez aucune question avec logique",
    "surveyEdit.message.placeholder": "Rédigez votre message ici...",
    "surveyEdit.preventDeleting.desc": "Une condition logique est associée à cette question. Vous devrez d’abord supprimer cette condition logique dans l’éditeur de logique avant de pouvoir supprimer cette question.",
    "surveyEdit.preventDeleting.title": "Cette question ne peut pas être supprimée",
    "surveyEdit.preventOrdering.desc": "Si vous changez votre réponse à cette question, vous devrez répondre à nouveau à toutes les questions suivantes, car certaines questions peuvent être visibles ou masquées en fonction de votre nouvelle réponse.",
    "surveyEdit.preventOrdering.goTo": "Aller à l’éditeur de logique",
    "surveyEdit.preventOrdering.title": "Cette question ne peut pas être déplacée à cette position",
    "surveyEdit.question.selectType": "Choisissez votre type de question",
    "surveyEdit.questionEditor": "Éditeur de question",
    "surveyEdit.updateLogic": "Modifier une logique",
    "surveyEdit.yesNoQuestion.no": "Non",
    "surveyEdit.yesNoQuestion.yes": "Oui",
    "surveyMigration.button": "Valider la migration du sondage",
    "surveyMigration.closeButton": "Fermer",
    "surveyMigration.dialog.title": "Valider le fichier de migration du sondage",
    "surveyMigration.error.commentsWithoutAnswer": "Commentaires sans réponse :",
    "surveyMigration.error.duplicatedQuestions": "Questions doublées :",
    "surveyMigration.error.missingMultipleChoiceOptions.description": "Si les options sont valides, vérifiez si elles utilisent le bon séparateur/délimiteur. Elles doivent être séparées par <strong>|||</strong>.",
    "surveyMigration.error.missingMultipleChoiceOptions.label": "Options de choix multiple manquantes :",
    "surveyMigration.error.missingMultipleChoiceOptions.options": "Options manquantes",
    "surveyMigration.error.missingRequiredFile": "Le fichier ne contient pas le champ obligatoire {{field}}.",
    "surveyMigration.error.misspelledRequiredField": "Le fichier a <strong>{{misspelledField}}</strong> au lieu de <strong>{{requiredField}}</strong>.",
    "surveyMigration.error.nonExistingQuestions": "Ces questions n’existent pas dans le sondage :",
    "surveyMigration.error.requiredFields.label": "Erreurs de champ obligatoire :",
    "surveyMigration.error.supportedFile.description": "Nous ne prenons en charge que les fichiers « .xlsx » en ce moment.",
    "surveyMigration.error.supportedFile.label": "Le fichier n’est pas pris en charge :",
    "surveyMigration.error.unsupportedTitles.description": "Nous ne prenons en charge que <strong>Identifiant de l’employé</strong>, <strong>Sondage répondu</strong> et les titres qui commencent par <strong>réponse:::</strong> ou <strong>commentaire:::</strong>.",
    "surveyMigration.error.unsupportedTitles.label": "Titres/en-têtes non pris en charge :",
    "surveyMigration.successAlert.description": "Gardez à l’esprit que le fichier peut encore contenir des erreurs non détectées.",
    "surveyMigration.successAlert.title": "Le fichier a réussi nos tests!",
    "surveyMigration.upload.label": "Sélectionnez votre fichier (nous ne prenons en charge que .xlsx)",
    "surveyMigration.validatingFile": "Validation du fichier :",
    "surveyTemplates": "Modèles de sondage",
    "surveyTemplates.description": "Ces modèles sont accessibles à toutes les entreprises et partagées par celles-ci. Veuillez garder les nouveaux modèles inactifs jusqu'à ce qu'ils soient prêts à être partagés universellement, et faites preuve de prudence lorsque vous mettez à jour des modèles actifs, car ils affectent tous les clients.",
    "surveyType": "Type de sondage",
    "surveyType.enName": "Nom du type de sondage (En)",
    "surveyType.exit": "Sortie",
    "surveyType.factor.used": "Ce facteur ne peut pas être supprimé car il a été utilisé par les questions de sondage",
    "surveyType.frName": "Nom du type de sondage (Fr)",
    "surveyType.name": "Nom du type de sondage",
    "surveyType.onboarding": "Intégration",
    "surveyTypes": "Types de sondage",
    "surveyTypes.key": "Clé",
    "surveyTypes.threshold": "Seuil d'anonymat",
    "surveyTypesAndFactors": "Types et facteurs de sondage",
    "surveys": "Enquêtes",
    "surveys.addMoreSurveys": "Ajouter Plus de Sondages",
    "surveys.cloneDialog.error": "Un sondage portant ce nom existe déjà. Veuillez saisir un nom unique.",
    "surveys.create.employees": "Liste des employés",
    "surveys.create.filter": "Rechercher la liste des employés et des destinataires",
    "sv-se": "Suédois",
    "swal.confirm.delete": "Êtes-vous sûr de vouloir supprimer ceci?",
    "swal.error.notfound": "Malheureusement, nous ne reconnaissons pas cette combinaison nom d'utilisateur/mot de passe. Veuillez essayer à nouveau.",
    "swal.info.launched": "Votre sondage a été programmé",
    "swal.message.surveySaved": "Sauvegarde réussie. Youppi!",
    "swal.reminders.already.scheduled": "Les rappels pour ce sondage ont déjà été programmés et seront bientôt envoyés.",
    "swal.reminders.send": "Un rappel sera envoyé à tous les employés qui n’ont pas encore rempli le sondage. Cela prendra environ {{timeToSendMin}} minutes.",
    "swal.saved": "Enregistré!",
    "swal.survey.emails.no.language.error": "Vous devez activer au moins une langue pour votre courriel",
    "switch.current": "Entreprise actuelle",
    "system.field.deleted": "[Attribut supprimé]",
    "system.field.disabled": "Désactivé",
    "system.field.email": "Courriel",
    "system.field.enabled": "Activé",
    "system.field.firstname": "Prénom",
    "system.field.language": "Langue",
    "system.field.lastname": "Nom",
    "system.field.manageremail": "Courriel du dirigeant",
    "system.field.permissions": "Autorisations",
    "system.field.reportingMax": "Maximum de 10 attributs de rapport autorisés",
    "system.field.startdate": "Date d’entrée",
    "table.nodata": "Pas de données disponibles",
    "table.stop": "Arrêter",
    "templates.clone": "Cloner le modèle",
    "templates.cloneDialog.description": "Veuillez choisir un nom unique pour le nouveau modèle.",
    "templates.cloneDialog.error": "Un modèle portant ce nom existe déjà. Veuillez saisir un nom unique.",
    "templates.cloneDialog.title": "Cloner le modèle « {{name}} »?",
    "templates.create": "Créer un nouveau modèle",
    "templates.deactivate": "Désactiver le modèle",
    "templates.delete": "Supprimer le modèle",
    "templates.deleteDialog.button.cancel": "Annuler",
    "templates.deleteDialog.button.delete": "Oui, supprimer",
    "templates.deleteDialog.description": "La suppression d'un modèle le retire définitivement de la plateforme et aucun client ne pourra le voir ou l'utiliser à l'avenir.",
    "templates.deleteDialog.description2": "Cette action est irréversible.",
    "templates.deleteDialog.description3": "Voulez-vous vraiment supprimer ce modèle?",
    "templates.deleteDialog.title": "Supprimer le modèle « {{name}} »?",
    "templates.edit": "Modifier le modèle",
    "templates.lastUpdated": "Dernière mise à jour",
    "templates.name": "Nom du modèle",
    "templates.status": "Statut du modèle",
    "templates.survey-type.no.compatible": "Aucun type de sondage configuré n'est compatible avec ce modèle.",
    "templates.survey-type.no.compatible-plural": "Aucun type de sondage configuré n'est compatible avec les modèles disponibles.",
    "templates.survey-type.no.permissions": "Vous n'avez pas l'autorisation de créer un sondage de ce type.",
    "templates.surveyStyles": "Styles de sondage",
    "templates.type": "Type de sondage",
    "templates.zeroState": "Aucun modèle n'est configuré.",
    "term.accept": "Vous acceptez les",
    "term.title": "Conditions d’utilisation",
    "terms.of.use": "Conditions d’utilisation",
    "th-th": "Thaïlande",
    "thanks.for.rating": "Merci d'avoir noté!",
    "themes.button.generate": "Identifier les thèmes...",
    "themes.button.regenerate": "Re-générer les thèmes...",
    "themes.description.generate": "Demander à l'IA d'organiser les réponses en thèmes ?",
    "themes.description.generate.loading": "L'IA génère des thèmes clés...",
    "themes.description.regenerate": "Demander à l'IA de refaire une analyse thématique ?",
    "themes.description.regenerate.loading": "L'IA réactualise des thèmes clés...",
    "themes.toast.error.generate": "Les thèmes n'ont pas pu être générés. Veuillez réessayer.",
    "themes.toast.error.regenerate": "Les thèmes n'ont pas pu être régénérés. Les thèmes précédents ont été conservés. Veuillez réessayer.",
    "themes.toast.success.generate": "Thèmes générés avec succès.",
    "themes.toast.success.regenerate": "Les thèmes ont été re-générés avec succès.",
    "tiho.test": "",
    "title.lockedOut": "Vôtre compte a été bloqué",
    "tooltip.new": "Nouveau",
    "tooltip.upload": "Téléverser",
    "top.attributes": "Cinq premiers attributs",
    "tr-tr": "Turc",
    "trend.annual": "Annuel",
    "trend.group": "Grouper par",
    "trend.month": "Mois",
    "trend.no.survey": "Aucun sondage correspondant",
    "trend.quarter": "Trimestre",
    "trend.search.factor": "Rechercher par facteur",
    "trend.search.question": "Rechercher par question",
    "trend.survey": "Sondage",
    "trending.heatmap.anonymizedAttributes": "Les attributs ci-dessous sont anonymisés et donc exclus de la carte de densité.",
    "trending.heatmap.uniqueAttributes": "Les attributs ci-dessous ont été exclus de la carte thermique puisqu’ils sont présents dans seulement l’un des deux sondages.",
    "trends.addSurvey": "Ajouter un sondage",
    "trends.button.change-timeframes": "Modifier les délais",
    "trends.button.select-surveys": "Sélectionner des sondages tendance",
    "trends.button.select-timeframes": "Délais de l'enquête continue sur les tendances",
    "trends.empty": "Comparez jusqu’à 10 sondages pour déterminer la tendance de vos facteurs et vos questions dans votre organisation.",
    "trends.errors.missing-date": "Vous devez saisir les dates de début et de fin pour les délais personnalisés",
    "trends.selectSurveyType": "Sélectionner un type de sondage",
    "trends.subtitle.time-frames": "Tendance entre {{count}} les délais sélectionnés entre {{count}} et {{count}}",
    "trends.suppressed.label": "",
    "trends.timeframes-dialog.add-timeframe": "Ajouter un délai",
    "trends.timeframes-dialog.submit-button": "Afficher les tendances pour ces périodes",
    "trends.timeframes-dialog.title": "Choisissez deux ou plusieurs périodes de temps pour établir une tendance",
    "trends.title": "Tendances",
    "trends.title.trends-for": "Tendances pour",
    "trends.view": "Afficher",
    "trigger.status.paused": "En pause",
    "triggers.type.exitDate": "Date de sortie",
    "triggers.type.startDate": "Date de début",
    "update.snapshots": "Mettre à jour les copies instantanées",
    "user": "Utilisateur",
    "user.activation.codeNotFound": "Code d'activation introuvable",
    "user.activation.description": "{{companyName}} vous invite à rejoindre la plateforme WorkTango par courriel: {{userEmail}}",
    "user.activation.loginOrGetInvited": "Si vous avez déjà activé votre compte, veuillez vous connecter ici. Si vous n'avez pas encore activé votre compte, veuillez contacter votre administrateur de compte pour recevoir une invitation.",
    "user.activation.success": "Votre compte a été activé avec succès!",
    "user.activation.title": "Activation",
    "user.invite.message": "vous avez reçu une invitation de %inviter% (%company%) pour utiliser WorkTango, une plateforme qui aide à donner la parole aux employés et offre des retours en temps réel pour notre organisation. Veuillez cliquer ci-dessous pour finaliser votre inscription.",
    "user.invite.subject": "Vous êtes invité à WorkTango",
    "user.login.email": "Courriel",
    "user.login.forgot": "Mot de passe oublié?",
    "user.login.privacy.notice": "Avis de confidentialité",
    "user.login.privacy.policy": "Politique de confidentialité",
    "user.login.terms.of.use": "Conditions d’utilisation",
    "user.not.found": "Utilisateur introuvable",
    "user.password.reset.email": "Cliquez ci-dessous pour réinitialiser votre mot de passe.",
    "user.password.reset.subject": "Réinitialiser le mot de passe",
    "user.remove.customAttributes": "Les attributs personnalisés précédemment sélectionnés seront supprimés, êtes-vous sûr?",
    "user.reset.header": "Réinitialiser un mot de passe",
    "user.reset.password": "Saisir un nouveau mot de passe",
    "user.reset.password.confirmation": "Confirmer le mot de passe",
    "user.reset.passwordMatch": "Les mots de passe ne correspondent pas",
    "users.addButton": "Ajouter des utilisateurs",
    "users.column.customPermission": "Permissions personnalisées",
    "users.column.customPermissionDesc": "Cet utilisateur a des permissions personnalisées qui ne s’appliquent qu’à lui.",
    "users.invite.email.addresses": "Adresses mail",
    "users.invite.email.csv": "Utilisez des valeurs séparées par des virgules (CSV) lors de la saisie manuelle des e-mails",
    "users.invite.invited.by": "Inviter par",
    "users.invite.loading.employees": "Chargement des employés...",
    "users.invite.name.from": "Nom à partir duquel l'e-mail d'invitation est envoyé",
    "users.invite.search.employees.and.emails": "Rechercher des employés ou saisir une adresse personnalisée",
    "users.mainHeader": "Utilisateurs et permissions",
    "users.role.checkbox.cannot.select.kw.default.role": "Si vous souhaitez personnaliser les autorisations de cette personne de manière plus granulaire, veuillez lui attribuer le rôle « SURVEY CUSTOM » dans la gestion des utilisateurs.",
    "users.role.selectDesc": "Attribuez un rôle existant à un ou des utilisateurs ci-dessus ou configurez des permissions personnalisées pour eux.",
    "users.role.selectLabel": "Sélectionner un rôle ou des permissions personnalisées",
    "users.role.selectTitle": "Rôle",
    "users.role.selectedNotice": "Vous trouverez ci-dessous les permissions pour {{name}}. Vous pouvez modifier ces permissions dans la section Rôles.",
    "users.role.selectedNoticeIntegrated": "Les autorisations pour {{name}} se trouvent ici-dessous. Vous pouvez modifier le rôle de l'utilisateur dans la zone Gestion des utilisateurs, ou vous pouvez lui attribuer un rôle « Personnalisé » pour débloquer les autorisations granulaires de Sondages et informations.",
    "users.rolePermissionType": "Permissions personnalisées",
    "users_one": "{{count}} utilisateur",
    "users_other": "{{count}} utilisateurs",
    "validating": "Validation...",
    "view.by": "Vu par",
    "view.communication.templates.for.suggestions": "Consultez nos modèles de communication pour des suggestions",
    "view.content": "Afficher le contenu",
    "welcome": "Vous avez été invité à la plateforme WorkTango!",
    "wizard.next": "Prochain",
    "wizard.previous": "Précédent",
    "worktango.admin.export": "Exportation brute",
    "worktango.powered": "Alimenté par WorkTango",
    "yes_no_banana": "Banane mûrissante",
    "yes_no_check_and_x": "Coche et X",
    "yes_no_faces": "Visages",
    "yes_no_glasses_of_water": "Verres d’eau",
    "yes_no_ice_box": "Cornet de crème glacée",
    "yes_no_lightbulb": "Ampoule",
    "yes_no_mood_weather": "Humeur du temps",
    "yes_no_pizza_box": "Boîte à pizza",
    "yes_no_red_rose": "Rose",
    "yes_no_snowman": "Bonhomme de neige",
    "yes_no_thumbs": "Pouces",
    "yes_no_toilet_paper": "Papier hygiénique",
    "zh-cn": "Chinois (simplifié)",
    "zh-tw": "Chinois (traditionnel)",
    "survey.language.ar-sa": "عربي",
    "survey.language.cs-cz": "Čeština",
    "survey.language.da-dk": "Dansk",
    "survey.language.de-de": "Deutsch",
    "survey.language.el-gr": "Ελληνικά",
    "survey.language.en-ca": "English (CA)",
    "survey.language.en-us": "English (US)",
    "survey.language.es-es": "Español",
    "survey.language.fi-fi": "Suomi",
    "survey.language.fr-ca": "Français (CA)",
    "survey.language.fr-fr": "Français (FR)",
    "survey.language.hi-in": "हिन्दी",
    "survey.language.hu-hu": "Magyar",
    "survey.language.id-id": "Indonesia",
    "survey.language.it-it": "Italiano",
    "survey.language.jp-jp": "日本語",
    "survey.language.ko-kr": "한국어",
    "survey.language.ms-my": "Bahasa Melayu",
    "survey.language.my-mm": "မြန်မာဘာသာ",
    "survey.language.nb-no": "Norsk Bokmål",
    "survey.language.nl-nl": "Nederlands",
    "survey.language.pl-pl": "Polski",
    "survey.language.pt-br": "Português (BR)",
    "survey.language.pt-pt": "Português (PT)",
    "survey.language.ru-ru": "Pусский",
    "survey.language.sq-al": "Shqip",
    "survey.language.sv-se": "Svenska",
    "survey.language.th-th": "แบบไทย",
    "survey.language.tr-tr": "Türkçe",
    "survey.language.zh-cn": "简化字",
    "survey.language.zh-tw": "繁體中文"
  }
}
